const translation = {
    common: {
        utilityMenuLandmark: 'User menu',
        back: 'Back',
        cancel: 'Cancel',
        expand: 'Expand',
        create: 'Create',
        save: 'Save',
        saveChanges: 'Save changes',
        apply: 'Apply',
        delete: 'Delete',
        edit: 'Edit',
        close: 'Close',
        clear: 'Clear',
        clearFilter: 'Clear filter',
        clearSearch: 'Clear search',
        select: 'Select',
        confirm: 'Confirm',
        approve: 'Approve',
        reject: 'Reject',
        more: 'More',
        less: 'Less',
        showMoreCount: 'Show all {{count}}',
        showLess: 'Show less',
        showTree: 'Show tree',
        hideTree: 'Hide tree',
        submit: 'Submit',
        reset: 'Reset',
        loading: 'Loading...',
        saving: 'Saving...',
        required: 'Required',
        maxValues: 'Max values',
        defaultValue: 'Default',
        creating: 'Creating...',
        deleting: 'Deleting...',
        submitting: 'Submitting...',
        name: 'Name',
        description: 'Description',
        actions: 'Actions',
        status: 'Status',
        type: '[[Type]]',
        search: 'Search...',
        enabled: 'Enabled',
        disabled: 'Disabled',
        active: 'Active',
        inactive: 'Inactive',
        static: 'Static',
        dynamic: 'Dynamic',
        testdata: 'Testdata',
        yes: 'Yes',
        no: 'No',
        none: 'None',
        all: 'All',
        noResults: 'No results found.',
        noData: 'No data available.',
        filterByResource: 'Filter by [[resource]]...',
        viewFailureDetails: 'View full failure details including stack trace',
        errorLoading: 'Error loading data. Please try again.',
        comingSoon: 'Coming soon...',
        pageNotFound: 'This page does not exist.',
        notFound: '{{entity}} not found.',
        didYouMean: 'Did you mean one of these?',
        backToDashboard: 'Back to Dashboard',
        showingRange: 'Showing {{start}} to {{end}} of {{total}} items',
        rowsPerPage: 'Rows per page:',
        pageOf: 'Page {{page}} of {{totalPages}}',
        firstPage: 'First page',
        previousPage: 'Previous page',
        nextPage: 'Next page',
        lastPage: 'Last page',
        allTypes: 'All [[types]]',
        allStatus: 'All status',
        allStates: 'All states',
        matchingFilter: 'matching filter',
        matchingFilters: 'matching filters',
        version: 'Version',
        createdAt: 'Created',
        updatedAt: 'Updated',
        lastUpdated: 'Last updated',
        id: 'ID',
        details: 'Details',
        overview: 'Overview',
        configuration: 'Configuration',
        permissions: 'Permissions',
        settings: 'Settings',
        noRoles: 'No [[roles]]',
        set: 'Set',
        view: 'View',
        switchToDarkMode: 'Switch to dark mode',
        switchToLightMode: 'Switch to light mode',
        logout: 'Logout',
        never: 'Never',
        justNow: 'just now',
        durationDaysAgo: '{{count}} day ago',
        durationDaysAgo_other: '{{count}} days ago',
        durationHoursAgo: '{{count}} hour ago',
        durationHoursAgo_other: '{{count}} hours ago',
        durationMinutesAgo: '{{count}} minute ago',
        durationMinutesAgo_other: '{{count}} minutes ago',
        durationSecondsAgo: '{{count}}s ago',
        durationMinutesShortAgo: '{{count}}m ago',
        durationHoursShortAgo: '{{count}}h ago',
        durationDaysFromNow: 'in {{count}} day',
        durationDaysFromNow_other: 'in {{count}} days',
        durationHoursFromNow: 'in {{count}} hour',
        durationHoursFromNow_other: 'in {{count}} hours',
        durationMinutesFromNow: 'in {{count}} minute',
        durationMinutesFromNow_other: 'in {{count}} minutes',
        inAMoment: 'in a moment',
        selectedCount: '{{count}} selected',
        unknown: 'Unknown',
        unknownError: 'Unknown error',
        errorTitle: 'Error',
        viewErrorLog: 'View [[error log]]',
        sessionExpired: 'Session expired',
        cancelledByUser: 'Cancelled by user',
        optional: 'Optional',
        noRolesAssigned: 'No [[roles]] assigned',
        primary: 'Primary',
        permanent: 'Permanent',
        resource: '[[Resource]]',
        entitlement: 'Entitlement',
        operation: 'Operation',
        validUntil: 'Valid until',
        value: 'Value',
        observed: 'Observed',
        validFrom: 'Valid from',
        from: 'From:',
        to: 'To:',
        add: 'Add',
        remove: 'Remove',
        unchanged: 'Unchanged',
        priorityValue: 'Priority: {{value}}',
        versionPrefix: 'v{{version}}',
        valueWithMs: '{{value}}ms',
        emDash: '\u2014',
        completedTask_one: '{{count}} completed task',
        completedTask_other: '{{count}} completed tasks',
        task_one: '{{count}} task',
        task_other: '{{count}} tasks',
        identity_one: '{{count}} [[identity]]',
        identity_other: '{{count}} [[identities]]',
        system_one: '{{count}} system',
        system_other: '{{count}} systems',
        byUser: 'by {{user}}',
        atPosition: '(position {{position}})',
        viewAllExecutions: 'View all {{count}} [[executions]] →',
        viewErrors: 'View errors',
        matched: 'Matched:',
        rfc7644: 'RFC 7644 (Standard)',
        salesforce: 'Salesforce',
        microsoft: 'Microsoft',
        iamCore: 'ID Pulse',
        swissAdmin: 'Swiss admin',
        percentValue: '{{value}}%',
        connectionLostReconnecting: 'Connection lost. Reconnecting in {{seconds}}s...',
        connectionLostMaxAttempts: 'Connection lost. Max reconnection attempts reached.',
        failedToConnectRetrying: 'Failed to connect. Retrying in {{seconds}}s...',
        failedToConnectLiveUpdates: 'Failed to connect to live updates.',
        retry: 'Retry',
        attributes: 'Attributes',
        attributeCount: '{{count}} attributes defined',
        attributeCount_one: '{{count}} attribute defined',
        attributeCount_other: '{{count}} attributes defined',
        noAttributes: 'No attributes defined.',
        addAttribute: 'Add attribute',
        editAttribute: 'Edit attribute',
        deleteAttribute: 'Delete attribute',
        attributeName: 'Attribute name',
        attributeValue: 'Attribute value',
        authority: 'Authority',
        confirmDeleteAttribute: 'Are you sure you want to delete this attribute?',
        attributeSaved: 'Attribute saved successfully.',
        attributeDeleted: 'Attribute deleted successfully.',
        addValue: 'Add',
        removeValue: 'Remove value',
        maxValuesReached: 'Maximum number of values reached',
        copyFailed: 'Failed to copy to clipboard.',
        next: 'Next',
    },
    typeScopeFilter: {
        all: 'All',
        global: 'Global',
    },
    accessibility: {
        skipToContent: 'Skip to main content',
    },
    dashboard: {
        title: 'Dashboard',
        subtitle: '[[Identity]] & access management system',
        sectionsNav: 'Main sections',
        myIam: 'My IAM',
        myIamDesc: '[[Request]] access and manage your [[approvals]]',
        iamAdmin: 'IAM admin',
        iamAdminDesc: 'Manage [[roles]], permissions, and system settings',
        connectors: 'Connectors',
        connectorsDesc: 'Manage inbound and outbound system connectors',
        identityManagement: '[[Identity Management]]',
        identityManagementDesc: 'Manage [[parties]], [[identities]], and their lifecycle',
        targetSystems: '[[Target Systems]] & [[resources]]',
        targetSystemsDesc: 'View [[target systems]], [[resources]], and entitlements',
        accessGovernance: '[[Access Governance]]',
        accessGovernanceDesc: 'Manage [[access profiles]], rules, and [[access requests]]',
        effectiveAccess: 'Effective access',
        effectiveAccessDesc: 'View effective access and compare [[identity]] access',
        accessProvisioning: 'Access provisioning',
        accessProvisioningDesc: 'Monitor [[provisioning tasks]] and access fulfillment',
        backgroundJobs: 'Background [[jobs]]',
        backgroundJobsDesc: 'Manage scheduled [[jobs]] and cluster',
        auditLog: '[[Audit Log]]',
        auditLogDesc: 'Review system activity and access history',
        reporting: 'Reporting & auditing',
        reportingDesc: 'SQL-first reporting and compliance reports',
        schema: 'Schema',
        schemaDesc: 'Define the data model — types, attributes, [[form layouts]], and relationships',
    },
    schema: {
        title: 'Schema',
        pageTitle: 'Schema',
        subtitle: 'Define and manage the data model for your IAM system',
        welcome: 'Welcome to schema',
        selectOption: 'Select an option from the menu to configure the data model.',
        typeValues: '[[Type Values]]',
        typeValuesDescription: 'Manage [[type values]] and translations',
        attributeDefinitions: '[[Attribute Definitions]]',
        attributeDefinitionsDescription: 'Manage custom [[attribute definitions]]',
        formLayouts: '[[Form Layouts]]',
        formLayoutsDescription: 'Configure form input field layouts',
        relationshipSchema: 'Relationship schema',
        relationshipSchemaDescription: 'Define allowed [[party]] relationship types',
        schemaPolicies: 'Schema policies',
        schemaPoliciesDescription: 'Define and govern domain rules',
        schemaViolations: 'Schema violations',
        schemaViolationsDescription: 'Detected schema-policy violations',
        valueLists: '[[Value Lists]]',
        valueListsDescription: 'Manage custom [[value lists]] for attributes',
    },
    connectorsHub: {
        pageTitle: 'Connectors',
        welcome: 'Welcome to connectors',
        selectOption: 'Select inbound or outbound to manage connectors.',
        inboundTitle: '[[Inbound Connectors]]',
        inboundDescription: 'Manage inbound data import connectors',
        outboundTitle: '[[Outbound Connectors]]',
        outboundDescription: 'Manage outbound system connectors for provisioning',
    },
    admin: {
        title: 'IAM administration',
        pageTitle: 'IAM admin',
        subtitle: 'Manage [[roles]], permissions, connectors, and system settings',
        welcome: 'Welcome to IAM admin',
        selectOption: 'Select an option from the menu to get started.',
        adminRoles: '[[Roles]]',
        adminRolesDescription: 'Manage [[roles]] and permissions',
        roleAssignments: '[[Role Assignments]]',
        roleAssignmentsDescription: 'Assign [[roles]] to users',
        connectors: '[[Outbound Connectors]]',
        connectorsDescription: 'Manage outbound system connectors',
        typeValues: '[[Type Values]]',
        typesDescription: 'Manage [[type values]] and translations',
        notificationLog: '[[Notification]] Log',
        notificationLogDescription: 'Monitor [[notification]] delivery status',
        attributeDefinitions: '[[Attribute Definitions]]',
        attributeDefinitionsDescription: 'Manage custom [[attribute definitions]]',
        relationshipSchema: 'Relationship schema',
        relationshipSchemaDescription: 'Define allowed [[party]] relationship types',
        errorLogs: '[[Error Log]]',
        errorLogsDescription: 'Errors across all modules',
        scriptExecuteLog: 'Script execute log',
        scriptExecuteLogDescription: 'DDL audit trail from sql.execute() calls',
        llmPrompts: 'LLM Prompts',
        llmPromptsDescription: 'Configure AI prompt templates',
        caches: 'Caches',
        cachesDescription: 'In-process caches — size, last load, TTL, manual reload',
        notificationTemplates: '[[Notification Templates]]',
        notificationTemplatesDescription: 'Customise [[notification]] email templates',
        testData: 'Test data',
        testDataDescription: 'Generate bulk test data',
        formLayouts: '[[Form Layouts]]',
        formLayoutsDescription: 'Configure form input field layouts',
        inboundConnectors: '[[Inbound Connectors]]',
        inboundConnectorsDescription: 'Manage inbound data import connectors',
        valueLists: '[[Value Lists]]',
        valueListsDescription: 'Manage custom [[value lists]] for attributes',
        requestInspector: '[[Request Inspector]]',
        requestInspectorDescription: 'Inspect HTTP traces and session timelines',
        rehireReview: 'Rehire review',
        rehireReviewDescription: 'Review pending rehires',
        serviceAccounts: '[[Service Accounts]]',
        serviceAccountsDescription: 'Manage non-human [[identities]] and API keys',
        sectionIdpulseAccess: 'idPulse Access',
        sectionActivity: 'Activity',
        sectionDiagnostics: 'Diagnostics',
        sectionConfigurationTooling: 'Configuration & Tooling',
    },
    testData: {
        pageTitle: 'Test Data Generator | Admin',
        title: 'Test data generator',
        subtitle: 'Generate bulk test data for development and testing',
        generateEntities: 'Generate entities',
        generateAttributeValues: 'Generate attribute values',
        generateErrorLogs: 'Generate [[error logs]]',
        generateErrorLogsDescription: 'Create sample error records across all modules',
        errorLogs: '[[Error Logs]]',
        generatorType: 'Generator [[type]]',
        parties: '[[Parties]]',
        identities: '[[Identities]]',
        count: 'Count',
        partyType: '[[Party]] [[type]]',
        identityType: '[[Identity]] [[type]]',
        entityType: 'Entity [[type]]',
        definition: '[[Attribute Definition]]',
        valueTemplate: 'Value template',
        valueTemplatePlaceholder: 'e.g. CC-ENG-{seq}',
        valueTemplateHelp: 'Use {seq} for sequence number, {random} for random string, {uuid} for UUID',
        generate: 'Generate',
        generating: 'Generating...',
        generatingProgress: 'Generating batch {{current}} of {{total}}...',
        success: 'Successfully created {{count}} {{type}}',
        error: 'Failed to generate test data',
        noDefinitions: 'No [[attribute definitions]] found for this entity type',
        selectDefinition: 'Select a definition',
        selectEntityType: 'Select entity type',
        attributeValues: 'attribute values',
    },
    attributeDefinitions: {
        pageTitle: '[[Attribute Definitions]] | Admin',
        title: '[[Attribute Definitions]]',
        subtitle: 'Manage custom [[attribute definitions]] across entity types',
        noPermission: 'You do not have permission to view [[attribute definitions]].',
        tabs: {
            parties: '[[Parties]]',
            identities: '[[Identities]]',
            resources: '[[Resources]]',
            functionGroups: '[[Function Groups]]',
            targetSystems: '[[Target Systems]]',
            connectors: 'Connectors',
            reports: 'Reports',
        },
        reorder: {
            failedToast: 'Failed to save new order. Order has been restored.',
            disabledTooltip: "Switch to 'All' to reorder",
            banner: 'Drag to reorder is available only in the All view.',
            announcement: 'Row moved from position {{from}} to position {{to}}',
        },
        dragToType: {
            successToast: '[[Type]] assignment updated',
            failedToast: 'Failed to update type assignment.',
        },
        nameDuplicate: 'A definition with this name already exists.',
        nameInvalid: 'Name must contain only letters, numbers, and underscores.',
        managedBy: 'Managed by {{authority}}',
        sqlEditor: 'SQL Value Source Editor',
        sqlTooManyColumns: 'Value source SQL must return exactly one column, but returned {{count}}: {{columns}}. Please use SELECT DISTINCT column_name FROM table.',
        sqlLabeledColumnCount: 'SQL_LABELED value source must return exactly two columns (code, label), but returned {{count}}: {{columns}}.',
        sqlHintOneColumn: 'Expected result: 1 column (code). Available parameters: ${lang} — current user locale (e.g. en, de)',
        sqlHintTwoColumns: 'Expected result: 2 columns (code, label). Available parameters: ${lang} — current user locale (e.g. en, de)',
        columns: {
            name: 'Name',
            displayName: 'Display name',
            valueType: 'Value [[type]]',
            authority: 'Authority',
            required: 'Required',
            active: 'Active',
            searchable: 'Searchable',
            filterable: 'Filterable',
            sortOrder: 'Sort order',
            typeScope: '[[Type]] Scope',
            valueSource: 'Value source',
        },
        flags: {
            enableSearchable: 'Enable free-text search',
            disableSearchable: 'Disable free-text search',
            enableFilterable: 'Show in filter panel',
            disableFilterable: 'Hide from filter panel',
            updateSuccess: 'Flag updated.',
            updateFailed: 'Failed to update flag.',
        },
        valueSourceTypes: {
            LIST: 'Static list',
            ENUM: '[[Type]] Table',
            SQL: 'SQL Query',
            SQL_LABELED: 'SQL Query (Code + Label)',
            CUSTOM_LIST: 'Custom list',
        },
        typeScopeAllTypes: 'All',
        typeScopeSpecificTypes: 'Specific',
        typeScopeAddType: 'Add type',
        typeScopeSelectTypes: 'Select types',
        typeScopeAll: 'All types',
        empty: 'No [[attribute definitions]] found.',
        loading: 'Loading [[attribute definitions]]...',
        count: '{{count}} definition',
        count_other: '{{count}} definitions',
        required: 'Required',
        optional: 'Optional',
        createDefinition: 'Create definition',
        editDefinition: 'Edit definition',
        deleteDefinition: 'Delete definition',
        deleteConfirmTitle: 'Delete [[attribute definition]]',
        deleteConfirmDescription: 'Are you sure you want to delete this [[attribute definition]]? This action cannot be undone.',
        deleteInUse: 'This [[attribute definition]] is in use and cannot be deleted.',
        createSuccess: '[[Attribute Definition]] created successfully.',
        updateSuccess: '[[Attribute Definition]] updated successfully.',
        deleteSuccess: '[[Attribute Definition]] deleted successfully.',
        removeFromType: 'Remove from this type',
        removeFromTypeSuccess: 'Removed from type successfully.',
        removeFromTypeImpact: 'Removing "{{name}}" from type {{type}} will affect {{count}} attribute values.',
        optimisticLockConflict: 'This definition was modified by another user. Please close and reopen to get the latest version.',
        deleteImpactMessage: 'Definition "{{name}}" has {{valueCount}} values across {{entityCount}} entities. All values will be permanently deleted.',
        deleteConfirmButton: 'Delete Definition and {{count}} Values',
        deleteConfirmButton_one: 'Delete Definition and 1 Value',
        sections: {
            basic: 'Basic',
            behavior: 'Behavior',
            validation: 'Validation',
        },
        fields: {
            name: 'Name',
            namePlaceholder: 'e.g. department',
            displayName: 'Display name',
            displayNameLocale: 'Display Name ({{locale}})',
            displayNamePlaceholder: 'e.g. Department',
            valueType: 'Value [[type]]',
            required: 'Required',
            unique: 'Unique',
            active: 'Active',
            sortOrder: 'Sort order',
            typeScope: '[[Type]] Scope',
        },
        translations: {
            title: 'Translations',
            saveFirstHint: 'Save the definition first, then edit to add translations.',
            label: 'Label',
            description: 'Description',
            saveFailed: 'Definition saved, but translations could not be saved. Please retry.',
        },
        validationRules: {
            title: 'Validation rules',
            titleWithCount: 'Validation Rules ({{count}})',
            noRulesForType: 'No validation rules available for this value type.',
            notApplicableWithAllowedValues: 'Not applicable when allowed values are defined.',
            minLength: 'Min length',
            minLengthDescription: 'Minimum number of characters required',
            minLengthPlaceholder: 'e.g. 2',
            maxLength: 'Max length',
            maxLengthDescription: 'Maximum number of characters allowed',
            maxLengthPlaceholder: 'e.g. 100',
            pattern: 'Pattern (Regular Expression)',
            patternDescription: 'Java-compatible regex. Examples: ^[A-Z]{2}$ (ISO country), ^CC-[A-Z]+-\\d{3}$ (cost center)',
            patternPlaceholder: 'e.g. ^[A-Z]{2}$',
            patternInvalid: 'Invalid regular expression: {{error}}',
            allowedValues: 'Allowed values',
            allowedValuesDescription: 'Restrict input to a fixed set of values.',
            allowedValuesPlaceholder: '[[Type]] a value and press Enter',
            allowedValuesDuplicate: 'Value already exists',
            listEditor: {
                title: 'List entries',
                codePlaceholder: 'e.g. AT',
                labelPlaceholder: 'e.g. Austria',
                codeHeader: 'Code',
                labelHeader: 'Label',
                addEntry: 'Add entry',
                removeEntry: 'Remove',
                errorBlankCode: 'Code is required',
                errorBlankLabel: 'Label is required',
                errorDuplicateCode: 'Duplicate code',
            },
            min: 'Minimum value',
            minDescription: 'Smallest acceptable value (inclusive)',
            minPlaceholder: 'e.g. 0',
            max: 'Maximum value',
            maxDescription: 'Largest acceptable value (inclusive)',
            maxPlaceholder: 'e.g. 100',
            minMaxError: 'Minimum must be less than or equal to maximum',
            minLengthMaxLengthError: 'Min length must be less than or equal to max length',
            mustBeAtLeastOne: 'Must be at least 1',
        },
        patternSuggest: {
            title: 'Suggest pattern',
            description: 'Enter sample values and let the system infer a regex pattern.',
            addSample: 'Add sample',
            samplePlaceholder: 'Enter a sample value',
            samplesLabel: 'Samples',
            samples: 'samples',
            addSampleHint: 'Add at least 2 sample values to infer a pattern',
            analyzing: 'Analyzing patterns...',
            inferredPattern: 'Inferred pattern',
            accept: 'Use this pattern',
            noSamples: 'Please enter at least one sample value',
            minSamples: 'Please add at least 2 sample values',
            duplicateSample: 'This sample already exists',
            error: 'Failed to infer pattern',
        },
        noPermissionToEdit: 'You do not have permission to edit this [[attribute definition]].',
        impact: {
            checkingImpact: 'Checking impact...',
            checkingProgress: 'Checking impact... {{checked}} / {{total}} values',
            warningTitle: 'Breaking changes detected',
            affectedCount: '{{valueCount}} values across {{entityCount}} entities will be affected.',
            affectedEntitiesOnly: '{{entityCount}} entities will need an initial value.',
            breakingChanges: 'Breaking changes:',
            affectedEntities: 'Affected entities',
            currentValue: 'Current value: {{value}}',
            andMore: 'and {{count}} more...',
            confirmationLabel: 'I understand that {{valueCount}} values across {{entityCount}} entities will be affected',
            confirmationLabelEntitiesOnly: 'I understand that {{entityCount}} entities will need an initial value',
            saveWithMigration: 'Save with Migration',
            suggestMigrationSql: 'Suggest Migration SQL',
            suggestingMigrationSql: 'Generating...',
        },
        migration: {
            migrate: 'Migrate',
            sqlEditorTitle: 'Migration SQL Editor',
            submitWithSql: 'Submit with Migration',
            sqlError: 'Migration SQL error: {{error}}',
            jobStarted: 'Definition update submitted. Migration [[job]] started.',
            createWithMigration: 'Definition created. Migration [[job]] started.',
            createRequiredImpact: '{{count}} existing entities have no value for this required attribute.',
            viewJobDashboard: 'View in [[job]] Dashboard',
            inProgress: 'Migration in progress...',
            completedWithErrors: 'Migration completed with errors',
            failed: 'Migration failed',
            editDisabledDuringMigration: 'Edit disabled during migration',
            deleteDisabledDuringMigration: 'Delete disabled during migration',
        },
    },
    partyRelationshipSchema: {
        pageTitle: 'Relationship Schema | Admin',
        title: 'Relationship schema',
        subtitle: 'Define which [[party]] types can be connected through which relationship types',
        noPermission: 'You do not have permission to view the relationship schema.',
        tabs: {
            schemaEntries: 'Schema entries',
            violations: 'Violations',
        },
        columns: {
            fromType: 'From [[type]]',
            relationshipType: 'Relationship [[type]]',
            toType: 'To [[type]]',
            cardinality: 'Cardinality',
            display: 'Display',
            status: 'Status',
        },
        form: {
            createTitle: 'Create schema entry',
            createDescription: 'Define a new allowed [[party]] relationship type.',
            editTitle: 'Edit schema entry',
            editDescription: 'Modify cardinality, display settings, and labels.',
            detailTitle: 'Schema entry details',
            fromPartyType: 'From [[party]] [[type]]',
            relationshipType: 'Relationship [[type]]',
            toPartyType: 'To [[party]] [[type]]',
            maxFromCount: 'Max from count',
            maxFromCountHint: '0 = unlimited',
            maxToCount: 'Max to count',
            maxToCountHint: '0 = unlimited',
            fromSideDisplay: 'Display from side',
            toSideDisplay: 'Display to side',
            fromSideTree: 'Tree from side',
            toSideTree: 'Tree to side',
            fromSideLabel: 'From side label',
            toSideLabel: 'To side label',
            iconFrom: 'Icon (From Side)',
            iconTo: 'Icon (To Side)',
            aliasNameFrom: 'Alias name (from side)',
            aliasNameTo: 'Alias name (to side)',
            aliasNameHint: 'Optional camelCase identifier exposed to CEL expressions (e.g. memberOf, hasMembers).',
            aliasNameInvalid: 'Alias name must be camelCase: start with a lowercase letter, then letters and digits only.',
            aliasNamePlaceholder: 'e.g. memberOf',
            sortOrder: 'Sort order',
            active: 'Active',
            labelRequired: 'Label is required when display is enabled.',
            minZero: 'Must be 0 or greater.',
            required: 'Required.',
            unlimited: 'Unlimited',
            searchIcon: 'Search icons...',
        },
        actions: {
            create: 'Create schema entry',
            save: 'Save',
            deactivate: 'Deactivate',
        },
        messages: {
            createSuccess: 'Schema entry created.',
            updateSuccess: 'Schema entry updated.',
            deactivateSuccess: 'Schema entry deactivated.',
            deactivateTitle: 'Deactivate schema entry',
            deactivateDescription: 'This will deactivate the schema entry for {{from}} → {{rel}} → {{to}}. Existing relationships will not be deleted.',
            duplicateTriple: 'A schema entry for this combination already exists.',
            unsavedChanges: 'You have unsaved changes. Discard?',
            discard: 'Discard',
            keepEditing: 'Keep editing',
        },
        violations: {
            title: 'Schema violations',
            empty: 'No schema violations recorded.',
            emptyDescription: 'When enforcement mode is set to WARN, relationships that violate the schema are logged here.',
            violationType: 'Violation [[type]]',
            detail: 'Detail',
            createdAt: 'Created at',
            allTypes: 'All [[types]]',
            noSchemaEntry: 'No schema entry',
            cardinalityExceeded: 'Cardinality exceeded',
            createdAfter: 'Created after',
            createdBefore: 'Created before',
            runValidation: 'Run validation',
            validationStarted: 'Schema validation [[job]] started. Results will appear shortly.',
        },
        enforcement: {
            strict: 'Enforcement: STRICT — invalid relationships are rejected.',
            warn: 'Enforcement: WARN — invalid relationships are logged but allowed.',
            off: 'Enforcement: OFF — schema validation is disabled.',
            modeOff: 'OFF',
            modeWarn: 'WARN',
            modeStrict: 'STRICT',
            updated: 'Enforcement mode updated.',
            changeMode: 'Change mode',
            changeModeTitle: 'Change enforcement mode',
            changeModeDescription: 'Select the new enforcement mode. This affects how the system handles relationships that violate the schema.',
            changeModeWarning: 'Changing the enforcement mode affects all relationship operations system-wide. Switching to STRICT will reject any new relationships that violate the schema.',
            newMode: 'New mode',
            offDescription: 'Schema validation is disabled. No checks are performed.',
            warnDescription: 'Invalid relationships are logged as violations but still allowed.',
            strictDescription: 'Invalid relationships are rejected. Only schema-compliant relationships can be created.',
            confirm: 'Confirm change',
        },
    },
    roles: {
        title: '[[Roles]]',
        pageTitle: '[[Roles]] | Admin',
        detailPageTitle: '[[Role]] Details | Admin',
        subtitle: 'Manage [[roles]] and their permissions',
        allRoles: 'All [[roles]]',
        createRole: 'Create [[role]]',
        editRole: 'Edit [[role]]',
        deleteRole: 'Delete [[role]]',
        filterPlaceholder: 'Filter [[roles]]...',
        roleCount: '{{count}} [[role]]',
        roleCount_other: '{{count}} [[roles]]',
        count: '{{count}} [[role]](s)',
        system: 'System',
        custom: 'Custom',
        createDescription: 'Create a new [[role]] with a name and description.',
        editDescription: 'Update the [[role]] name and description.',
        deleteConfirm: 'Are you sure you want to delete the [[role]] "{{name}}"? This action cannot be undone.',
        namePlaceholder: 'Enter [[role]] name',
        descriptionPlaceholder: 'Enter [[role]] description (optional)',
        keyColumn: 'Key',
        keyLabel: 'OAuth Claim Key',
        keyPlaceholder: 'iam-admin',
        keyValidationError: 'Key must be kebab-case ASCII (e.g. iam-admin), max 64 characters',
        keyHint: 'Stable identifier used to map upstream [[oidc role claims]] onto this role. Read-only after create.',
        noRolesMatch: 'No [[roles]] match your filter.',
        noRolesFound: 'No [[roles]] found. Create your first [[role]] to get started.',
        loadingRoles: 'Loading [[roles]]...',
        loadingRole: 'Loading [[role]]...',
        errorLoading: 'Error loading [[roles]]. Please try again.',
        errorLoadingRole: 'Error loading [[role]]. Please try again.',
        noDescription: 'No description',
        permissionsForRole: 'Permissions for {{name}}',
        permissionsDescription: 'This [[role]] has the following permissions assigned:',
        permissionsAssigned: '{{selected}} of {{total}} permission(s) assigned',
        noPermissions: 'No permissions assigned to this [[role]].',
        permissionCount: '{{count}} permission(s)',
        category: 'Category',
        assignPermissions: 'Assign permissions',
        editPermissions: 'Edit permissions',
        savePermissions: 'Save permissions',
        removePermission: 'Remove',
        addPermissions: 'Add permissions',
        availablePermissions: 'Available permissions',
        searchPermissions: 'Search permissions...',
        addSelected: 'Add selected',
        removeSelected: 'Remove selected',
        editing: 'Editing',
        resource: '[[Resource]]',
        roleCreated: '[[Role]] created successfully.',
        roleUpdated: '[[Role]] updated successfully.',
        roleDeleted: '[[Role]] deleted successfully.',
        permissionsSaved: 'Permissions saved successfully.',
    },
    roleAssignments: {
        title: '[[Role Assignments]]',
        pageTitle: '[[Role Assignments]] | Admin',
        subtitle: 'View and manage [[role assignments]] for [[identities]]',
        oauthSubtitle: 'View [[role assignments]] (managed via OAuth)',
        allAssignments: 'All [[role assignments]]',
        identity: '[[Identity]]',
        role: '[[Role]]',
        assignedAt: 'Assigned at',
        assignRole: 'Assign [[role]]',
        removeAssignment: 'Remove assignment',
        removeConfirm: 'Are you sure you want to remove the [[role]] "{{role}}" from "{{identity}}"? This action cannot be undone.',
        filterPlaceholder: 'Filter assignments...',
        assignmentCount: '{{count}} assignment(s)',
        noAssignmentsMatch: 'No assignments match your filter.',
        noAssignmentsFound: 'No [[role assignments]] found.',
        loadingAssignments: 'Loading [[role assignments]]...',
        errorLoading: 'Error loading [[role assignments]]. Please try again.',
        selectIdentity: 'Select [[identity]]',
        selectRole: 'Select [[role]]',
        searchIdentities: 'Search [[identities]]...',
        searchRoles: 'Search [[roles]]...',
        assignDescription: 'Assign a [[role]] to an [[identity]].',
        assigning: 'Assigning...',
        removing: 'Removing...',
        usersWithRoles: 'Users with [[roles]]',
        email: 'Email',
        userCount: '{{count}} user(s)',
        filterUsersPlaceholder: 'Filter users...',
        assignedRoles: 'Assigned [[roles]]',
        oauthNote: 'Human-user [[roles]] are assigned automatically based on OAuth claims; service-account [[roles]] are managed on the service-account detail page.',
        noUsersMatch: 'No users match your filter.',
        noUsersFound: 'No users found. Users are created when they log in via OAuth.',
        type: '[[Type]]',
        typeUser: 'User',
        typeServiceAccount: '[[Service Account]]',
        typeFilterAll: 'All',
        typeFilterUsers: 'Users only',
        typeFilterServiceAccounts: '[[Service Accounts]] only',
    },
    connectors: {
        title: '[[Outbound Connectors]]',
        pageTitle: '[[Outbound Connectors]] | Admin',
        detailPageTitle: '[[Outbound Connector]] Details | Admin',
        subtitle: 'Manage outbound system connectors for provisioning',
        allConnectors: 'All [[outbound connectors]]',
        createConnector: 'Create connector',
        deleteConnector: 'Delete connector',
        connectorCount: '{{count}} connector(s)',
        filterPlaceholder: 'Filter connectors...',
        targetSystem: '[[Target System]]',
        connectorType: 'Connector [[type]]',
        lastUpdated: 'Last updated',
        scim20: 'SCIM 2.0',
        ldap: 'LDAP',
        sapAbap: {
            connectionSection: 'SAP ABAP connection',
            connectionDescription: 'Outbound provisioning into SAP ABAP via OData V2 (config + [[roles]]) and optional RFC/BAPI (user create + [[role]] assign).',
            odataBaseUrl: 'OData base URL',
            rfcBaseUrl: 'RFC base URL',
            mandant: 'Mandant',
            userTypeDefault: 'Default user type',
            roleAssignmentMode: '[[Role]] assignment mode',
            compositeRoleExpansion: 'Composite [[role]] expansion',
            bnameTemplate: 'BNAME template',
            passwordPolicy: 'Password policy',
            lockReason: 'Lock reason',
            etagRetryLimit: 'ETag retry limit',
            allowedActions: 'Allowed actions',
            actionCreate: 'CREATE',
            actionUpdate: 'UPDATE',
            actionDelete: 'DELETE',
            actionEnable: 'ENABLE',
            actionDisable: 'DISABLE',
            actionGrant: 'GRANT',
            actionRevoke: 'REVOKE',
            warnCreateWithoutGrant: 'CREATE is disabled but GRANT is active — [[role assignments]] will fail because the user is never created in SAP.',
            warnDisableWithoutDelete: 'DISABLE is disabled but DELETE is active — terminated [[identities]] will be deleted instead of locked, losing audit history.',
            bapiAllowlist: 'BAPI allowlist',
            bapiAllowlistPlaceholder: 'One BAPI function module per line. Empty = unrestricted; non-empty = strict allowlist.',
            editDialogTitle: 'Edit SAP ABAP configuration',
            editDialogDescription: 'Update connection, authentication, provisioning controls, allowed actions and BAPI allowlist for this SAP ABAP connector. Default [[role]] list is managed separately.',
            sectionConnection: 'Connection',
            sectionAuthentication: 'Authentication',
            sectionProvisioning: 'Provisioning',
            sectionTimeouts: 'Timeouts',
            clientId: 'Client ID',
            clientSecretRef: 'Client secret reference',
            tokenUrl: 'Token URL',
            scope: 'OAuth scope',
            username: 'Username',
            passwordSecretRef: 'Password secret reference',
            clientCertSecretRef: 'Client certificate reference',
            clientKeySecretRef: 'Client key reference',
            truststoreSecretRef: 'Truststore reference',
            connectTimeoutMs: 'Connect timeout (ms)',
            readTimeoutMs: 'Read timeout (ms)',
            maxRetries: 'Max retries',
            saveSuccess: 'SAP ABAP configuration saved.',
        },
        createDescription: 'Create a new connector for a [[target system]].',
        deleteConfirm: 'Are you sure you want to delete the connector for "{{name}}"? This will also delete its configuration. This action cannot be undone.',
        selectSystem: 'Select a system',
        selectOutboundConnectorType: 'Select connector type',
        noConnectorsMatch: 'No connectors match your filter.',
        noConnectorsFound: 'No connectors found. Create a connector to get started.',
        loadingConnectors: 'Loading connectors...',
        loadingConnector: 'Loading connector...',
        errorLoading: 'Error loading connectors. Please try again.',
        errorLoadingConnector: 'Error loading connector. Please try again.',
        allSystemsHaveConnectors: 'All systems already have connectors configured.',
        connectorDetails: 'Connector details',
        connectorConfiguration: 'Connector configuration',
        baseUrl: 'Base URL',
        authToken: 'Auth token',
        authTokenPlaceholder: 'Enter authentication token',
        baseUrlPlaceholder: 'Enter SCIM base URL',
        saveConfiguration: 'Save configuration',
        testConnection: 'Test connection',
        testingConnection: 'Testing...',
        connectionSuccess: 'Connection successful',
        connectionFailed: 'Connection failed',
        connectionSuccessMessage: 'The SCIM server responded with status {{statusCode}}.',
        syncNow: 'Sync now',
        syncing: 'Syncing...',
        lastSyncAt: 'Last synced',
        neverSynced: 'Never synced',
        system: 'System',
        disable: 'Disable',
        enable: 'Enable',
        overview: 'Overview',
        basicInfo: 'Basic connector information',
        scimConfiguration: 'SCIM Configuration',
        scimDescription: 'SCIM 2.0 endpoint and authentication settings',
        configure: 'Configure',
        configureScimConnection: 'Configure SCIM Connection',
        configureScimDescription: 'Set up the SCIM 2.0 endpoint and authentication.',
        editScimConfiguration: 'Edit SCIM Configuration',
        editScimDescription: 'Update the SCIM 2.0 endpoint and authentication settings.',
        scimNotConfigured: 'SCIM configuration has not been set up yet.',
        recentActivity: 'Recent activity',
        last20Calls: 'Last 20 connector operations',
        noActivity: 'No activity recorded yet.',
        testResultTitle: 'Connection test result',
        endpoint: 'Endpoint',
        authentication: 'Authentication',
        authType: 'Auth [[type]]',
        authTypeLabels: {
            bearerToken: 'Bearer token',
            basicAuth: 'Basic auth',
            oauth2Client: 'OAuth2 Client Credentials',
            token: 'Token',
            certificate: 'Certificate',
            kubeconfig: 'Kubeconfig',
            none: 'None',
        },
        bearerToken: 'Bearer token',
        oauth2Client: 'OAuth2 Client Credentials',
        basicAuth: 'Basic authentication',
        tokenSecretRef: 'Token secret reference',
        tokenSecretRefHint: 'Reference to the secret containing the bearer token.',
        tokenUrl: 'Token URL',
        clientId: 'Client ID',
        clientSecretRef: 'Client secret reference',
        scope: 'Scope',
        username: 'Username',
        passwordSecretRef: 'Password secret reference',
        leaveEmptyToKeep: 'Leave empty to keep current',
        leaveEmptyToKeepHint: 'Leave empty to keep the current token. Enter a new reference to update.',
        httpSettings: 'HTTP Settings',
        connectTimeout: 'Connect timeout',
        connectTimeoutMs: 'Connect Timeout (ms)',
        readTimeout: 'Read timeout',
        readTimeoutMs: 'Read Timeout (ms)',
        maxRetries: 'Max retries',
        retryBackoff: 'Retry backoff',
        retryBackoffMs: 'Retry Backoff (ms)',
        features: 'Features',
        supportsBulk: 'Supports bulk operations',
        supportsEtag: 'Supports ETag',
        patchStyle: 'Patch style',
        userEndpoint: 'User endpoint',
        groupEndpoint: 'Group endpoint',
        timestamp: 'Timestamp',
        operation: 'Operation',
        resource: '[[Resource]]',
        duration: 'Duration',
        statusCode: 'Status code: {{code}}',
        pending: 'Pending',
        batch: 'Batch',
        // LDAP configuration
        ldapConfiguration: 'LDAP Configuration',
        ldapDescription: 'LDAP server connection and directory settings',
        configureLdapConnection: 'Configure LDAP Connection',
        configureLdapDescription: 'Set up the LDAP server connection and directory search settings.',
        editLdapConfiguration: 'Edit LDAP Configuration',
        editLdapDescription: 'Update the LDAP server connection and directory search settings.',
        ldapNotConfigured: 'LDAP configuration has not been set up yet.',
        serverSettings: 'Server',
        host: 'Host',
        hostPlaceholder: 'ldap.example.com',
        port: 'Port',
        useSsl: 'Use SSL (LDAPS)',
        useStarttls: 'Use StartTLS',
        bindDn: 'Bind DN',
        bindDnPlaceholder: 'cn=admin,dc=example,dc=com',
        bindPasswordRef: 'Bind password reference',
        bindPasswordRefPlaceholder: 'vault:secret/ldap/bind-password',
        bindPasswordRefHint: 'Reference to the secret containing the bind password.',
        directorySettings: 'Directory',
        directoryDialect: 'Directory dialect',
        directoryDialectHint: 'Choose the directory flavour to drive DISABLE/ENABLE_ACCOUNT wire shape.',
        dialectActiveDirectory: '[[Active Directory]]',
        dialectOpenLdap: 'OpenLDAP / 389-DS',
        baseDn: 'Base DN',
        baseDnPlaceholder: 'dc=example,dc=com',
        userSearchBase: 'User search base',
        userSearchBasePlaceholder: 'ou=Users,dc=example,dc=com',
        userSearchFilter: 'User search filter',
        userSearchFilterPlaceholder: '(sAMAccountName={0})',
        groupSearchBase: 'Group search base',
        groupSearchBasePlaceholder: 'ou=Groups,dc=example,dc=com',
        groupMemberAttribute: 'Group member attribute',
        userDnAttribute: 'User DN Attribute',
        connectionSettings: 'Connection',
        responseTimeoutMs: 'Response Timeout (ms)',
        poolSize: 'Pool size',
        connectionSuccessMessageGeneric: 'The server responded successfully.',
        // REST configuration
        restConfiguration: 'REST Configuration',
        restDescription: 'REST API endpoint templates for GRANT and REVOKE operations',
        configureRestConnection: 'Configure REST Connection',
        configureRestDescription: 'Set up the REST API base URL and per-action URL/body templates.',
        editRestConfiguration: 'Edit REST Configuration',
        editRestDescription: 'Update the REST API connection and template settings.',
        restNotConfigured: 'REST configuration has not been set up yet.',
        restBaseUrlPlaceholder: 'https://api.example.com/v1',
        authSecretRef: 'Auth secret reference',
        authSecretRefPlaceholder: 'vault:secret/rest/token',
        grantAction: 'Grant action',
        revokeAction: 'Revoke action',
        httpMethod: 'HTTP Method',
        urlTemplate: 'URL Template',
        urlTemplatePlaceholder: '${baseUrl}/repos/${repoId}/collaborators/${userId}',
        bodyTemplate: 'Body template',
        bodyTemplatePlaceholder: '{"permission": "${roleName}"}',
        headers: 'Headers',
        headersPlaceholder: '{"X-Custom-Header": "value"}',
        addHeader: 'Add header',
        noHeaders: 'No headers configured',
        headerName: 'Header name',
        headerNamePlaceholder: 'Authorization',
        headerValue: 'Header value',
        headerValuePlaceholder: 'Bearer ${token}',
        successStatusCodes: 'Success status codes',
        successStatusCodesPlaceholder: '200,201,204',
        contentType: 'Content [[type]]',
        // Database configuration
        databaseConfiguration: 'Database configuration',
        databaseDescription: 'JDBC database connection and SQL templates for GRANT and REVOKE operations',
        configureDatabaseConnection: 'Configure database connection',
        configureDatabaseDescription: 'Set up the JDBC database connection and SQL templates.',
        editDatabaseConfiguration: 'Edit database configuration',
        editDatabaseDescription: 'Update the JDBC database connection and SQL templates.',
        databaseNotConfigured: 'Database configuration has not been set up yet.',
        databaseType: 'Database [[type]]',
        jdbcUrl: 'JDBC URL',
        jdbcUrlPlaceholder: 'jdbc:postgresql://localhost:5432/mydb',
        driverClass: 'Driver class',
        driverClassPlaceholder: 'org.postgresql.Driver',
        dbUsername: 'Username',
        dbUsernamePlaceholder: 'db_connector_user',
        passwordRef: 'Password reference',
        passwordRefPlaceholder: 'plain:secret or vault:secret/db/password',
        passwordRefHint: 'Reference to the secret containing the database password.',
        grantSqlTemplate: 'Grant SQL Template',
        grantSqlTemplatePlaceholder: 'GRANT ${enforcementObjectExternalId} TO "${accountExternalId}"',
        revokeSqlTemplate: 'Revoke SQL Template',
        revokeSqlTemplatePlaceholder: 'REVOKE ${enforcementObjectExternalId} FROM "${accountExternalId}"',
        testSql: 'Test SQL',
        testSqlPlaceholder: 'SELECT 1',
        testSqlHint: 'SQL statement to verify connectivity. Leave empty for default.',
        queryTimeoutMs: 'Query Timeout (ms)',
        sqlTemplates: 'SQL Templates',
        // Kubernetes configuration
        k8sConfiguration: 'Kubernetes configuration',
        k8sDescription: 'Kubernetes API server connection and RBAC binding settings',
        configureK8sConnection: 'Configure kubernetes connection',
        configureK8sDescription: 'Set up the Kubernetes API server connection.',
        editK8sConfiguration: 'Edit kubernetes configuration',
        editK8sDescription: 'Update the Kubernetes API server connection settings.',
        k8sNotConfigured: 'Kubernetes configuration has not been set up yet.',
        apiServerUrl: 'API Server URL',
        apiServerUrlPlaceholder: 'https://k8s.example.com:6443',
        tokenRef: 'Token secret reference',
        tokenRefPlaceholder: 'vault:secret/k8s/token or plain:my-token',
        caCertRef: 'CA Cert Secret Reference',
        caCertRefPlaceholder: 'vault:secret/k8s/ca-cert',
        defaultNamespace: 'Default namespace',
        defaultNamespacePlaceholder: 'default',
        skipTlsVerify: 'Skip TLS Verification',
        requestTimeoutMs: '[[Request]] Timeout (ms)',
        // Email configuration
        emailConfiguration: 'Email configuration',
        emailDescription: 'SMTP connection and [[notification]] template settings',
        configureEmailConnection: 'Configure email connection',
        configureEmailDescription: 'Set up the SMTP server, recipients, and [[notification]] templates.',
        editEmailConfiguration: 'Edit email configuration',
        editEmailDescription: 'Update the SMTP connection and [[notification]] template settings.',
        emailNotConfigured: 'Email configuration has not been set up yet.',
        smtpSettings: 'SMTP Settings',
        smtpHost: 'SMTP Host',
        smtpPort: 'SMTP Port',
        smtpUsername: 'SMTP Username',
        smtpPasswordRef: 'SMTP Password Reference',
        useTls: 'Use TLS',
        recipients: 'Recipients',
        fromAddress: 'From address',
        toAddresses: 'To addresses',
        ccAddresses: 'CC Addresses',
        grantTemplate: 'Grant [[notification]] Template',
        revokeTemplate: 'Revoke [[notification]] Template',
        subjectTemplate: 'Subject template',
        bodyContentType: 'Body Content [[type]]',
        advancedSettings: 'Advanced settings',
        optionalPlaceholder: 'Optional',
        connectorCreated: 'Connector created successfully.',
        connectorUpdated: 'Connector updated successfully.',
        connectorDeleted: 'Connector deleted successfully.',
        connectorToggled: 'Connector status updated successfully.',
        configurationSaved: 'Configuration saved successfully.',
        // Auth type labels
        tokenAuth: '[[Service Account]] Token',
        certificateAuth: 'Client certificate',
        kubeconfigAuth: 'Kubeconfig file',
        noneAuth: 'No authentication',
        // Placeholder texts
        tokenSecretRefPlaceholder: 'vault:secret/api/token or plain:my-token',
        tokenUrlPlaceholder: 'https://auth.example.com/oauth/token',
        clientSecretRefPlaceholder: 'vault:secret/oauth/client-secret',
        scopePlaceholder: 'openid profile email',
        passwordSecretRefPlaceholder: 'vault:secret/api/password',
        scimBaseUrlPlaceholder: 'https://scim.example.com/v2',
        smtpHostPlaceholder: 'smtp.example.com',
        smtpPasswordRefPlaceholder: 'vault:secret/smtp/password',
        fromAddressPlaceholder: 'noreply@example.com',
        toAddressesPlaceholder: 'recipient@example.com',
        grantSubjectTemplatePlaceholder: 'Access granted: ${accessProfileName}',
        grantBodyTemplatePlaceholder: 'Hello ${identity.displayName}, access has been granted.',
        revokeSubjectTemplatePlaceholder: 'Access revoked: ${accessProfileName}',
        revokeBodyTemplatePlaceholder: 'Hello ${identity.displayName}, access has been revoked.',
        // Database type labels
        databaseTypePostgresql: 'PostgreSQL',
        databaseTypeMysql: 'MySQL',
        databaseTypeOracle: 'Oracle',
        databaseTypeSqlserver: 'SQL Server',
        databaseTypeOther: 'Other',
        // Tabs
        tabs: {
            overview: 'Overview',
            configuration: 'Configuration',
            attributes: 'Attributes',
            provisioningTasks: '[[Provisioning Tasks]]',
        },
        // Attributes tab
        attributes: {
            title: 'Connector attributes',
            description: 'Custom attributes assigned to this connector.',
        },
        // Attribute Mappings card
        attributeMappings: {
            title: 'Attribute mappings',
            description: 'Define how [[identity]] attributes map to [[target system]] fields during account provisioning.',
            descriptionDetail: 'Each row maps a source (Direct attribute, Computed template, or Static value) to a target field name.',
            emptyState: 'No attribute mappings configured yet.',
            addMapping: 'Add mapping',
            source: 'Source',
            target: 'Target',
            type: '[[Type]]',
            transform: 'Transform',
            transformNone: 'None',
            required: 'Required',
            typeDirect: 'Direct',
            typeComputed: 'Computed',
            typeStatic: 'Static',
            sourceHintDirect: 'Select an [[attribute definition]]',
            sourceHintComputed: '{firstName} {lastName}',
            sourceHintStatic: 'Literal value (e.g. 512)',
            targetHint: '[[Target System]] attribute (e.g. mail)',
            duplicateTarget: 'Duplicate target: {{name}}',
            unknownSource: 'Unknown [[attribute definition]]',
            saved: 'Attribute mappings saved',
            cleared: 'Attribute mappings cleared',
            confirmDelete: 'Remove this mapping?',
            noMappings: 'No attribute mappings configured',
            noMappingsWarning: 'Account provisioning (CREATE_ACCOUNT, UPDATE_ACCOUNT) will fail until attribute mappings are configured.',
            invalidTemplateSyntax: 'Invalid template syntax (unclosed or nested braces)',
            unknownScimTarget: 'Unknown SCIM target path',
            sourceRequired: 'Source is required',
            targetExceedsMaxLength: 'Target exceeds 100 characters',
            sourceExceedsMaxLength: 'Source exceeds 500 characters',
            invalidRfc4512Target: 'Must start with a letter, followed by letters, digits, hyphens, or dots',
            maxMappingsReached: 'Maximum 50 attribute mappings',
            maxMappingsTooltip: 'Maximum 50 attribute mappings reached',
            unknownVariable: 'Unknown variable: {{name}}',
            addMappingAction: '+ Add',
        },
        // Navigation guard dialog
        unsavedChangesTitle: 'Leave without saving?',
        unsavedChangesBody: 'You have unsaved changes. If you leave now, your changes will be lost.',
        unsavedChangesStay: 'Stay',
        unsavedChangesLeave: 'Leave without saving',
        // Per-connector Provisioning Tasks tab (issue 601)
        provisioningTasks: {
            title: '[[Provisioning Tasks]]',
            active: 'Active tasks',
            history: 'Recent history',
            viewAll: 'View all in Provisioning History →',
            activeEmpty: 'No active [[provisioning tasks]] for this connector.',
            historyEmpty: 'No provisioning history yet for this connector.',
            loading: 'Loading [[provisioning tasks]]...',
            errorLoading: 'Error loading [[provisioning tasks]]. Please try again.',
            columns: {
                identity: '[[Identity]]',
                entitlement: 'Entitlement',
                account: 'Account',
                action: 'Action',
                status: 'Status',
                retries: 'Retries',
                created: 'Created',
                completed: 'Completed',
            },
        },
        // LDAP Provisioning Config card
        ldapProvisioningConfig: {
            title: 'LDAP Provisioning Config',
            description: 'LDAP-specific provisioning configuration including OU routing rules and object classes.',
            emptyState: 'No LDAP provisioning configuration set. Defaults apply: objectClass=inetOrgPerson, DN template=cn=${accountName},${ou}.',
            objectClasses: 'Object classes',
            objectClassesHint: 'e.g. top, person, inetOrgPerson',
            objectClassesEmpty: 'No object classes configured',
            dnTemplate: 'DN Template',
            dnTemplateHint: 'Must contain {ou}. Example: cn={cn},{ou}',
            noConfig: 'No LDAP provisioning config',
            noConfigWarning: 'Account provisioning requires object classes and a DN template.',
            ouRouting: 'OU Routing',
            ouRoutingDescription: 'Rules evaluated top-to-bottom. First match wins.',
            defaultOu: 'Default OU',
            addRule: 'Add rule',
            attribute: 'Attribute',
            operator: 'Operator',
            value: 'Value',
            targetOu: 'Target OU',
            saved: 'LDAP provisioning config saved',
            defaultOuRequired: 'Default OU is required when rules exist',
            defaultOuMaxLength: 'Max 500 characters',
        },
    },
    types: {
        title: '[[Type Values]]',
        pageTitle: '[[Type Values]] | Admin',
        subtitle: 'Manage [[type value]] tables and their entries',
        allTypeTables: 'All [[type]] Tables',
        filterPlaceholder: 'Filter type tables...',
        searchPlaceholder: 'Search type tables...',
        entityTypesOnly: 'Entity types only',
        tableName: 'Table name',
        entryCount: 'Entries',
        noTablesMatch: 'No type tables match your filter.',
        noTablesFound: 'No type tables found.',
        loadingTables: 'Loading type tables...',
        errorLoading: 'Error loading type tables. Please try again.',
        tableCount: '{{count}} type table(s)',
        values: 'Values',
        code: 'Code',
        label: 'Label',
        sortOrder: 'Sort order',
        addValue: 'Add value',
        editValue: 'Edit value',
        deleteValue: 'Delete value',
        deleteValueConfirm: 'Are you sure you want to delete the value "{{code}}"? This action cannot be undone.',
        codePlaceholder: 'Enter code',
        labelPlaceholder: 'Enter label',
        sortOrderPlaceholder: 'Enter sort order',
        noValuesFound: 'No values found in this type table.',
        noValuesMatch: 'No values match your filter.',
        filterValuesPlaceholder: 'Filter values...',
        valueCount: '{{count}} value(s)',
        loadingValues: 'Loading [[type values]]...',
        errorLoadingValues: 'Error loading [[type values]]. Please try again.',
        typesTitle: '[[Types]]',
        detailPageTitle: '[[Type]] Details | Admin',
        typesSubtitle: 'Manage [[type values]] and their translations for dropdown selections throughout the application.',
        loadingTypes: 'Loading types...',
        errorLoadingTypes: 'Error loading types. Please try again.',
        addTypeValue: 'Add [[type value]]',
        createValueDescription: 'Create a new value for {{name}}.',
        deleteTypeValue: 'Delete [[type value]]',
        cannotDelete: 'Cannot delete {{code}} because it is used by {{count}} records.',
        setInactiveHint: 'You can set it to inactive instead to hide it from new selections.',
        codeFormatHint: 'UPPERCASE_WITH_UNDERSCORES',
        noPermission: 'You do not have permission to view types.',
        usage: 'Usage',
        translations: 'Translations',
        translationsFor: 'Translations for {{code}}',
        editTranslations: 'Edit translations',
        editTranslationsFor: 'Update translations for {{code}}',
        viewTranslations: 'View translations',
        language: 'Language',
        descriptionOptional: 'Description (optional)',
        setInactive: 'Set inactive',
        setActive: 'Set active',
        inUse: '({{count}} in use)',
        activeCount: '{{count}} active',
        translationLabel: '{{locale}} Translation',
        entityTypeBadge: 'Entity [[type]]',
        valueDetailPageTitle: '[[Type Value]] | Admin',
        backToTable: 'Back to {{tableName}}',
        settingsCard: 'Settings',
        settingsCardEmpty: 'No settings configured. Fill in the fields above and click Save.',
        settingsIconLabel: 'Icon',
        settingsIconNone: 'No icon selected',
        settingsIconSearch: 'Search icons...',
        settingsIconNoResults: 'No icons found',
        iconCategories: {
            people: 'People & Teams',
            business: 'Business & Buildings',
            technology: 'Technology',
            security: 'Security & Access',
            communication: 'Communication',
            organization: 'Organization',
            files: 'Files & Data',
            status: 'Status & Indicators',
            objects: 'Objects & Places',
            tools: 'Tools & Actions',
        },
        settingsColorLabel: 'Color',
        settingsTemplateLabel: 'Display name template',
        settingsTemplatePlaceholder: 'e.g. {firstName} {lastName}',
        settingsTemplateChipsHint: 'Click a chip to append the placeholder to the template.',
        settingsTemplateNoAttributes: 'No attributes scoped to this type yet.',
        settingsTemplateStalePlaceholders: 'Some placeholders in this template ({{placeholders}}) are not scoped to this type and will resolve to an empty string.',
        settingsSaveSuccess: 'Settings saved.',
        settingsSaveSuccessRederivation: 'Display names are being re-derived for all [[identities]] of this type. This may take a moment.',
        settingsSaveError: 'Failed to save settings. Please try again.',
        settingsConflict: 'Settings were changed by another user. Please reload the page to get the latest version.',
        scopedAttributesCard: 'Scoped [[attribute definitions]]',
        scopedAttributesEmpty: 'No [[attribute definitions]] are scoped to this type.',
        scopedAttributesViewLink: 'View [[attribute definitions]]',
        scopedAttributesName: 'Name',
        scopedAttributesDisplayName: 'Display name',
        scopedAttributesValueType: 'Value [[type]]',
        scopedAttributesRequired: 'Required',
        unsavedChangesTitle: 'Discard unsaved changes?',
        unsavedChangesBody: 'Your settings changes have not been saved. Leave anyway?',
        unsavedChangesDiscard: 'Discard',
        retryButton: 'Retry',
        errorLoadingValue: 'Could not load this [[type value]]. The table or code may not exist, or it is not an entity type table.',
        groupedView: {
            searchPlaceholder: 'Search rows by code or label...',
            noResults: 'No rows match your search.',
            ungroupedLabel: 'Ungrouped',
            rowCountAria: '{{count}} rows in group {{group}}',
        },
    },
    parties: {
        title: '[[Parties]]',
        pageTitle: '[[Parties]] | [[identity management]]',
        detailPageTitle: '[[Party]] Details | [[identity management]]',
        subtitle: 'Manage [[parties]] (people and organizations)',
        subtitleExtended: 'View and manage [[parties]] (people, organizations, and agents)',
        allParties: 'All [[parties]]',
        filterPlaceholder: 'Search by name, External ID, or [[party]] attributes...',
        searchByName: 'Search by name...',
        partyCount: '{{count}} part(ies)',
        partyCount_one: '{{count}} [[party]]',
        partyCount_other: '{{count}} [[parties]]',
        createSuccess: '[[Party]] created successfully.',
        displayName: 'Display name',
        email: 'Email',
        partyType: '[[Party]] [[type]]',
        noPartiesMatch: 'No [[parties]] match your filters.',
        noPartiesFound: 'No [[parties]] found.',
        loadingParties: 'Loading [[parties]]...',
        loadingParty: 'Loading [[party]]...',
        errorLoading: 'Error loading [[parties]]. Please try again.',
        errorLoadingParty: 'Error loading [[party]]. Please try again.',
        partyDetails: '[[Party]] Details',
        firstName: 'First name',
        lastName: 'Last name',
        identities: '[[Identities]]',
        noIdentities: 'No [[identities]] found for this [[party]].',
        identityCount: '{{count}} [[identities]] linked to this [[party]]',
        identityCount_one: '{{count}} [[identity]] linked to this [[party]]',
        identityCount_other: '{{count}} [[identities]] linked to this [[party]]',
        noIdentitiesLinked: 'No [[identities]] linked to this [[party]].',
        relationships: 'Relationships',
        partyHierarchy: 'Organization',
        organizationalStructure: 'Organizational structure and relationships',
        noRelationshipsForCard: 'No {{label}} assigned.',
        noRelationships: 'No [[party]] relationships defined.',
        addRelationship: 'Add {{label}}',
        addRelationshipMaxReached: 'Maximum {{label}} reached.',
        removeRelationship: 'Remove {{name}}',
        removeRelationshipTitle: 'Remove relationship',
        removeRelationshipConfirm: 'Remove the relationship to {{name}}? This sets validTo on the relationship; the row is no longer active but is kept for audit history.',
        relationshipPickerPlaceholder: 'Search for a [[party]]...',
        relationshipCreateSuccess: 'Relationship created.',
        relationshipEndedSuccess: 'Relationship removed.',
        created: 'Created',
        menuDescription: 'People, organizations, and agents',
    },
    identities: {
        title: '[[Identities]]',
        pageTitle: '[[Identities]] | [[identity management]]',
        subtitle: 'View and manage digital [[identities]]',
        allIdentities: 'All [[identities]]',
        searchPlaceholder: 'Search by [[party]] name, External ID, or attributes...',
        identityCount: '{{count}} [[identities]]',
        identityCount_one: '{{count}} [[identity]]',
        identityCount_other: '{{count}} [[identities]]',
        party: '[[Party]]',
        identityType: '[[Type]]',
        lifecycleState: 'State',
        noIdentitiesMatch: 'No [[identities]] match your filters.',
        noIdentitiesFound: 'No [[identities]] found.',
        loadingIdentities: 'Loading [[identities]]...',
        errorLoading: 'Error loading [[identities]]. Please try again.',
        identityDetails: '[[Identity]] Details',
        detailPageTitle: '[[Identity]] Details | [[identity management]]',
        loadingIdentity: 'Loading [[identity]]...',
        errorLoadingIdentity: 'Error loading [[identity]]. Please try again.',
        identityInfo: 'Core [[identity]] information and lifecycle state',
        lifecycleChanged: 'Lifecycle changed',
        attributes: 'Attributes',
        attributeCount: '{{count}} attributes defined for this [[identity]]',
        attributeCount_one: '{{count}} attribute defined for this [[identity]]',
        attributeCount_other: '{{count}} attributes defined for this [[identity]]',
        noAttributes: 'No attributes found for this [[identity]].',
        authority: 'Authority',
        addAttribute: 'Add attribute',
        editAttribute: 'Edit attribute',
        deleteAttribute: 'Delete attribute',
        confirmDeleteAttribute: 'Are you sure you want to delete this attribute?',
        attributeSaved: 'Attribute saved successfully.',
        attributeDeleted: 'Attribute deleted successfully.',
        accountCount: '{{count}} accounts linked to this [[identity]]',
        accountCount_one: '{{count}} account linked to this [[identity]]',
        accountCount_other: '{{count}} accounts linked to this [[identity]]',
        noAccountsLinked: 'No accounts linked to this [[identity]].',
        identifiersSection: 'Identifiers',
        identifierCount: '{{count}} identifiers recorded for this [[identity]]',
        identifierCount_one: '{{count}} identifier recorded for this [[identity]]',
        identifierCount_other: '{{count}} identifiers recorded for this [[identity]]',
        noIdentifiersRecorded: 'No identifiers recorded for this [[identity]].',
        identifierTypeColumn: 'Type',
        identifierValueColumn: 'Value',
        identifierPrimaryColumn: 'Primary',
        identifierValidFromColumn: 'Valid from',
        identifierValidToColumn: 'Valid to',
        identifierPrimaryBadge: 'Primary',
        activeAssignmentCount: '{{count}} active assignments',
        activeAssignmentCount_one: '{{count}} active assignment',
        activeAssignmentCount_other: '{{count}} active assignments',
        noAssignments: 'No [[access profile assignments]].',
        byAssignment: 'By assignment',
        assignmentHistory: 'Assignment history',
        noHistoryEvents: 'No history events.',
        partyBelongsTo: 'The [[party]] this [[identity]] belongs to',
        viewPartyDetails: 'View [[party]] details',
        managerSection: 'Manager',
        managerSection_other: 'Responsible persons',
        managerSectionDescription: 'The line manager for this [[identity]]',
        managerSectionDescription_other: 'Persons responsible for this [[identity]]',
        managerEmptyState: 'No manager assigned',
        managerLoadError: 'Could not load responsible persons',
        managerRetry: 'Retry',
        viewIdentityDetails: 'View [[identity]] details',
        sources: 'Sources',
        activeSources: '{{count}} active',
        request: '[[Request]]',
        expiresAt: 'Expires',
        externalIdentifier: 'External identifier',
        revokeAssignment: 'Revoke assignment',
        revokeAssignmentConfirm: 'Are you sure you want to revoke this assignment? This action cannot be undone.',
        revoking: 'Revoking...',
        revoke: 'Revoke',
        activateIdentity: 'Activate [[identity]]',
        suspendIdentity: 'Suspend [[identity]]',
        terminateIdentity: 'Terminate [[identity]]',
        activateDescription: 'This will activate the [[identity]] and enable access.',
        suspendDescription: 'This will suspend the [[identity]] and temporarily disable access.',
        terminateDescription: 'This will permanently terminate the [[identity]]. This action cannot be undone.',
        activate: 'Activate',
        suspend: 'Suspend',
        terminate: 'Terminate',
        rehire: 'Rehire',
        rehireIdentity: 'Rehire [[identity]]',
        rehireDescription: 'Rehire a terminated [[identity]] with a new entry date. They will become active immediately if the entry date is today, or remain suspended until the entry date arrives. Access will be re-granted on activation.',
        rehireNewEntryDate: 'New entry date',
        rehireNewEntryDateHelper: 'Today or in the future, within 2 years.',
        rehireReason: 'Reason',
        rehireReasonHelper: 'Required. Captured in the [[audit log]].',
        rehireSubmitted: 'Rehire submitted — [[identity]] is now suspended until its entry date.',
        processing: 'Processing...',
        menuDescription: 'Digital [[identities]] and lifecycle',
        accounts: 'Accounts',
        accessProfiles: '[[Access Profiles]]',
        effectiveAccess: 'Effective access',
        timeline: 'Timeline',
        snapshot: 'Snapshot',
        lifecycleUpdated: '[[Identity]] lifecycle updated successfully.',
        activationSubmitted: 'Activation submitted — processing in background.',
        terminationSubmitted: 'Termination submitted — processing in background.',
        assignmentRevoked: 'Assignment revoked successfully.',
        entryDate: 'Entry date',
        exitDate: 'Exit date',
        reactivationDate: 'Planned reactivation',
        reactivationDateNone: 'Not scheduled',
        plannedReactivationDate: 'Planned reactivation date',
        plannedReactivationDateHelper: 'Optional future date. The [[identity]] will be reactivated automatically on this day.',
        reactivationDateUpdated: 'Planned reactivation date updated.',
        editReactivationDate: 'Edit planned reactivation date',
        editReactivationDateDescription: 'Set a new planned reactivation date or clear it to leave the suspension indefinite.',
        derivedDisplayName: 'Display name',
        upcomingEvents: 'Upcoming events',
        upcomingEventsDescription: 'Scheduled joiners and leavers',
        noUpcomingEvents: 'No upcoming [[lifecycle events]].',
        eventTypeActivation: 'Activation',
        eventTypeTermination: 'Termination',
        joiner: 'Joiner',
        leaver: 'Leaver',
        evaluateRules: 'Re-evaluate Rules',
        evaluateRulesDescription: 'This will re-evaluate all [[auto-assign rules]] for this [[identity]]. Use when attributes have changed (Mover scenario).',
        evaluateRulesSubmitted: 'Rule evaluation submitted successfully.',
    },
    lifecycleEvents: {
        triggerSource: {
            USER_ACTION: 'User action',
            JML_JOINER: 'Joiner',
            JML_LEAVER: 'Leaver',
            JML_MOVER: 'Mover',
            EXIT_DATE_JOB: 'Exit Date [[job]]',
            REACTIVATION_SWEEPER: 'Reactivation sweeper',
            INBOUND_SYNC: 'Inbound sync',
            OUTBOUND_PROVISIONING: 'Outbound provisioning',
            ACCESS_REQUEST: '[[Access Request]]',
            CERTIFICATION_REVOKE: 'Certification revoke',
            INITIAL_LOAD: 'Initial load',
            SYSTEM: 'System',
        },
        tab: {
            identity: 'Lifecycle',
            account: 'Status events',
        },
        header: {
            viewTimeline: 'View full timeline →',
            createdAs: 'Created as {{state}}',
            unavailable: 'Lifecycle history unavailable',
            loading: 'Loading lifecycle history…',
            by: 'by',
            reasonLabel: 'Reason',
        },
        timeline: {
            system: 'System',
            createdLabel: 'Created',
            cascadedFromIdentity: 'Cascaded from [[identity]] →',
            viewJobExecution: 'View [[job]] [[execution]] →',
            viewAccessRequest: 'View [[access request]] →',
            loading: 'Loading timeline…',
            errorBanner: 'Failed to load [[lifecycle events]].',
        },
        empty: {
            noEvents: 'No [[lifecycle events]] recorded for this [[identity]].',
            noEventsAccount: 'No status events recorded for this account.',
            cutoverNote: 'Events are recorded from the deployment ship date onwards.',
            noResultsForFilters: 'No [[lifecycle events]] match the current filters.',
            clearFilters: 'Clear filters',
        },
        filter: {
            triggerSource: 'Trigger source',
            stateTransition: 'State',
            dateRange: 'Date range',
            from: 'From',
            to: 'To',
            toggleFilters: 'Filters',
            clearFilters: 'Clear filters',
        },
        dialog: {
            reasonLabel: 'Reason',
            reasonHelp: 'Optional — visible in lifecycle history',
            reasonCounter: '{{count}} / 1000',
            reasonPlaceholder: 'Why is this state change happening?',
        },
        toast: {
            updated: 'Lifecycle state updated',
            accountUpdated: 'Account status updated',
        },
        dashboard: {
            title: '[[Lifecycle Events]]',
            pageTitle: '[[Lifecycle Events]] | Admin',
            menuDescription: 'Cross-cutting timeline of [[identity]] and account state changes',
            cardTitle: 'All [[lifecycle events]]',
            count: '{{count}} event(s)',
            count_one: '{{count}} event',
            count_other: '{{count}} events',
            errorLoading: 'Error loading [[lifecycle events]]. Please try again.',
            loading: 'Loading [[lifecycle events]]…',
            entityTypeFilter: 'Entity [[type]]',
            allEntities: 'All entities',
            allTriggerSources: 'All trigger sources',
            triggerSourceCount: '{{count}} sources',
            entityType: {
                IDENTITY: '[[Identity]]',
                ACCOUNT: 'Account',
            },
            columns: {
                changedAt: 'Changed at',
                entity: 'Entity',
                fromTo: 'From → To',
                triggerSource: 'Trigger source',
                actor: 'Actor',
                reason: 'Reason',
            },
            actorSystem: 'System',
            actorSystemWithSource: 'System ({{source}})',
            createdLabel: 'Created',
            createdSeparator: 'Created · {{state}}',
            fromToSeparator: '{{from}} → {{to}}',
            none: '—',
        },
    },
    accounts: {
        title: 'Accounts',
        pageTitle: 'Accounts | [[identity management]]',
        detailPageTitle: 'Account details',
        accountDetails: 'Account details',
        accountConfig: 'Account configuration',
        notFound: 'Account not found',
        subtitle: 'View accounts across all [[target systems]]',
        allAccounts: 'All accounts',
        filterPlaceholder: 'Search accounts...',
        accountCount: '{{count}} account(s)',
        accountName: 'Account name',
        targetSystem: '[[Target System]]',
        identity: '[[Identity]]',
        subtitleExtended: 'View and manage accounts across all [[target systems]]',
        searchByExternalId: 'Search by external ID...',
        accountCount_one: '{{count}} account',
        accountCount_other: '{{count}} accounts',
        externalId: 'External ID',
        allStatuses: 'All statuses',
        allSystems: 'All systems',
        allEnvs: 'All environments',
        filterBySystem: 'Filter by system...',
        noSystemsFound: 'No systems found.',
        menuDescription: 'Accounts across [[target systems]]',
        noAccountsMatch: 'No accounts match your filters.',
        noAccountsFound: 'No accounts found.',
        loadingAccounts: 'Loading accounts...',
        errorLoading: 'Error loading accounts. Please try again.',
        pendingCreation: 'Pending creation...',
        creationInProgress: 'Account creation in progress',
        disableInProgress: 'Account disable in progress',
        enableInProgress: 'Account enable in progress',
        deleteInProgress: 'Account deletion in progress',
        lockedTooltip: 'Account locked due to security incident. Contact security team.',
        createAccount: 'Create account',
        provisionNow: 'Provision now',
        disableAccount: 'Disable account',
        enableAccount: 'Enable account',
        deleteAccount: 'Delete account',
        cancelAccountCreation: 'Cancel account creation',
        revokeGrantsFirst: 'Revoke all grants before deleting this account',
        createAccountTitle: 'Create account',
        createAccountMessage: 'Create account on {{systemName}}?',
        selectTargetSystem: 'Select [[target system]]',
        disableAccountTitle: 'Disable account',
        disableAccountMessage: 'Disable account on {{systemName}}? The account will be deactivated in the [[target system]].',
        enableAccountTitle: 'Enable account',
        enableAccountMessage: 'Enable account on {{systemName}}?',
        deleteAccountTitle: 'Delete account',
        deleteAccountMessage: 'Delete account on {{systemName}}? This will permanently remove the account from the [[target system]]. This action cannot be undone.',
        cancelCreationTitle: 'Cancel account creation',
        cancelCreationMessage: 'Cancel the pending account creation on {{systemName}}? The account will not be created.',
        operationQueued: 'Account operation queued \u2014 processing in background',
        provisionNowQueued: 'Provisioning queued — the account will be (re-)provisioned on the [[target system]].',
        noAccountsLinked: 'No accounts linked to this [[identity]].',
        environment: 'Environment',
        systemType: 'System type',
        disabledAt: 'Disabled at',
        externalIdentifier: 'External identifier',
    },
    systems: {
        title: '[[Target Systems]]',
        pageTitle: 'Systems | [[target systems]]',
        subtitle: 'Manage [[target systems]] and their configuration',
        allSystems: 'All systems',
        filterPlaceholder: 'Filter systems...',
        systemCount: '{{count}} system(s)',
        systemName: 'System name',
        systemType: 'System [[type]]',
        noSystemsMatch: 'No systems match your filter.',
        noSystemsFound: 'No systems found.',
        loadingSystems: 'Loading systems...',
        errorLoading: 'Error loading systems. Please try again.',
        detailPageTitle: 'System Details | [[target systems]]',
        subtitleView: 'View and manage [[target systems]] and their configuration',
        searchByName: 'Search by name...',
        environment: 'Environment',
        allEnvironments: 'All environments',
        lastSync: 'Last sync',
        loadingSystem: 'Loading system...',
        errorLoadingSystem: 'Error loading system. Please try again.',
        configDescription: 'System configuration and metadata',
        authoritativeForIdentities: 'Authoritative for [[identities]]',
        authoritativeForAttributes: 'Authoritative for Attributes',
        authoritativeForAccounts: 'Authoritative for Accounts',
        resourceCount_one: '{{count}} [[resource]] in this system',
        resourceCount_other: '{{count}} [[resources]] in this system',
        noResources: 'No [[resources]] found for this system.',
        enforcementObjectCount_one: '{{count}} [[enforcement object]] in this system',
        enforcementObjectCount_other: '{{count}} [[enforcement objects]] in this system',
        noEnforcementObjects: 'No [[enforcement objects]] found for this system.',
        connector: 'Connector',
        connectorDescription: 'Connector configuration for this system',
        noConnector: 'No connector configured for this system.',
        noConnectorConfigured: 'No connector has been configured',
        addConnector: 'Add connector',
        loadingConnector: 'Loading connector...',
        viewConnector: 'View connector details',
        classification: 'Classification',
        menuDescription: '[[Target Systems]] and configuration',
        systemDetails: 'System details',
        resources: '[[Resources]]',
        connectors: 'Connectors',
        resourceCount: '{{count}} [[resource]](s)',
        enforcementObjectCount: '{{count}} [[enforcement object]](s)',
        terminationAction: 'Termination action',
        terminationActionHelper: 'Controls whether accounts are deleted or disabled when an [[identity]] is terminated',
        terminationActionDelete: 'DELETE',
        terminationActionDisable: 'DISABLE',
        connectorCapabilityBanner: 'This connector type ({{type}}) does not support automated account lifecycle operations. Accounts must be created, disabled, and deleted manually in the [[target system]].',
        createSystem: 'Create system',
        createSuccess: '[[Target System]] created.',
        editName: 'Edit name',
        editNameTitle: 'Edit system name',
        editNameDescription: 'Update the display name of this [[target system]].',
        nameLabel: 'Name',
        nameUpdated: 'System name updated.',
        ownersTitle: 'Owners',
        ownersDescription: '[[Parties]] responsible for this [[target system]].',
        noOwners: 'No owners assigned to this [[target system]].',
        deleteSystem: 'Delete system',
        deleteConfirmTitle: 'Delete [[target system]]?',
        deleteConfirmDescription: 'This will permanently remove "{{name}}". The system can only be deleted when it has no [[resources]], [[enforcement objects]], or accounts.',
        deleteSuccess: '[[Target System]] deleted.',
        pickType: 'Pick a system type',
        pickTypePrompt: 'Choose the system type to create.',
    },
    resources: {
        title: '[[Resources]]',
        pageTitle: '[[Resources]] | [[target systems]]',
        subtitle: 'View and manage protected [[resources]]',
        allResources: 'All [[resources]]',
        filterPlaceholder: 'Filter [[resources]]...',
        resourceCount: '{{count}} [[resource]](s)',
        resourceName: '[[Resource]] Name',
        resourceType: '[[Resource]] [[type]]',
        targetSystem: '[[Target System]]',
        noResourcesMatch: 'No [[resources]] match your filter.',
        noResourcesFound: 'No [[resources]] found.',
        loadingResources: 'Loading [[resources]]...',
        errorLoading: 'Error loading [[resources]]. Please try again.',
        detailPageTitle: '[[Resource]] Details | [[target systems]]',
        subtitleView: 'View and manage protected [[resources]]',
        searchByName: 'Search by name...',
        filterBySystem: 'Filter by system...',
        allClassifications: 'All classifications',
        resourceCount_one: '{{count}} [[resource]]',
        resourceCount_other: '{{count}} [[resources]]',
        system: 'System',
        loadingResource: 'Loading [[resource]]...',
        errorLoadingResource: 'Error loading [[resource]]. Please try again.',
        configAndMetadata: 'Configuration and metadata',
        nativeKey: 'Native key',
        dataClassification: 'Data classification',
        createResource: 'Create [[resource]]',
        createSuccess: '[[Resource]] created.',
        editDisplayName: 'Edit name',
        editDisplayNameTitle: 'Edit [[resource]] name',
        editDisplayNameDescription: 'Update the display name of this [[resource]].',
        displayNameLabel: 'Display name',
        displayNameUpdated: '[[Resource]] name updated.',
        deleteResource: 'Delete [[resource]]',
        deleteConfirmTitle: 'Delete [[resource]]?',
        deleteConfirmDescription: 'This will permanently remove "{{name}}". The [[resource]] can only be deleted when it has no child [[resources]] or [[enforcement objects]].',
        deleteSuccess: '[[Resource]] deleted.',
        pickType: 'Pick a [[resource]] type',
        pickTypePrompt: 'Choose the [[resource]] type to create.',
        enforcementObjectCount: '{{count}} [[enforcement objects]] in this [[resource]]',
        enforcementObjectCount_one: '{{count}} [[enforcement object]] in this [[resource]]',
        enforcementObjectCount_other: '{{count}} [[enforcement objects]] in this [[resource]]',
        noEnforcementObjects: 'No [[enforcement objects]] found for this [[resource]].',
        owners: 'Owners',
        ownerCount: '{{count}} owners assigned to this [[resource]]',
        ownerCount_one: '{{count}} owner assigned to this [[resource]]',
        ownerCount_other: '{{count}} owners assigned to this [[resource]]',
        noOwners: 'No owners assigned to this [[resource]].',
        responsibility: 'Responsibility',
        validTo: 'Valid to',
        menuDescription: 'Protected [[resources]] and entitlements',
        resourceDetails: '[[Resource]] Details',
        enforcementObjects: '[[Enforcement Objects]]',
        parentResource: 'Parent [[resource]]',
        children: 'Children',
        childCount: '{{count}} child [[resources]]',
        childCount_one: '{{count}} child [[resource]]',
        childCount_other: '{{count}} child [[resources]]',
        noChildren: 'No child [[resources]].',
        ancestors: 'Ancestors',
        setParent: 'Set parent',
        removeParent: 'Remove parent',
        inheritedAccess: 'Inherited access',
        inheritedFrom: 'Inherited from',
        treeView: 'Tree view',
        rootResources: 'Root [[resources]]',
    },
    enforcementObjects: {
        title: '[[Enforcement Objects]]',
        pageTitle: '[[Enforcement Objects]] | [[target systems]]',
        subtitle: 'View [[enforcement objects]] (entitlements)',
        allEnforcementObjects: 'All [[enforcement objects]]',
        filterPlaceholder: 'Filter [[enforcement objects]]...',
        enforcementObjectCount: '{{count}} [[enforcement object]](s)',
        objectName: 'Name',
        objectType: '[[Type]]',
        resource: '[[Resource]]',
        targetSystem: '[[Target System]]',
        noObjectsMatch: 'No [[enforcement objects]] match your filter.',
        noObjectsFound: 'No [[enforcement objects]] found.',
        loadingObjects: 'Loading [[enforcement objects]]...',
        errorLoading: 'Error loading [[enforcement objects]]. Please try again.',
        detailPageTitle: '[[Enforcement Object]] Details | [[target systems]]',
        subtitleExtended: 'View and manage [[enforcement objects]] (entitlements, [[roles]], permissions)',
        searchByName: 'Search by name...',
        filterBySystem: 'Filter by system...',
        filterByResource: 'Filter by [[resource]]...',
        enforcementObjectCount_one: '{{count}} [[enforcement object]]',
        enforcementObjectCount_other: '{{count}} [[enforcement objects]]',
        externalId: 'External ID',
        externalIdentifier: 'External identifier',
        enforcementType: 'Enforcement [[type]]',
        loadingObject: 'Loading [[enforcement object]]...',
        errorLoadingObject: 'Error loading [[enforcement object]]. Please try again.',
        technicalConfig: 'Technical configuration and identifiers',
        relatedEntities: 'Related entities',
        systemAndResourceAssociations: 'System and [[resource]] associations',
        notLinkedToResource: 'Not linked to a [[resource]]',
        accessProfiles: '[[Access Profiles]]',
        accessProfilesDesc: '[[Access Profiles]] that include this [[enforcement object]]',
        noAccessProfiles: 'No [[access profiles]] linked to this [[enforcement object]].',
        noSystemsFound: 'No systems found.',
        noResourcesFound: 'No [[resources]] found.',
        menuDescription: '[[Enforcement Objects]] and entitlements',
        objectDetails: '[[Enforcement Object]] Details',
    },
    identityManagement: {
        title: '[[Identity Management]]',
        subtitle: 'Manage [[parties]], [[identities]], and their lifecycle',
        parties: '[[Parties]]',
        identities: '[[Identities]]',
        accounts: 'Accounts',
        onboarding: 'Onboarding',
        selectOption: 'Select an option from the menu to get started.',
    },
    targetSystemsResources: {
        title: '[[Target Systems]] & [[resources]]',
        subtitle: 'View and manage [[target systems]], [[resources]], and entitlements',
        systems: 'Systems',
        resources: '[[Resources]]',
        enforcementObjects: '[[Enforcement Objects]]',
        selectOption: 'Select an option from the menu to get started.',
    },
    accessGovernance: {
        title: '[[Access Governance]]',
        pageTitle: '[[Access Governance]]',
        subtitle: 'Manage [[access profiles]], rules, and [[access requests]]',
        sectionAccess: 'Access',
        sectionPolicies: 'Policies & Rules',
        sectionCertifications: 'Certifications',
        sectionRestrictions: 'Restrictions',
        accessProfiles: '[[Access Profiles]]',
        accessProfilesDesc: 'Requestable access bundles',
        functionGroups: '[[Function Groups]]',
        functionGroupsDesc: 'Bundles of [[access profiles]] assigned as a unit',
        autoAssignRules: '[[Auto-Assign Rules]]',
        autoAssignRulesDesc: 'Automatic access rules',
        autoAssignRuleRequests: '[[Auto-assign rule requests]]',
        autoAssignRuleRequestsDesc: '[[Request]] rule changes',
        accessRequests: '[[Access requests]]',
        accessRequestsDesc: 'Manage [[access requests]]',
        approvalPolicies: '[[Approval Policies]]',
        approvalPoliciesDesc: '[[Approval]] routing rules',
        certificationCampaigns: 'Certification [[campaigns]]',
        certificationCampaignsDesc: 'Access certification [[campaigns]]',
        certificationReviews: 'My reviews',
        certificationReviewsDesc: 'Review assigned certifications',
        certificationPolicies: '[[Certification Policies]]',
        certificationPoliciesDesc: 'Review policy configuration',
        restrictionRules: '[[Restriction Rules]]',
        restrictionRulesDesc: 'Separation of Duty enforcement',
        restrictionRuleRequests: '[[Restriction rule requests]]',
        restrictionRuleRequestsDesc: 'Governance [[requests]] for [[restriction rules]]',
        violationsDashboard: 'Violations dashboard',
        violationsDashboardDesc: 'Cross-rule violation overview',
        certificationDashboard: 'Certification dashboard',
        certificationDashboardDesc: 'Certification overview',
        functionGroupRequests: '[[Function group requests]]',
        functionGroupRequestsDesc: '[[Function group requests]]',
        delegations: 'Delegations',
        delegationsDesc: 'Deputy delegation management',
        selectOption: 'Select an option from the menu to get started.',
    },
    approvalPolicies: {
        title: '[[Approval Policies]]',
        pageTitle: '[[Approval Policies]] | [[access governance]]',
        createPageTitle: 'Create [[approval policy]] | [[access governance]]',
        detailPageTitle: '[[Approval Policy]] Details | [[access governance]]',
        editPageTitle: 'Edit [[approval policy]] | [[access governance]]',
        subtitle: 'Manage [[approval]] routing policies for [[access requests]]',
        allPolicies: 'All [[approval policies]]',
        policiesCount: '{{count}} policies',
        noPoliciesFound: 'No [[approval policies]] found.',
        createPolicy: 'Create policy',
        createDescription: 'Define a new [[approval]] routing policy',
        createCardTitle: 'Policy details',
        createCardDesc: 'Configure the policy, conditions, and [[approval steps]]',
        editPolicy: 'Edit policy',
        editDescription: 'Modify the [[approval]] routing policy',
        deletePolicy: 'Delete policy',
        deleteConfirm: 'Are you sure you want to delete the policy "{{name}}"? This action cannot be undone.',
        cannotDeleteDefault: 'Default policies cannot be deleted.',
        loadingPolicy: 'Loading policy...',
        loadingPolicies: 'Loading policies...',
        errorLoadingPolicy: 'Error loading policy. Please try again.',
        errorLoading: 'Error loading policies. Please try again.',
        name: 'Name',
        namePlaceholder: 'e.g., High Risk [[approval]]',
        description: 'Description',
        descriptionPlaceholder: 'Describe when this policy applies...',
        priority: 'Priority',
        priorityPlaceholder: 'e.g., 10',
        priorityHelp: 'Lower number = higher priority. The first matching policy wins.',
        active: 'Active',
        activeDesc: 'Inactive policies are not evaluated',
        validFrom: 'Valid from',
        validTo: 'Valid to',
        isDefault: 'Default',
        defaultBadge: 'Default',
        conditions: 'Conditions',
        conditionsDesc: 'When does this policy apply? Empty conditions match all [[requests]].',
        conditionsCount: '{{count}} condition(s)',
        noConditions: 'No conditions (matches all [[requests]])',
        addCondition: 'Add condition',
        field: 'Field',
        operator: 'Operator',
        value: 'Value',
        conditionValuePlaceholder: 'e.g., HIGH',
        defaultResolverParam: 'APPLICATION_OWNER',
        steps: '[[Approval Steps]]',
        stepsDesc: 'Who approves? Steps are evaluated in order.',
        stepsCount: '{{count}} step(s)',
        addStep: 'Add step',
        stepOrder: 'Order',
        resolverType: 'Resolver',
        resolverParam: 'Parameter',
        approvalStrategy: 'Strategy',
        required: 'Required',
        requiredDesc: 'Fail if no approvers found',
        moveUp: 'Move up',
        moveDown: 'Move down',
        removeStep: 'Remove step',
        removeCondition: 'Remove condition',
        atLeastOneStep: 'At least one [[approval step]] is required.',
        policyType: 'Policy [[type]]',
        policyTypeLabels: {
            ACCESS_PROFILE: '[[Access Profile]]',
            FUNCTION_GROUP: '[[Function Group]]',
            AUTO_ASSIGN_RULE: '[[Auto-Assign Rule]]',
            RESTRICTION_RULE: '[[Restriction Rule]]',
        },
        allPolicyTypes: 'All Policy [[types]]',
        incompatibleConditionsRemoved: 'Incompatible conditions and steps removed',
        fieldLabels: {
            RISK_LEVEL: 'Risk level',
            RESOURCE_TYPE: '[[Resource]] [[type]]',
            DATA_CLASSIFICATION: 'Data classification',
            FUNCTION_GROUP_TYPE: '[[Function Group]] [[type]]',
            OWNER_PARTY: 'Owner [[party]]',
        },
        operatorLabels: {
            EQUALS: 'Equals',
            NOT_EQUALS: 'Not equals',
            IN: 'In (comma-separated)',
        },
        resolverTypeLabels: {
            RESOURCE_OWNER: '[[Resource]] Owner',
            PROFILE_OWNER: 'Profile owner',
            MANAGER: 'Manager',
            SPECIFIC_IDENTITY: 'Specific [[identity]]',
            TEAM_MEMBER: 'Team member',
            FUNCTION_GROUP_OWNER: '[[Function Group]] Owner',
            RULE_OWNER: 'Rule owner',
        },
        resolverParamPlaceholder: {
            RESOURCE_OWNER: 'e.g., APPLICATION_OWNER',
            PROFILE_OWNER: 'e.g., BUSINESS_OWNER',
            SPECIFIC_IDENTITY: '[[Identity]] UUID',
            TEAM_MEMBER: 'Search for a team...',
        },
        strategyLabels: {
            ANY: 'Any (1 of N)',
            ALL: 'All must approve',
        },
        createdAt: 'Created',
        updatedAt: 'Last updated',
        version: 'Version',
        policyDetails: 'Policy details',
        policyDetailsDesc: 'General policy configuration',
        policyCreated: '[[Approval]] policy created successfully.',
        policyUpdated: '[[Approval]] policy updated successfully.',
        policyDeleted: '[[Approval]] policy deleted successfully.',
    },
    accessProfiles: {
        title: '[[Access Profiles]]',
        pageTitle: '[[Access Profiles]] | [[access governance]]',
        createPageTitle: 'Create [[access profile]] | [[access governance]]',
        detailPageTitle: '[[Access Profile]] Details | [[access governance]]',
        editPageTitle: 'Edit [[access profile]] | [[access governance]]',
        subtitle: 'Manage requestable access bundles (entitlement packages)',
        allProfiles: 'All [[access profiles]]',
        createProfile: 'Create profile',
        editProfile: 'Edit [[access profile]]',
        deleteProfile: 'Delete [[access profile]]',
        filterPlaceholder: 'Filter [[access profiles]]...',
        searchByName: 'Search by name...',
        filterByResource: 'Filter by [[resource]]...',
        allStatuses: 'All statuses',
        allEnvironments: 'All environments',
        allRisks: 'All risks',
        profileCount: '{{count}} [[access profile]](s)',
        profilesCount: '{{count}} profile(s)',
        profileName: 'Profile name',
        noProfilesMatch: 'No [[access profiles]] match your filters.',
        noProfilesFound: 'No [[access profiles]] found.',
        loadingProfiles: 'Loading [[access profiles]]...',
        loadingProfile: 'Loading [[access profile]]...',
        errorLoading: 'Error loading [[access profiles]]. Please try again.',
        errorLoadingProfile: 'Error loading [[access profile]]. Please try again.',
        profileDetails: 'Profile details',
        profileDetailsDesc: '[[Access Profile]] configuration and governance settings',
        enforcementObjects: '[[Enforcement Objects]]',
        noEnforcementObjects: 'No [[enforcement objects]] assigned.',
        deleteConfirm: 'Are you sure you want to delete "{{name}}"? This action cannot be undone.',
        createDescription: 'Define a new [[access profile]] for [[resource]] protection',
        createCardTitle: 'Profile details',
        createCardDesc: 'Configure the [[access profile]] settings and governance rules',
        editDescription: 'Update the [[access profile]] settings and governance rules',
        code: 'Code',
        codePlaceholder: 'e.g. mdr-employee-access',
        codeDesc: 'Unique identifier: lowercase letters, numbers, and hyphens (3-100 chars). Auto-suggested from name.',
        namePlaceholder: 'Enter profile name',
        descriptionPlaceholder: 'Enter profile description',
        selectEnforcementObjects: 'Select [[enforcement objects]]',
        riskLevel: 'Risk level',
        owner: 'Owner',
        ownerPartyDesc: 'The [[party]] responsible for this [[access profile]]',
        searchOwnerParty: 'Search for owner [[party]]...',
        noPartiesFound: 'No [[parties]] found. [[type]] to search.',
        approvalRequired: '[[Approval]] Required',
        step: 'Step {{number}}',
        basicInfo: 'Basic information',
        selectItems: 'Select items',
        review: 'Review',
        next: 'Next',
        previous: 'Previous',
        resource: '[[Resource]]',
        environment: 'Environment',
        selectResourceEnv: 'Select a [[resource]] to see environment',
        risk: 'Risk',
        requestable: 'Requestable',
        requestableDesc: 'Users can [[request]] this [[access profile]]',
        autoAssignable: 'Auto-Assignable',
        autoAssignableDesc: 'Can be automatically assigned by rules',
        expiryRequired: 'Expiry required',
        expiryRequiredDesc: 'Assignments must have an expiry date',
        maxDuration: 'Max duration',
        maxDurationDays: '{{days}} days',
        maxDurationLabel: 'Maximum Duration (days) *',
        maxDurationPlaceholder: 'Enter max duration in days',
        reviewFrequencyDays: 'Review frequency',
        reviewFrequencyMonthly: 'Monthly (30 days)',
        reviewFrequencyBimonthly: 'Bimonthly (60 days)',
        reviewFrequencyQuarterly: 'Quarterly (90 days)',
        reviewFrequencySemiAnnual: 'Semi-Annual (180 days)',
        reviewFrequencyAnnual: 'Annual (365 days)',
        selectRiskLevel: 'Select risk level',
        selectReviewFrequency: 'Select review frequency',
        searchResource: 'Search for a [[resource]]...',
        noResourcesFound: 'No [[resources]] found.',
        owners: 'Owners',
        ownersCount: '{{count}} owner(s) responsible for this profile',
        party: '[[Party]]',
        responsibility: 'Responsibility',
        noOwners: 'No owners assigned to this profile.',
        boundCount: '{{count}} [[enforcement object]](s) bound to this profile',
        addEnforcementObject: 'Add [[enforcement object]]',
        addBindings: 'Add bindings',
        addBindingsDesc: 'Select [[enforcement objects]] to bind to this [[access profile]].',
        filterEnforcementObjects: 'Filter [[enforcement objects]]...',
        loadingEnforcementObjects: 'Loading [[enforcement objects]]...',
        noAvailableEnforcementObjects: 'No available [[enforcement objects]] for this [[resource]].',
        noEnforcementObjectsMatch: 'No [[enforcement objects]] match your filter.',
        selectedCount: '{{count}} [[enforcement object]](s) selected',
        operationLabel: 'Operation (applied to all selected)',
        selectOperation: 'Select operation',
        addBindingsButton: 'Add {{count}} Binding(s)',
        adding: 'Adding...',
        removeBinding: 'Remove binding',
        removeBindingConfirm: 'Are you sure you want to remove this binding? This action cannot be undone.',
        removing: 'Removing...',
        remove: 'Remove',
        activateProfile: 'Activate [[access profile]]',
        activateConfirm: 'Are you sure you want to activate "{{name}}"? This will make the profile available for assignment.',
        activating: 'Activating...',
        activate: 'Activate',
        deprecateProfile: 'Deprecate [[access profile]]',
        deprecateConfirm: 'Are you sure you want to deprecate "{{name}}"? Deprecated profiles cannot be newly assigned but existing assignments remain active.',
        deprecating: 'Deprecating...',
        deprecate: 'Deprecate',
        system: 'System',
        createError: 'Failed to create [[access profile]]',
        updateError: 'Failed to update [[access profile]]',
        profileCreated: '[[Access Profile]] created successfully.',
        profileUpdated: '[[Access Profile]] updated successfully.',
        profileDeleted: '[[Access Profile]] deleted successfully.',
        profileActivated: '[[Access Profile]] activated successfully.',
        profileDeprecated: '[[Access Profile]] deprecated successfully.',
        bindingAdded: 'Binding added successfully.',
        bindingRemoved: 'Binding removed successfully.',
    },
    autoAssignRules: {
        title: '[[Auto-Assign Rules]]',
        pageTitle: '[[Auto-Assign Rules]] | [[access governance]]',
        detailPageTitle: '[[Auto-Assign Rule]] Details | [[access governance]]',
        executionsPageTitle: 'Rule [[executions]] | [[access governance]]',
        subtitle: 'Rules that automatically assign [[access profiles]] to [[identities]] based on conditions',
        allRules: '[[Auto-Assign Rules]]',
        createRule: 'Create rule',
        editRule: 'Edit rule',
        deleteRule: 'Delete rule',
        filterPlaceholder: 'Filter rules...',
        searchByName: 'Search by name...',
        ruleCount: '{{count}} rule(s)',
        ruleName: 'Rule name',
        accessProfile: '[[Access Profile]]',
        functionGroupLabel: '[[Function Group]]',
        condition: 'Condition',
        priority: 'Priority',
        profiles: 'Profiles',
        columnType: 'Type',
        columnTarget: 'Target',
        targetProfileCount: '{{count}} [[access profile]]',
        targetProfileCount_other: '{{count}} [[access profiles]]',
        owner: 'Owner',
        risk: 'Risk',
        version: 'Version',
        activeOnly: 'Active only',
        allStatus: 'All status',
        activeRulesOnly: 'Active rules only',
        noRulesMatch: 'No [[auto-assign rules]] match your filters.',
        noRulesFound: 'No [[auto-assign rules]] found.',
        loadingRules: 'Loading [[auto-assign rules]]...',
        loadingRule: 'Loading [[auto-assign rule]]...',
        errorLoading: 'Error loading [[auto-assign rules]]. Please try again.',
        errorLoadingRule: 'Error loading [[auto-assign rule]]. Please try again.',
        ruleDetails: 'Rule details',
        ruleDetailsDesc: '[[Auto-Assign Rule]] configuration',
        conditionExpression: 'Condition expression',
        conditionExpressionDesc: 'Rule that determines which [[identities]] receive access',
        accessProfiles: '[[Access Profiles]]',
        accessProfilesCount: '{{count}} [[access profile]](s) assigned by this rule',
        noAccessProfiles: 'No [[access profiles]] linked to this rule.',
        deleteConfirm: 'Are you sure you want to delete the rule "{{name}}"? This action cannot be undone.',
        testRule: 'Test rule',
        testing: 'Testing...',
        testResults: 'Test results',
        testResultsDesc: 'Preview of how this rule would affect [[identities]]',
        testFailed: 'Test failed',
        evaluated: 'Evaluated',
        matched: 'Matched',
        toAdd: 'To add',
        toRemove: 'To remove',
        viewAffectedIdentities: 'View Affected [[identities]] ({{count}})',
        ruleInformation: 'Rule information',
        ruleId: 'Rule ID',
        removalGraceDays: 'Removal grace days',
        removalGraceDaysValue: '{{days}} days',
        userRiskScore: 'User risk score',
        profileCount: 'Profile count',
        versionHistory: 'Version history',
        versionByAuthor: ' by {{name}}',
        createRequestError: 'Failed to create [[request]]',
        noVersionHistory: 'No version history available.',
        current: 'Current',
        executions: '[[Executions]]',
        executionHistory: '[[Execution]] History',
        noExecutionsYet: 'No [[executions]] yet.',
        viewAllExecutions: 'View all {{count}} [[executions]]',
        lastExecution: 'Last [[execution]]',
        nextExecution: 'Next [[execution]]',
        runNow: 'Run now',
        running: 'Running...',
        expression: 'Expression',
        allExecutions: 'All [[executions]]',
        executionCount: '{{count}} [[execution]](s)',
        executionId: '[[Execution]] ID',
        startedAt: 'Started at',
        completedAt: 'Completed at',
        duration: 'Duration',
        assignmentsCreated: 'Assignments created',
        noExecutionsFound: 'No [[executions]] found.',
        loadingExecutions: 'Loading [[executions]]...',
        errorLoadingExecutions: 'Error loading [[executions]]. Please try again.',
        triggerExecution: 'Trigger [[execution]]',
        triggerDescription: 'Run this rule now to evaluate and create assignments.',
        triggering: 'Triggering...',
        affectedIdentities: 'Affected [[identities]]',
        affectedIdentitiesDesc: 'Preview of which [[identities]] would be affected by this rule',
        searchIdentities: 'Search [[identities]]...',
        noIdentitiesMatch: 'No [[identities]] match your filters.',
        identity: '[[Identity]]',
        party: '[[Party]]',
        action: 'Action',
        activateRule: 'Activate rule',
        activateRuleDesc: 'Create a [[request]] to activate the rule "{{name}}". The [[request]] will need to be approved before the rule becomes active.',
        createActivateRequest: 'Create Activate [[request]]',
        deactivateRule: 'Deactivate rule',
        deactivateRuleDesc: 'Create a [[request]] to deactivate the rule "{{name}}". The [[request]] will need to be approved before the rule becomes inactive. [[identities]] will no longer receive access from this rule once deactivated.',
        createDeactivateRequest: 'Create Deactivate [[request]]',
        error: 'Error',
        creating: 'Creating...',
        ruleExecutionHistory: 'Rule [[execution]] History',
        executionsForRule: '[[Executions]] for rule: {{name}}',
        viewAllRuleExecutions: 'View all [[auto-assign rule]] [[executions]]',
        filters: 'Filters:',
        allStatuses: 'All statuses',
        statusSelectedCount: '{{count}} selected',
        success: 'Success',
        partial: 'Partial',
        failed: 'Failed',
        rule: 'Rule',
        executedAt: 'Executed at',
        added: 'Added',
        removed: 'Removed',
        showingOfExecutions: 'Showing {{count}} of {{total}} [[executions]]',
        noExecutions: 'No [[executions]] found.',
        previous: 'Previous',
        next: 'Next',
        requestCreated: 'Rule [[request]] created successfully.',
        ruleNoOwner: 'Cannot submit: rule has no owner. Assign an owner [[party]] to the rule before submitting.',
        impactAnalysis: {
            title: 'Impact analysis',
            description: 'Preview the additions and removals this rule would produce against a sample of [[identities]]. No assignments are written.',
            runButton: 'Run impact analysis',
            opening: 'Open impact analysis',
            running: 'Analyzing...',
            filterTitle: '[[Identity]] Sample',
            identityTypeCode: '[[Identity]] [[type]] Code',
            identityTypeCodePlaceholder: 'e.g. WORKFORCE',
            lifecycleState: 'Lifecycle state',
            lifecycleStateAny: 'Any',
            maxIdentities: 'Max [[identities]]',
            maxIdentitiesHint: '1 to 10000 (default 1000)',
            counts: 'Evaluated {{evaluated}} • Add {{add}} • Remove {{remove}} • Unchanged {{unchanged}}',
            truncatedWarning: 'Sample was truncated to the cap. Increase Max [[identities]] or refine the filter to see more.',
            empty: 'No additions or removals — this rule would have no effect on the sample.',
            errorTitle: 'Impact analysis failed',
            unknownError: 'Unknown error',
            tableIdentity: '[[Identity]]',
            tableProfile: '[[Access Profile]]',
            tableAction: 'Action',
            tableSourceRule: 'Source rule',
            actionAdd: 'Add',
            actionRemove: 'Remove',
            close: 'Close',
        },
        triggerFullEvaluation: {
            buttonLabel: 'Trigger full evaluation',
            confirmTitle: 'Trigger Full Auto-Assign Evaluation',
            confirmBody: 'Run the start-of-day [[job]] now? It evaluates every active [[auto-assign rule]] against every active [[identity]] and writes the resulting changes. A new [[execution]] log row will appear.',
            confirmButton: 'Trigger',
            running: 'Triggering...',
            successToast: 'Full evaluation triggered. Check the [[executions]] tab for progress.',
            errorToast: 'Failed to trigger the full evaluation.',
        },
    },
    autoAssignRuleRequests: {
        title: '[[Auto-Assign Rules]]',
        openRequestExists: 'A change [[request]] is already in progress for this rule.',
        pageTitle: 'Rule [[requests]] | [[access governance]]',
        createPageTitle: 'Create Rule [[request]] | [[access governance]]',
        editPageTitle: 'Edit Rule [[request]] | [[access governance]]',
        detailPageTitle: 'Rule [[request]] Details | [[access governance]]',
        subtitle: 'Manage automatic [[access profile assignments]] based on [[identity]] conditions',
        allRequests: '[[Auto-assign rule requests]]',
        createRequest: 'Create [[request]]',
        editRequest: 'Edit Rule [[request]]',
        filterPlaceholder: 'Filter rule [[requests]]...',
        searchByName: 'Search by name...',
        requestCount: '{{count}} [[request]](s)',
        requestCountWithFilter: '{{count}} [[request]](s) matching filters',
        requestType: '[[Request]] [[type]]',
        requestStatus: '[[Request]] Status',
        requestedBy: 'Requested by',
        requestedAt: 'Requested at',
        noRequestsMatch: 'No rule [[requests]] match your filters.',
        noRequestsFound: 'No rule [[requests]] found. Create one to get started.',
        loadingRequests: 'Loading rule [[requests]]...',
        loadingRequest: 'Loading rule [[request]]...',
        errorLoading: 'Error loading rule [[requests]]. Please try again.',
        errorLoadingRequest: 'Error loading rule [[request]]. Please try again.',
        requestDetails: '[[Request]] Details',
        requestDetailsDesc: '[[Auto-Assign Rule]] configuration',
        createDescription: 'Define a new [[auto-assign rule]] for automatic access provisioning',
        updateDescription: 'Create a [[request]] to update "{{name}}"',
        editDescription: 'Modify the rule configuration before submitting for [[approval]]',
        approveRequest: 'Approve [[request]]',
        approveDesc: 'Approving this [[request]] will create/update the [[auto-assign rule]]. This action cannot be undone.',
        rejectRequest: 'Reject [[request]]',
        rejectDesc: 'Please provide a reason for rejecting this [[request]]. The requester will be notified.',
        rejectionReason: 'Reason for Rejection *',
        rejectionReasonPlaceholder: 'Explain why this [[request]] is being rejected...',
        approving: 'Approving...',
        rejecting: 'Rejecting...',
        selectAccessProfile: 'Select [[access profile]]',
        selectRuleType: 'Select [[request]] type',
        wizardTitle: 'Create Rule [[request]]',
        wizardUpdateTitle: 'Update Rule [[request]]',
        wizardEditTitle: 'Edit: {{name}}',
        defaultName: 'Rule [[request]]',
        theRule: 'the rule',
        wizardStep1: '[[Request]] [[type]]',
        wizardStep2: 'Rule details',
        wizardStep3: 'Review & Submit',
        newRule: 'New rule',
        modifyRule: 'Modify rule',
        activateRule: 'Activate rule',
        deactivateRule: 'Deactivate rule',
        createNewRule: 'Create new rule',
        modifyExistingRule: 'Modify existing rule',
        draft: 'Draft',
        pendingApproval: 'Pending [[approval]]',
        approved: 'Approved',
        rejected: 'Rejected',
        submitForApproval: 'Submit for [[approval]]',
        submitDesc: 'This will submit the rule [[request]] for [[approval]]. Once submitted, you will not be able to edit it until it is approved or rejected.',
        deleteRequest: 'Delete [[request]]',
        deleteConfirm: 'Are you sure you want to delete this rule [[request]]? This action cannot be undone.',
        commentOptional: 'Comment (optional)',
        commentPlaceholder: 'Add an optional comment...',
        workflow: 'Workflow',
        reviewedBy: 'Reviewed by',
        reviewedAt: 'Reviewed at',
        reviewComment: 'Review comment',
        targetRuleId: 'Target Rule ID',
        expressionDesc: '[[Identities]] matching this condition will receive the [[access profiles]]',
        profilesAssignDesc: 'Profiles that will be assigned when the rule matches',
        noProfilesLinked: 'No [[access profiles]] linked to this [[request]].',
        wouldBeAdded: 'Would be added',
        wouldBeRemoved: 'Would be removed',
        unchanged: 'Unchanged',
        showingIdentities: 'Showing {{filtered}} of {{total}} [[identities]]',
        cannotEdit: 'This [[request]] cannot be edited because it is in {{status}} status.',
        loadingRuleData: 'Loading rule data...',
        ruleNameLabel: 'Rule Name *',
        ruleNamePlaceholder: 'e.g., All Employees - Basic Access',
        descriptionPlaceholder: 'Describe what this rule does...',
        ownerPartyLabel: 'Owner [[party]] *',
        ownerPartyDesc: 'The [[party]] responsible for this rule',
        searchOwnerParty: 'Search for owner [[party]]...',
        noPartiesFound: 'No [[parties]] found. [[type]] to search.',
        priorityLabel: 'Priority',
        priorityPlaceholder: 'e.g., 10',
        priorityDesc: 'Lower values are evaluated first (1 = highest priority)',
        removalGraceDaysLabel: 'Removal grace days',
        removalGraceDaysPlaceholder: 'e.g., 7',
        removalGraceDaysDesc: 'Days before access is removed',
        userRiskLabel: 'User risk score',
        userRiskDesc: 'Optional, 0–100',
        conditionExprLabel: 'Condition Expression *',
        conditionExprPlaceholder: "[[Identity]].type == 'WORKFORCE' && [[identity]].lifecycleState == 'ACTIVE'",
        showHelp: 'Show help',
        hideHelp: 'Hide help',
        expressionValid: 'Expression is valid',
        errorAtPosition: ' (position {{position}})',
        testYourExpression: 'Test your expression to see which [[identities]] match before continuing.',
        runTest: 'Run test',
        testCompleted: 'Test completed',
        testCompletedDesc: 'Evaluated {{total}} [[identities]], {{matched}} matched your expression.',
        expressionBeingTested: 'Expression being tested:',
        accessProfilesLabel: '[[Access Profiles]] *',
        accessProfilesDesc: 'Select the [[access profiles]] that will be assigned when [[identities]] match the rule condition. Only auto-assignable profiles are shown.',
        searchProfilesToAdd: 'Search [[access profiles]] to add...',
        noAutoAssignableProfiles: 'No auto-assignable profiles found',
        selectAtLeastOneProfile: 'Search and select at least one [[access profile]]',
        reviewRuleName: 'Rule name',
        reviewOwner: 'Owner',
        notSelected: 'Not selected',
        reviewConditionExpression: 'Condition expression',
        reviewAccessProfiles: '[[Access Profiles]] ({{count}})',
        noProfilesFound: 'No profiles found',
        ruleConfiguration: 'Rule configuration',
        ruleConfigurationUpdateDesc: 'Modify the rule configuration. Changes will require [[approval]] before taking effect.',
        ruleConfigurationCreateDesc: 'Configure the rule condition and [[access profiles]] to be assigned',
        viewCount: 'View ({{count}})',
        allCount: 'All ({{count}})',
        addCount: 'Add ({{count}})',
        removeCount: 'Remove ({{count}})',
        unchangedCount: 'Unchanged ({{count}})',
        reviewMatchedOfTotal: '{{matched}} of {{total}} [[identities]] matched',
        reviewWouldBeAdded: '({{count}} would be added)',
        failedToCreateRequest: 'Failed to create rule [[request]]',
        failedToUpdateRequest: 'Failed to update rule [[request]]',
        requestCreated: 'Rule [[request]] created successfully.',
        requestUpdated: 'Rule [[request]] updated successfully.',
        requestSubmitted: 'Rule [[request]] submitted for [[approval]].',
        requestApproved: 'Rule [[request]] approved successfully.',
        requestRejected: 'Rule [[request]] rejected.',
        requestDeleted: 'Rule [[request]] deleted successfully.',
        matchedPolicy: 'Matched Policy: {{name}}',
        ruleTypeLabel: 'Rule [[type]] *',
        accessProfileRule: '[[Access Profile]]',
        functionGroupRule: '[[Function Group]]',
        ruleTypeDesc: 'Choose whether this rule assigns [[access profiles]] or [[function groups]]',
        functionGroupsLabel: '[[Function Groups]] *',
        functionGroupsDesc: 'Select the [[function groups]] that will be assigned when [[identities]] match the rule condition. Only auto-assignable [[function groups]] are shown.',
        searchFunctionGroupsToAdd: 'Search [[function groups]] to add...',
        noAutoAssignableFunctionGroups: 'No auto-assignable [[function groups]] found',
        selectAtLeastOneFunctionGroup: 'Search and select at least one [[function group]]',
        reviewFunctionGroups: '[[Function Groups]] ({{count}})',
        stepBasicInfo: 'Basic info',
        stepBasicInfoDesc: 'Name and configuration',
        stepExpression: 'Expression',
        stepExpressionDesc: 'Define condition',
        stepTest: 'Test',
        stepTestDesc: 'Validate rule',
        stepProfiles: 'Profiles',
        stepProfilesDesc: 'Select access',
        stepFunctionGroups: '[[Function Groups]]',
        stepFunctionGroupsDesc: 'Select [[function groups]]',
        stepReview: 'Review',
        stepReviewDesc: 'Confirm & create',
        expressionDescFunctionGroup: '[[Identities]] matching this condition will receive the [[function groups]]',
        functionGroupsAssignDesc: '[[Function Groups]] that will be assigned when the rule matches',
        noFunctionGroupsLinked: 'No [[function groups]] linked to this [[request]].',
    },
    accessRequests: {
        title: '[[Access requests]]',
        pageTitle: '[[Access requests]] | [[access governance]]',
        detailPageTitle: '[[Access Request]] Details | [[access governance]]',
        newPageTitle: 'New [[access request]] | [[access governance]]',
        subtitle: 'All [[access requests]] in the system',
        allRequests: 'All [[access requests]]',
        createRequest: 'New [[request]]',
        filterPlaceholder: 'Filter [[access requests]]...',
        searchByBeneficiary: 'Search by beneficiary...',
        requestCount: '{{count}} [[access request]](s)',
        requester: 'Requester',
        beneficiary: 'Beneficiary',
        requestedFor: 'Requested for',
        requestStatus: 'Status',
        requestedAt: 'Requested at',
        noRequestsMatch: 'No [[access requests]] match your filter.',
        noRequestsFound: 'No [[access requests]] found',
        loadingRequests: 'Loading...',
        errorLoading: 'Failed to load [[access requests]]',
        requestDetails: '[[Request]] Details',
        items: 'Items',
        itemsPlusMore: '+{{count}} more',
        requestItems: '[[Request]] Items ({{count}})',
        approvalHistory: '[[Approval]] History',
        approvers: 'Approvers:',
        cancelRequest: 'Cancel [[request]]',
        cancelItem: 'Cancel item',
        cancelEntireRequest: 'Cancel Entire [[request]]',
        cancelReason: 'Reason (required)',
        cancelReasonPlaceholder: 'Provide a reason...',
        cancelling: 'Cancelling...',
        approveItem: 'Approve item',
        rejectItem: 'Reject item',
        commentOptional: 'Comment (optional)',
        commentPlaceholder: 'Add a comment...',
        reasonRequired: 'Reason (required)',
        rejectReasonPlaceholder: 'Provide a reason for rejection...',
        wizardTitle: 'New [[access request]]',
        wizardSelectIdentity: 'Select [[identity]]',
        wizardSelectProfiles: 'Select [[access profiles]]',
        wizardConfigure: 'Configure',
        wizardReviewSubmit: 'Review & Submit',
        whoNeedsAccess: 'Who needs access?',
        myself: 'Myself',
        someoneElse: 'Someone else',
        searchForIdentity: 'Search for [[identity]]',
        searchByName: 'Search by name...',
        selected: 'Selected:',
        selectAccessProfiles: 'Select [[access profiles]]',
        searchAccessProfiles: 'Search [[access profiles]]...',
        noProfilesFound: 'No profiles found',
        selectedCount: 'Selected ({{count}})',
        expiryRequired: 'Expiry required',
        expiresAtLabel: 'Expires at',
        maxDurationHint: 'Max duration: {{days}} days',
        reviewAndSubmit: 'Review & Submit',
        reviewBeneficiary: 'Beneficiary',
        reviewAccessProfiles: '[[Access Profiles]] ({{count}})',
        justification: 'Justification',
        justificationPlaceholder: 'Explain why this access is needed...',
        noProfilesSelected: 'No [[access profiles]] selected.',
        searchProfiles: 'Search [[access profiles]]...',
        untilDate: '(until {{date}})',
        submitting: 'Submitting...',
        submitRequest: 'Submit [[request]]',
        failedToCreate: 'Failed to create [[request]]: {{error}}',
        popularInDepartment: 'Popular in your department ({{count}})',
        peerRecommendations: 'Recommended based on your peers',
        allProfiles: 'All [[access profiles]]',
        setExpiration: 'Set expiration',
        expirationDate: 'Expiration date',
        expires: 'Expires:',
        showingRange: 'Showing {{start}}-{{end}} of {{total}}',
        cancelled: 'Cancelled:',
        statusSubmitted: 'Submitted',
        statusInProgress: 'In progress',
        statusCompleted: 'Completed',
        statusCancelled: 'Cancelled',
        statusPendingApproval: 'Pending [[approval]]',
        statusApproved: 'Approved',
        statusFulfilled: 'Fulfilled',
        statusRejected: 'Rejected',
        approving: 'Approving...',
        approve: 'Approve',
        rejecting: 'Rejecting...',
        cancellingItem: 'Cancelling...',
        cancellingRequest: 'Cancelling...',
        itemApproved: 'Item approved successfully.',
        itemRejected: 'Item rejected.',
        itemCancelled: 'Item cancelled successfully.',
        requestCancelled: '[[Request]] cancelled successfully.',
        requestSubmitted: '[[Access Request]] submitted successfully.',
        beneficiaries: 'Beneficiaries',
        searchBeneficiariesPlaceholder: 'Search beneficiaries…',
        beneficiariesCounter: '{{count}} / 50',
        beneficiariesMax: 'Maximum of 50 beneficiaries reached.',
        pickerNoResults: 'No [[identities]] found.',
        pickerHintTypeMore: '[[Type]] at least 2 characters to search.',
        reviewExpansion: '{{beneficiaries}} beneficiaries × {{items}} [[access profiles]] = {{total}} [[requests]]',
        bulkSuccess_one: '1 [[access request]] submitted.',
        bulkSuccess_other: '{{count}} [[access requests]] submitted.',
        bulkValidationFailed: 'Submission failed — no [[requests]] were created.',
        bulkErrorGeneric: 'An unexpected error occurred. Please try again.',
    },
    approvalChain: {
        title: '[[Approval]] Chain',
        stepLabel: 'Step {{step}}',
        strategy: 'Strategy',
        strategyAny: 'Any one approver',
        strategyAll: 'All approvers',
        statusPending: 'Pending',
        statusActive: 'Awaiting decision',
        statusApproved: 'Approved',
        statusRejected: 'Rejected',
        statusSkipped: 'Skipped',
        pending: 'pending',
        preliminary: 'preliminary — may change when step activates',
        matchedPolicy: 'Matched policy',
        resolverResourceOwner: '[[Resource]] Owner',
        resolverProfileOwner: 'Profile owner',
        resolverManager: 'Manager',
        resolverSpecificIdentity: 'Specific [[identity]]',
        resolverTeamMember: 'Team member',
        approved: 'approved',
        rejected: 'rejected',
    },
    myRequests: {
        title: 'My [[requests]]',
        pageTitle: 'My [[requests]]',
        subtitle: 'Access and [[function group requests]] you have submitted',
        tabAccessRequests: '[[Access requests]]',
        tabFunctionGroupRequests: '[[Function group requests]]',
        myAccessRequests: 'My [[access requests]]',
        accessRequestsSubmitted: '[[Access requests]] you have submitted',
        newRequest: 'New [[request]]',
        allRequests: 'All My [[requests]]',
        allAccessRequests: 'All [[access requests]]',
        allFunctionGroupRequests: 'All [[function group requests]]',
        accessRequestsDescription: '[[Access Profile]] [[requests]] you have submitted',
        functionGroupRequestsDescription: '[[Function group requests]] you have submitted',
        requestCount: '{{count}} [[request]](s)',
        accessRequestCount: '{{count}} [[access request]](s)',
        accessRequestCount_one: '{{count}} [[access request]]',
        accessRequestCount_other: '{{count}} [[access requests]]',
        functionGroupRequestCount: '{{count}} [[function group request]](s)',
        functionGroupRequestCount_one: '{{count}} [[function group request]]',
        functionGroupRequestCount_other: '{{count}} [[function group requests]]',
        filterStatus: 'Filter by status',
        allStatuses: 'All statuses',
        searchPlaceholder: 'Search beneficiary or justification...',
        filterPlaceholder: 'Filter [[requests]]...',
        noRequestsMatch: 'No [[requests]] match your filter.',
        noRequestsFound: "You haven't made any [[access requests]] yet.",
        noAccessRequestsFound: 'No [[access requests]] found',
        statusSubmitted: 'Submitted',
        statusInProgress: 'In progress',
        statusCompleted: 'Completed',
        statusCancelled: 'Cancelled',
        loadingRequests: 'Loading your [[requests]]...',
        failedToLoadRequests: 'Failed to load [[requests]]',
        errorLoading: 'Error loading your [[requests]]. Please try again.',
        previous: 'Previous',
        next: 'Next',
    },
    myApprovals: {
        title: 'My [[approvals]]',
        pageTitle: 'My [[approvals]]',
        subtitle: 'Review and approve [[access requests]]',
        searchPlaceholder: 'Search by justification, requester, beneficiary…',
        itemsPendingApproval: 'Items pending your [[approval]]',
        allApprovals: 'All Pending [[approvals]]',
        approvalCount: '{{count}} [[approval]](s)',
        filterPlaceholder: 'Filter [[approvals]]...',
        noApprovalsMatch: 'No [[approvals]] match your filter.',
        noApprovalsFound: 'No pending [[approvals]].',
        noPendingApprovals: 'No pending [[approvals]]',
        statusPending: 'Pending',
        statusApproved: 'Approved',
        statusFulfilled: 'Fulfilled',
        statusRejected: 'Rejected',
        statusCancelled: 'Cancelled',
        accessProfile: '[[Access Profile]]',
        loadingApprovals: 'Loading [[approvals]]...',
        failedToLoadApprovals: 'Failed to load [[approvals]]',
        errorLoading: 'Error loading [[approvals]]. Please try again.',
        approveAccessRequest: 'Approve [[access request]]',
        rejectAccessRequest: 'Reject [[access request]]',
        batchApprove: 'Approve selected',
        batchReject: 'Reject selected',
        batchApproveTitle: 'Approve {{count}} Item(s)',
        batchRejectTitle: 'Reject {{count}} Item(s)',
        batchApproveConfirm: 'Are you sure you want to approve {{count}} item(s)?',
        batchRejectConfirm: 'Are you sure you want to reject {{count}} item(s)?',
        selectAll: 'Select all',
        selectedItemCount: '{{count}} selected',
        requestedBy: 'Requested by',
        requestedFor: 'For',
        permanent: 'Permanent',
        risk: 'Risk:',
        previous: 'Previous',
        next: 'Next',
        itemApproved: 'Item approved successfully.',
        itemRejected: 'Item rejected.',
        batchApproved: 'Selected items approved successfully.',
        batchRejected: 'Selected items rejected.',
        tabAccessRequests: '[[Access requests]]',
        tabRuleRequests: '[[Auto-assign rule requests]]',
        accessRequestsDescription: '[[Access requests]] pending your [[approval]]',
        ruleRequestsDescription: '[[Auto-assign rule requests]] pending your [[approval]]',
        functionGroupRequestsDescription: '[[Function group requests]] pending your [[approval]]',
        restrictionRuleRequestsDescription: 'Separation-of-duty rule [[requests]] pending your [[approval]]',
        noRuleRequestApprovals: 'No pending rule [[request]] [[approvals]]',
        ruleRequestApproved: 'Rule [[request]] approved successfully.',
        ruleRequestRejected: 'Rule [[request]] rejected.',
        approveRuleRequest: 'Approve Rule [[request]]',
        rejectRuleRequest: 'Reject Rule [[request]]',
    },
    my: {
        title: 'My IAM',
        pageTitle: 'My IAM',
        subtitle: 'Manage your [[access requests]] and [[approvals]]',
        welcome: 'Welcome to My IAM',
        selectOption: 'Select an option from the menu to get started.',
        dashboard: 'Dashboard',
        dashboardDesc: 'Overview of your IAM activities',
        myAccess: 'My access',
        myAccessDesc: 'Your [[access profile]] and [[function group assignments]]',
        myRequests: 'My [[requests]]',
        myRequestsDesc: 'Access and [[function group requests]] you submitted',
        myApprovals: 'My [[approvals]]',
        myApprovalsDesc: 'Items awaiting your [[approval]]',
        myNotifications: '[[Notifications]]',
        myNotificationsDesc: 'Your [[notification]] history',
        myDelegations: 'My delegations',
        myDelegationsDesc: 'Manage your deputy delegations',
        myRehires: 'My rehires',
        myRehiresDesc: 'Review rehire candidates among your direct reports',
        myReviews: 'My reviews',
        myReviewsDesc: 'Review assigned certifications',
        myResponsibilities: 'My responsibilities',
        myResponsibilitiesDesc: 'Catalog entities you own or steward',
        sectionMyAccount: 'My account',
        sectionAsManager: 'As manager',
    },
    myResponsibilities: {
        title: 'My responsibilities',
        pageTitle: 'My responsibilities | My IAM',
        subtitle: 'Catalog entities you are responsible for as an owner or steward',
        noVisibleTabs: 'You do not have view permissions for any catalog entity type.',
        emptyAccessProfiles: 'You are not listed as an owner of any [[access profile]].',
        emptyFunctionGroups: 'You are not listed as an owner of any [[function group]].',
        emptyResources: 'You are not listed as an owner of any [[resource]].',
        emptyTargetSystems: 'You are not listed as an owner of any [[target system]].',
        emptyRestrictionRules: 'You are not listed as an owner of any [[restriction rule]].',
        emptyAutoAssignRules: 'You are not listed as an owner of any [[auto-assign rule]].',
        emptyCertificationPolicies: 'You are not listed as an owner of any [[certification policy]].',
        emptyCertificationCampaigns: 'You are not listed as an owner of any [[certification campaign]].',
    },
    myDashboard: {
        title: 'My dashboard',
        pageTitle: 'Dashboard | My IAM',
        subtitle: 'Overview of your IAM activities',
        myAccess: 'My access',
        myAccessDesc: 'Your [[access profile]] and [[function group assignments]]',
        pendingRequests: 'Pending [[requests]]',
        pendingRequestsDesc: 'Your access and [[function group requests]] still awaiting [[approval]]',
        pendingApprovals: 'Pending [[approvals]]',
        pendingApprovalsDesc: 'Items awaiting your [[approval]]',
        viewRequests: 'View All [[requests]]',
        viewApprovals: 'View All [[approvals]]',
        recentNotifications: 'Latest [[notifications]]',
        recentNotificationsEmpty: 'No [[notifications]] yet.',
        viewAllNotifications: 'View all [[notifications]]',
        newAccessRequest: 'New [[access request]]',
        newFunctionGroupRequest: 'New [[function group request]]',
    },
    myAccess: {
        title: 'My access',
        pageTitle: 'My Access | My IAM',
        subtitle: 'Your current [[access profile]] and [[function group assignments]] and history',
        byAssignment: 'By assignment',
        timeline: 'Timeline',
        noAssignments: 'You have no [[access profile assignments]].',
        noAssignmentsMatch: 'No [[access profile assignments]] match your filters.',
        assignmentHistory: 'Assignment history',
        noHistoryEvents: 'No history events.',
        accessProfilesTab: '[[Access Profiles]]',
        functionGroupsTab: '[[Function Groups]]',
        accessProfilesTabSection: 'Your current [[access profile assignments]].',
        functionGroupsTabSection: 'Your current [[function group assignments]].',
        accessProfilesSearchPlaceholder: 'Search by [[access profile]] name…',
        functionGroupsSearchPlaceholder: 'Search by [[function group]] name…',
        noFgAssignments: 'You have no [[function group assignments]].',
        noFgAssignmentsMatch: 'No [[function group assignments]] match your filters.',
        fgColumnName: '[[Function Group]]',
        fgColumnStatus: 'Status',
        fgColumnSources: 'Sources',
        fgColumnExpiresAt: 'Expires at',
        effectiveAccessTab: 'Effective access',
        effectiveAccessTabSection: 'All calculated grants currently in effect for your [[identity]], across every system and [[resource]].',
        effectiveAccessSearchPlaceholder: 'Search by system, entitlement, [[resource]]…',
        effectiveAccessScopeHint: 'You only see your own grants — search and filters are scoped to your [[identity]].',
        noEffectiveAccess: 'You currently have no effective access grants.',
        noEffectiveAccessMatch: 'No grants match your search.',
        eaColumnSystem: 'System',
        eaColumnEnforcementObject: 'Entitlement',
        eaColumnResource: '[[Resource]]',
        eaColumnOperation: 'Operation',
        eaColumnValidFrom: 'Valid from',
        eaColumnValidTo: 'Valid to',
        eaColumnSourcesCount: 'Sources',
    },
    backgroundJobs: {
        title: 'Background [[jobs]]',
        pageTitle: 'Background [[jobs]]',
        dashboardPageTitle: 'Dashboard | Background [[jobs]]',
        subtitle: 'Manage scheduled [[jobs]] and cluster',
        dashboard: 'Dashboard',
        dashboardDesc: 'Statistics overview',
        jobs: '[[Jobs]]',
        jobsDesc: 'Scheduled [[job]] definitions',
        executions: '[[Executions]]',
        executionsDesc: '[[Job]] [[execution]] history',
cluster: 'Cluster',
        clusterDesc: 'Cluster nodes and master',
        errorLogs: '[[Error Log]]',
        errorLogsDesc: 'Failure records across all modules',
        scripts: 'Scripts',
        scriptsDesc: 'Manage and test Groovy scripts',
        selectOption: 'Select an option from the menu...',
        jobsDashboard: '[[Jobs]] Dashboard',
        jobsDashboardDesc: 'Overview of [[job]] [[executions]] and system health',
        selectPeriod: 'Select period',
        last24Hours: 'Last 24 hours',
        last7Days: 'Last 7 days',
        last30Days: 'Last 30 days',
        customRange: 'Custom range',
        allTime: 'All time',
        jobExecutions: '[[Job]] [[executions]]',
        total: 'Total',
        completed: 'Completed',
        running: 'Running',
        pending: 'Pending',
        failed: 'Failed',
        cancelled: 'Cancelled',
        avgDuration: 'Avg duration',
        successRate: 'Success rate',
        jobsOverview: '[[Jobs]] Overview',
        totalJobs: 'Total [[jobs]]',
        enabled: 'Enabled',
        disabled: 'Disabled',
        processing: 'Processing',
        deadLetter: 'Dead letter',
        totalNodes: 'Total nodes',
        activeNodes: 'Active nodes',
        masterNode: 'Master node',
        completedOfTotal: '{{completed}} of {{total}} [[executions]] completed successfully',
        failedCancelledStats: '{{failed}} failed, {{cancelled}} cancelled',
        runningNow: 'Running now',
        failed24h: 'Failed (24h)',
        enabledOfTotal: '{{enabled}} enabled / {{total}} total',
        needsAttention: 'Needs attention',
        allSystemsHealthy: 'All systems healthy — no items need attention.',
        recentExecutions: 'Recent [[executions]]',
        viewAll: 'View all',
        sourceBreakdown: 'Source breakdown',
        sourceStatic: 'Static',
        sourceDynamic: 'Dynamic',
        sourceTestdata: 'Testdata',
        failedToLoadStats: 'Failed to load dashboard stats.',
        retry: 'Retry',
    },
    jobs: {
        title: '[[Jobs]]',
        pageTitle: '[[Jobs]] | Background [[jobs]]',
        detailPageTitle: '[[Job]] Details | Background [[jobs]]',
        subtitle: 'Manage scheduled and manual [[jobs]]',
        scheduledJobs: 'Scheduled [[jobs]]',
        scheduledJobsDesc: 'Manage scheduled background [[jobs]]',
        allJobs: 'All [[jobs]]',
        createJob: 'Create [[job]]',
        filterPlaceholder: 'Filter [[jobs]]...',
        jobCount: '{{count}} [[job]](s)',
        jobName: '[[Job]] Name',
        key: 'Key',
        schedule: 'Schedule',
        lastRun: 'Last run',
        nextRun: 'Next run',
        noJobsMatch: 'No [[jobs]] match your filter.',
        noJobsFound: 'No [[jobs]] found. Adjust your filters or create a new [[job]].',
        loadingJobs: 'Loading [[jobs]]...',
        failedToLoadJobs: 'Failed to load [[jobs]].',
        errorLoading: 'Error loading [[jobs]]. Please try again.',
        source: 'Source',
        manual: 'Manual',
        lastStatus: 'Last status',
        jobDetails: '[[Job]] Details',
        trigger: 'Trigger',
        triggering: 'Triggering...',
        tasks: 'Tasks',
        tasksDesc: 'Task definitions and their [[execution]] order',
        noTasksDefined: 'No tasks defined',
        taskCount: '{{count}} task(s)',
        cronExpression: 'Cron expression',
        timeout: 'Timeout',
        retries: 'Retries',
        maxConcurrent: 'Max concurrent',
        allowOverlap: 'Allow overlap',
        assignedNode: 'Assigned node',
        manualOnly: 'Manual only',
        builder: '[[Job]] Builder',
        runNow: 'Run now',
        disable: 'Disable',
        enable: 'Enable',
        deleteJob: 'Delete [[job]]',
        deleteConfirm: 'Are you sure you want to delete "{{name}}"? This action cannot be undone.',
        deleteConfirmMessage: 'This will permanently delete the [[job]] and all its task definitions. Active [[executions]] will be cancelled.',
        viewDetails: 'View details',
        viewExecutions: 'View [[executions]]',
        recentExecutions: 'Recent [[executions]]',
        recentExecutionsDesc: 'Last 10 [[job]] runs',
        live: 'Live',
        progress: 'Progress',
        started: 'Started',
        duration: 'Duration',
        node: 'Node',
        noExecutionsYet: 'No [[executions]] yet',
        neverRun: 'Never run',
        completed: 'Completed',
        completedWithErrors: 'Completed with Errors',
        running: 'Running',
        cancelling: 'Cancelling',
        failed: 'Failed',
        cancelled: 'Cancelled',
        pending: 'Pending',
        parallelGroup: 'Parallel group',
        sequentialGroup: 'Sequential group',
        skipOnFail: 'skip-on-fail',
        retryCount: '{{count}} retry',
        retryCountPlural: '{{count}} retries',
        log: 'Log:',
        jobNotFound: '[[Job]] not found.',
        loadingJobDetails: 'Loading [[job]] details...',
        timeoutDuration: 'timeout: {{duration}}',
        jobEnabled: '[[Job]] enabled successfully.',
        jobDisabled: '[[Job]] disabled successfully.',
        jobTriggered: '[[Job]] triggered successfully.',
        jobCancelled: '[[Job]] cancelled successfully.',
        jobDeleted: '[[Job]] deleted successfully.',
        manageJobScripts: 'Manage [[job]] Scripts',
    },
    jobBuilder: {
        title: '[[Job]] Builder',
        pageTitle: '[[Job]] Builder | Background [[jobs]]',
        editPageTitle: 'Edit Tasks | Background [[jobs]]',
        newPageTitle: 'New [[job]] | Background [[jobs]]',
        editTasks: 'Edit tasks',
        newJob: 'New [[job]]',
        unsavedChanges: 'You have unsaved changes.',
        // Palette
        taskPalette: 'Task palette',
        registeredTasks: 'Registered tasks',
        customTasks: 'Custom tasks',
        groovyScript: 'Groovy script',
        delay: 'Delay',
        searchTasks: 'Search tasks...',
        noRegisteredTasks: 'No registered tasks available.',
        failedToLoadPalette: 'Failed to load palette.',
        // Task chain
        taskChain: 'Task chain',
        noTasksYet: 'No tasks added yet.',
        addTasksFromPalette: 'Drag tasks from the palette to get started.',
        staticTask: 'Static task (locked)',
        dragToReorder: 'Drag to reorder',
        // Config panel
        taskConfig: 'Task configuration',
        beanMethod: 'Bean method',
        beanName: 'Bean name',
        methodName: 'Method name',
        readOnlyConfig: 'This task is read-only.',
        scriptBody: 'Script body',
        inputs: 'Inputs',
        inputKey: 'Key',
        inputValue: 'Value',
        addInput: 'Add input',
        sqlWriteAccess: 'SQL Write Access',
        sqlWriteAccessWarning: 'Enables INSERT/UPDATE/DELETE via context.sql. Use with caution.',
        testScript: 'Test script',
        testScriptRunning: 'Running...',
        testScriptOutput: 'Test output',
        testScriptError: 'Test failed',
        durationSeconds: 'Duration (seconds)',
        durationMin: 'Minimum: 1 second',
        durationMax: 'Maximum: 86400 seconds (24 hours)',
        durationOutOfRange: 'Duration must be between 1 and 86400 seconds.',
        apply: 'Apply',
        // Save / Cancel
        saveJob: 'Save',
        savingJob: 'Saving...',
        jobSaved: '[[Job]] tasks saved.',
        saveError: 'Failed to save [[job]] tasks.',
        addTaskBeforeSaving: 'Add at least one task before saving.',
        discardChangesTitle: 'Discard unsaved changes?',
        discardChangesDescription: 'Your task changes will be lost.',
        keepEditing: 'Keep editing',
        discard: 'Discard',
        conflictTitle: 'Conflict detected',
        conflictDescription: 'This [[job]] was modified by another user. Please reload and try again.',
        reload: 'Reload',
        // Create job dialog
        createJob: 'Create [[job]]',
        createJobDescription: 'Create a new dynamic [[job]] with a custom task chain.',
        jobName: '[[Job]] Name',
        jobNamePlaceholder: 'Enter [[job]] name',
        jobKey: '[[Job]] Key',
        jobKeyPlaceholder: 'e.g., my-background-[[Job]]',
        jobDescription: 'Description',
        jobDescriptionPlaceholder: 'Describe what this [[job]] does',
        cronExpression: 'Cron expression',
        cronExpressionPlaceholder: 'e.g., 0 0 2 * * *',
        cronExpressionHint: 'Leave empty for manual-only [[execution]].',
        cronPreview: 'Schedule: {{description}}',
        cronInvalid: 'Invalid cron expression.',
        timeoutSeconds: 'Timeout (seconds)',
        timeoutDefault: 'Default: 3600 (1 hour)',
        priority: 'Priority',
        priorityCritical: 'Critical',
        priorityHigh: 'High',
        priorityNormal: 'Normal',
        priorityLow: 'Low',
        next: 'Next',
        // Validation
        nameRequired: 'Name is required.',
        nameMaxLength: 'Name must be at most 100 characters.',
        keyRequired: '[[Job]] key is required.',
        keyMaxLength: '[[Job]] key must be at most 100 characters.',
        descriptionMaxLength: 'Description must be at most 500 characters.',
        taskName: 'Task name',
        taskNamePlaceholder: 'Enter task name',
        editScript: 'Edit script',
    },
    scriptEditor: {
        pageTitle: 'Script Editor | Background [[jobs]]',
        title: 'AI Script Assist',
        placeholder: 'Describe what the script should do...',
        suggest: 'Suggest code',
        suggesting: 'Suggesting...',
        apply: 'Apply',
        insertAtCursor: 'Insert at Cursor',
        insertAtCursorNoPosition: 'Click into the editor first, then try again.',
        replaceConfirmTitle: 'Replace current script?',
        replaceConfirmDescription: 'This will replace your entire script with the AI suggestion.',
        fixWithAi: 'Fix with AI',
        fixPrefix: 'Fix this compilation error',
        validate: 'Check syntax',
        validating: 'Checking...',
        syntaxOk: 'Syntax OK',
        syntaxError: 'Syntax errors found',
        syntaxModifiedHint: 'Script modified \u2014 re-check syntax to validate',
        errorSummary: {
            showAll: 'Show all ({{count}})',
            collapse: 'Show fewer',
            lineError: 'Line {{line}}: {{message}}',
        },
        rateLimited: 'Rate limit reached. Try again in {{seconds}} seconds.',
        llmUnavailable: 'AI assistance is not available. No LLM model is configured.',
        llmUnavailableBadge: 'Unavailable',
        suggestFailed: 'Failed to generate suggestion. Please try again.',
        networkError: 'Failed to validate script. Check your connection.',
        saved: 'Script saved',
        unsavedChanges: 'Unsaved changes',
        discardTitle: 'Discard unsaved changes?',
        discardDescription: 'Your script changes have not been saved and will be lost.',
        schedule: {
            edit: 'Edit schedule',
            cron: 'Cron expression',
            preview: 'Schedule: {{description}}',
            manual: 'Manual trigger only',
            saved: 'Schedule updated',
            removeTitle: 'Remove schedule?',
            removeDescription: 'This [[job]] will only run when triggered manually.',
            removeConfirm: 'Remove schedule',
            hint: '6-field cron (sec min hour day month weekday). Leave empty for manual trigger only.',
            cronFieldHint: 'e.g., 0 0 2 * * *',
            invalidCron: 'Invalid cron expression',
        },
        scriptTooLarge: 'Script exceeds 10,000 characters. Only the first 10,000 will be sent to AI.',
        editInBuilder: 'Edit in Builder',
        scriptPreview: {
            showAll: 'Show all',
            collapse: 'Show fewer',
        },
        taskNotFound: 'Task not found in this [[job]].',
        newScriptPlaceholder: '// Write your Groovy script here',
        save: 'Save',
        saving: 'Saving...',
        replace: 'Replace',
    },
    jobExecutions: {
        title: '[[Executions]]',
        pageTitle: '[[Executions]] | Background [[jobs]]',
        detailPageTitle: '[[Execution]] Details | Background [[jobs]]',
        subtitle: 'View [[job]] [[execution]] history',
        viewExecutionHistory: 'View [[execution]] history',
        allExecutions: 'All [[executions]]',
        filterPlaceholder: 'Filter by [[job]] name...',
        executionCount: '{{count}} [[execution]](s)',
        jobName: '[[Job]]',
        startedAt: 'Started',
        completedAt: 'Completed',
        duration: 'Duration',
        noExecutionsMatch: 'No [[executions]] match your filters.',
        noExecutionsFound: 'No [[executions]] found.',
        loadingExecutions: 'Loading [[executions]]...',
        errorLoading: 'Error loading [[executions]]. Please try again.',
        executionDetails: '[[Execution]] Details',
        liveUpdates: 'Live updates',
        connecting: 'Connecting...',
        taskResults: 'Task results',
        logs: 'Logs',
        output: 'Output',
        success: 'Success',
        failed: 'Failed',
        running: 'Running',
        pending: 'Pending',
        cancelled: 'Cancelled',
        completed: 'Completed',
        completedWithErrors: 'Completed with Errors',
        cancelling: 'Cancelling',
        noLogs: 'No logs available.',
        viewLogs: 'View logs',
        live: 'Live',
        timeRange: 'Time range',
        task: 'Task',
        tasks: 'Tasks',
        node: 'Node',
        total: 'Total',
        succeeded: 'Succeeded',
        loadingTasks: 'Loading tasks...',
        noTasksForExecution: 'No tasks for this [[execution]]',
        parallelGroup: 'Parallel group',
        sequentialGroup: 'Sequential group',
        executionInfo: '[[Execution]] Info',
        progress: 'Progress',
        started: 'Started',
        error: 'Error',
        statistics: 'Statistics',
        taskExecutions: 'Task [[executions]]',
        clickLogIcon: 'Click the log icon to view task [[execution]] logs',
        noTaskExecutions: 'No task [[executions]]',
        executionNotFound: '[[Execution]] not found.',
        loadingExecutionDetails: 'Loading [[execution]] details...',
        errorLoadingExecutions: 'Error loading [[executions]]. Please try again.',
        waiting: 'Waiting',
        skipped: 'Skipped',
        skipOnFail: 'skip-on-fail',
        jobLabel: '[[Job]]:',
        jobIdLabel: '[[Job]] ID: {{id}}',
        executionCancelled: '[[Execution]] cancelled successfully.',
        executionIdLabel: '[[Execution]] #{{id}}',
        cancelExecutionTitle: 'Cancel [[execution]]',
        cancelExecutionConfirm: 'Are you sure you want to cancel this [[execution]]? Running tasks will be interrupted.',
        keepRunning: 'Keep running',
        cancelExecution: 'Cancel [[execution]]',
        backToExecutions: 'Back to [[executions]]',
        failedToLoadExecution: 'Failed to load [[execution]] details.',
    },
clusterNodes: {
        title: 'Cluster nodes',
        pageTitle: 'Cluster | Background [[jobs]]',
        subtitle: 'Application instances in the [[job]] cluster',
        allNodes: 'All cluster nodes',
        nodeCount: '{{count}} node(s)',
        nodeId: 'Node ID',
        hostname: 'Hostname',
        ipAddress: 'IP Address',
        lastHeartbeat: 'Last heartbeat',
        registered: 'Registered',
        searchPlaceholder: 'Search by node ID, hostname, or IP...',
        noNodesFound: 'No nodes registered',
        noNodesMatch: 'No nodes match your search.',
        loadingNodes: 'Loading cluster nodes...',
        errorLoading: 'Error loading cluster nodes.',
        totalNodes: 'Total nodes',
        activeNodes: 'Active nodes',
        masterNode: 'Master node',
        removeNode: 'Remove node',
        removeNodeConfirm: 'Are you sure you want to remove this node from the cluster?',
        removeNodeDesc: 'This node will be unregistered and its [[jobs]] will be reassigned.',
        thisNode: 'This node',
        remove: 'Remove',
        master: 'Master',
        worker: 'Worker',
        active: 'Active',
        starting: 'Starting',
        inactive: 'Inactive',
        stopped: 'Stopped',
        nodeRemoved: 'Node removed from cluster.',
        failedToLoadCluster: 'Failed to load cluster info.',
    },
    scripts: {
        // Page titles
        pageTitle: 'Scripts | Background [[jobs]]',
        editorPageTitle: 'Script Editor | Background [[jobs]]',
        newPageTitle: 'New Script | Background [[jobs]]',

        // Navigation
        backToJobs: 'Back to [[jobs]]',
        backToJobBuilder: 'Back to [[job]] Builder',

        // List page
        title: 'Scripts',
        allScripts: 'All scripts',
        scriptCount: '{{count}} script(s)',
        newScript: 'New script',
        filterPlaceholder: 'Filter scripts...',
        filterCategory: 'Category',
        filterPublished: 'Status',
        allCategories: 'All categories',
        allStatuses: 'All',
        publishedOnly: 'Published',
        draftsOnly: 'Drafts',
        noScriptsFound: 'No scripts found.',
        noScriptsMatch: 'No scripts match your filter.',

        // Editor page
        scriptName: 'Script name',
        scriptNamePlaceholder: 'e.g., Import HR Users',
        category: 'Category',
        categoryPlaceholder: 'Select category',
        tags: 'Tags',
        tagsPlaceholder: 'Comma-separated tags',
        maxExecutionTime: 'Max [[execution]] Time',
        description: 'Description',
        descriptionPlaceholder: 'What does this script do?',
        metadata: 'Metadata',

        // Actions
        save: 'Save',
        saveFirst: 'Save first',
        saving: 'Saving...',
        validate: 'Check syntax',
        validating: 'Checking...',
        run: 'Test run',
        running: 'Running...',
        publish: 'Publish',
        unpublish: 'Unpublish',
        delete: 'Delete',
        deleteConfirm: 'Delete script',
        deleteConfirmDescription: 'Are you sure you want to delete this script? This action cannot be undone.',
        cannotDeletePublished: 'Unpublish the script before deleting it.',

        // Status messages
        saved: 'Script saved successfully.',
        created: 'Script created successfully.',
        deleted: 'Script deleted successfully.',
        published: 'Script published. It can now be used in [[jobs]].',
        unpublished: 'Script unpublished. It can no longer be used in new [[jobs]].',
        saveError: 'Failed to save script.',
        deleteError: 'Failed to delete script.',
        publishError: 'Failed to publish script.',

        // Validation
        validationValid: 'Syntax OK — no compilation errors.',
        validationErrors: '{{count}} syntax error(s) found.',
        validationWarnings: '{{count}} warning(s).',

        // Editor
        codeEditor: 'Script code',

        // Input Parameters
        inputParameters: 'Input parameters',
        addParameter: 'Add parameter',
        parameterName: 'Name',
        parameterType: '[[Type]]',
        parameterRequired: 'Required',
        parameterDefault: 'Default',
        parameterDescription: 'Description',
        removeParameter: 'Remove',
        noParameters: 'No input parameters defined.',

        // Test Runner
        testRun: 'Test run',
        executeTest: 'Execute',
        testOutput: 'Output',
        testResult: 'Result',
        noTestRuns: 'No test runs yet. Click Execute to run the script.',
        executionCompleted: 'Completed in {{duration}}ms',
        executionFailed: 'Failed: {{error}}',
        executionTimeout: '[[Execution]] timed out.',

        // Execution History
        executionHistory: '[[Execution]] History',
        executionId: '[[Execution]] ID',
        startedAt: 'Started at',
        duration: 'Duration',
        executedBy: 'Executed by',
        noExecutionHistory: 'No [[executions]] recorded yet.',

        // Tabs
        tabParameters: 'Parameters',
        tabTestRun: 'Test run',
        tabHistory: 'History',
        tabVersions: 'Versions',

        // Versions
        noVersionHistory: 'No version history yet. Versions are created when the script code changes.',
        versionLabel: 'Version',
        versionStatus: 'Status',
        viewDiff: 'View changes',
        currentVersion: 'Current',
        superseded: 'Superseded',
        publishVersion: 'Publish',
        republishConfirmTitle: 'Publish version',
        republishConfirmDesc: 'Publishing v{{version}} will replace the currently published version. [[jobs]] will use this version going forward.',
        publishDraftConfirmDesc: 'Publishing v{{version}} will make this script available for use in [[jobs]].',
        versionPublished: 'Version v{{version}} published successfully.',

        // Published badge
        publishedBadge: 'Published',
        draft: 'Draft',
        deactivated: 'Deactivated',

        // Job builder integration
        selectScript: 'Select script',
        chooseScript: 'Choose script',
        changeScript: 'Change script',
        scriptPickerTitle: 'Select a Script',
        scriptPickerDescription: 'Choose a script to execute in this task.',
        noScriptsAvailable: 'No active scripts available.',
        scriptInputs: 'Script inputs',
        noPublishedScripts: 'No published scripts available.',
        selectedScript: 'Selected script',

        // Templates
        templateBadge: 'Template',
        markAsTemplate: 'Mark as Template',
        unmarkAsTemplate: 'Remove template status',
        markAsTemplateDesc: 'Templates are available for others to create new scripts from.',
        markedAsTemplate: 'Script marked as template.',
        unmarkedAsTemplate: 'Template status removed.',
        manageTemplates: 'Manage templates',
        manageTemplatesDesc: 'Templates available for creating new scripts.',
        noTemplatesManage: 'No scripts are currently marked as templates.',
        removeTemplateBtnTooltip: 'Remove template status from this script',
        removeTemplateConfirmTitle: 'Remove template',
        removeTemplateConfirmDesc: 'Are you sure you want to remove "{{name}}" as a template? It will become a regular script.',
        removeTemplateConfirmAction: 'Remove template',
        fromTemplate: 'From template',
        templatePicker: 'Create from Template',
        selectTemplate: 'Select a Template',
        templatePickerDescription: 'Choose a template to create a new script with pre-built code.',
        noTemplates: 'No templates available.',
        creatingFromTemplate: 'Creating script...',

        // Unsaved changes
        unsavedChanges: 'You have unsaved changes.',
        backToList: 'All scripts',

        // Test Run dialog
        testRunTitle: 'Test Run — Live [[execution]]',
        testRunWarning: 'This will execute the script against the live database. Changes cannot be undone.',
        testRunBindings: 'Available bindings: sql (database), http (external requests), csv (parsing)',
        testRunConfirm: 'Run script',

        // Draft toast
        savedAsDraft: 'Script saved as draft.',
        savedAsDraftHint: 'Publish to make it available in [[jobs]].',

        // Activate/Deactivate
        activate: 'Activate',
        deactivate: 'Deactivate',
        activated: 'Script activated.',
        deactivatedMsg: 'Script deactivated. It can no longer run in [[jobs]].',
        deactivatedReadOnly: 'This script is deactivated. Reactivate it to make changes.',

        // Status toggle
        publishConfirm: 'Publishing makes this script available for use in [[jobs]].',
        unpublishWarning: '[[Jobs]] referencing this script will fail.',

        // Creation dialog
        newScriptDialog: 'New script',
        startBlank: 'Start blank',
        startBlankDesc: 'Empty script with default boilerplate',
        fromTemplateDesc: 'Copy code from a pre-built template',

        // History
        testBadge: 'Executed via Test Run',
        viewLogs: 'View logs',

        // SQL Insert dialog
        sqlInsertTitle: 'Compose SQL',
        sqlInsertDescription: 'Write your SQL query below. It will be inserted into the script as a Groovy binding call.',
        sqlBinding: 'Binding method',
        sqlPreview: 'Preview — will be inserted as:',
        sqlInsert: 'Insert into Script',
        sqlReplace: 'Replace in Script',
        insertSql: 'Insert SQL',
        sqlBindingOptions: {
            query: 'sql.query — returns rows',
            queryForValue: 'sql.queryForValue — single value',
            update: 'sql.update — UPDATE/DELETE',
            execute: 'sql.execute — DDL',
        },

        // Ad-hoc run
        runNow: 'Run',
        runNowTooltip: 'Execute this script now',
        runSuccess: 'Script executed successfully.',
        runError: 'Script [[execution]] failed.',
        openInEditor: 'Open in editor',
        lastExecuted: 'Last executed',

    },
    scriptSqlV2: {
        fields: {
            parameters: 'Parameters',
            resultType: 'Result type',
        },
        placeholders: {
            parameters: '[id: 1, status: "ACTIVE"]',
            groovyPreview: 'Type a SQL statement above to preview the inserted Groovy code.',
        },
        captions: {
            executeRestriction: 'DDL only. Allowed: CREATE TABLE, DROP TABLE, TRUNCATE TABLE, ALTER TABLE, CREATE INDEX, DROP INDEX, ANALYZE. Auth tables and audit_logs cannot be targeted.',
            executeParamsIgnored: 'Parameters are ignored on execute — DDL statements do not accept a parameter bag.',
            blocklist: 'auth_* and audit_logs tables are read-only and DDL-protected for scripts. Use http.iam(…) to access them via the API.',
            inlineLiteralAdvisory: 'Avoid embedding secrets as literals in SQL — use named parameters instead.',
            variableRefHint: 'Preview unavailable — replace variable references with literals to test.',
            codeMirrorEscapeHint: 'Esc to move focus to Parameters.',
        },
        actions: {
            insert: 'Insert into Script',
            replace: 'Replace in Script',
            trySql: 'Try SQL',
            running: 'Running…',
        },
        badges: {
            rolledBack: 'Rolled back',
        },
        aria: {
            rollbackBadge: 'The preview transaction was rolled back; no changes were committed to the database',
        },
        errorBanners: {
            sqlError: {
                heading: 'SQL error',
                bodyNoMessage: 'SQL preview failed without a diagnostic message. Check the [[error log]] for details.',
            },
            typeConversionError: {
                heading: 'Type conversion error',
                body: 'The query result could not be converted to {{selectedType}}. Try a different `Result type` (e.g. String accepts most values).',
            },
            paramsInvalid: {
                heading: 'Parameters error',
                body: 'Parameters must be literals only — replace any variable references with values to test.',
            },
            limitRowsPerQuery: {
                heading: 'Result too large',
                body: 'The query returned more than 100 rows. Add a LIMIT clause to narrow the preview result set.',
            },
            limitStatementTimeout: {
                heading: 'Query timed out',
                body: 'The query took longer than 60 seconds. Add filters or break it into smaller queries.',
            },
            limitResponsePayload: {
                heading: 'Result too large to display',
                body: 'The result set exceeds 5 MB. Add a LIMIT clause or narrow your query.',
            },
            limitGeneric: {
                heading: 'Preview limit exceeded',
                body: 'The query exceeded a preview limit. Narrow the query (LIMIT, filters) and try again.',
            },
            rateLimit: {
                heading: 'Slow down',
                body: "You've run too many previews. Try again in {{retryAfterSeconds}} seconds.",
            },
            permissionDenied: {
                heading: 'Permission denied',
                body: "You don't have permission to run SQL preview. Contact your administrator.",
            },
            serverError: {
                heading: 'Preview unavailable',
                body: 'The preview service is currently unavailable. Try again later.',
            },
            networkFailure: {
                heading: '`Try SQL` failed',
                body: 'Unable to reach the preview service. Check your connection and try again.',
            },
        },
    },
    analytics: {
        title: 'Effective access',
        pageTitle: 'Effective access',
        dashboardPageTitle: 'Dashboard | Effective Access',
        byIdentityPageTitle: 'By [[identity]] | Effective Access',
        bySystemPageTitle: 'By System | Effective Access',
        identityGrantsPageTitle: '[[Identity]] Access | Effective Access',
        systemGrantsPageTitle: 'System Access | Effective Access',
        comparePageTitle: 'Compare Access | Effective Access',
        subtitle: 'View effective access and compare [[identity]] access',
        dashboard: 'Dashboard',
        dashboardDesc: 'Overview and key metrics',
        byIdentity: 'By [[identity]]',
        byIdentityDesc: 'View access per [[identity]]',
        bySystem: 'By system',
        bySystemDesc: 'View access per [[target system]]',
        compare: 'Compare access',
        compareDesc: 'Compare [[identity]] access',
        selectOption: 'View effective access analytics and compare [[identity]] access across systems.',
        identityGrants: '[[Identity Grants]]',
        systemGrants: '[[System Grants]]',
        totalGrants: 'Total grants',
        directGrants: 'Direct grants',
        inheritedGrants: 'Inherited grants',
        searchIdentities: 'Search [[identities]]...',
        searchSystems: 'Search systems...',
        selectIdentity: 'Select an [[identity]]',
        selectSystem: 'Select a system',
        selectIdentities: 'Select [[identities]] to compare',
        noGrantsFound: 'No grants found.',
        loadingGrants: 'Loading grants...',
        loadingIdentities: 'Loading [[identities]]...',
        loadingSystems: 'Loading systems...',
        errorLoading: 'Error loading grants. Please try again.',
        errorLoadingIdentities: 'Error loading [[identities]]. Please try again.',
        errorLoadingSystems: 'Error loading systems. Please try again.',
        errorLoadingDashboard: 'Error loading dashboard statistics.',
        errorLoadingComparison: 'Error loading comparison. Please try again.',
        loadingComparison: 'Loading comparison...',
        grantSource: 'Source',
        grantType: 'Grant [[type]]',
        enforcementObject: '[[Enforcement Object]]',
        resource: '[[Resource]]',
        system: 'System',
        compareSummary: 'Comparison summary',
        onlyIn: 'Only in {{name}}',
        inBoth: 'In both',
        differences: 'Differences',
        noDifferences: 'No differences found.',
        accessAnalytics: 'Access analytics dashboard',
        effectiveAccessDashboard: 'Effective access dashboard',
        effectiveAccessDashboardDesc: 'Overview of effective access grants across all systems',
        identitiesWithAccess: '[[Identities]] with Access',
        identitiesWithGrants: '[[Identities]] with Grants',
        systemsWithGrants: 'Systems with Grants',
        entitlementsGranted: 'Entitlements granted',
        grantsOverTime: 'Grants over time',
        topSystems: 'Top Systems by Grants',
        topIdentities: 'Top [[identities]] by Grants',
        selectPeriod: 'Select period',
        last24Hours: 'Last 24 hours',
        last7Days: 'Last 7 days',
        last30Days: 'Last 30 days',
        allTimeTotals: 'All-Time Totals',
        activity: 'Activity',
        grantsCreated: 'Grants created',
        identitiesAffected: '[[Identities]] Affected',
        systemsAffected: 'Systems affected',
        noGrantsYet: 'No grants recorded yet.',
        noActivityYet: 'No activity in this period.',
        effectiveAccessByIdentity: 'Effective Access by [[identity]]',
        effectiveAccessByIdentityDesc: 'View effective access for each [[identity]]',
        accessByIdentities: 'Access by [[identities]]',
        party: '[[Party]]',
        viewAccess: 'View access',
        noIdentitiesMatch: 'No [[identities]] match your search.',
        noIdentitiesFound: 'No [[identities]] found.',
        effectiveAccessBySystem: 'Effective Access by System',
        effectiveAccessBySystemDesc: 'View effective access grants for each [[target system]]',
        accessByTargetSystems: 'Access by [[target systems]]',
        environment: 'Environment',
        noSystemsMatch: 'No systems match your search.',
        noSystemsFound: 'No systems found.',
        compareAccess: 'Compare access',
        compareAccessDesc: 'Compare effective access between two [[identities]]',
        selectIdentitiesLabel: 'Select [[identities]]',
        selectIdentitiesDesc: 'Choose two [[identities]] to compare their effective access',
        identityA: '[[Identity]] A',
        identityB: '[[Identity]] B',
        searchForIdentity: 'Search for [[identity]]...',
        noIdentitiesFoundSearch: 'No [[identities]] found.',
        commonGrants: 'Common grants',
        commonGrantsDesc: 'Grants that both [[identities]] have',
        onlyInDesc: 'Grants that only {{name}} has',
        targetSystem: '[[Target System]]',
        neitherHasGrants: 'Neither [[identity]] has any effective access grants.',
        selectTwoIdentities: 'Select two [[identities]] above to compare their effective access.',
        effectiveAccessLabel: 'Effective Access:',
        recalculate: 'Recalculate',
        recalculateSuccess: 'Recalculation started successfully.',
        recalculateError: 'Failed to start recalculation.',
        recalculating: 'Recalculating...',
        activeGrants: 'Active grants',
        lastCalculated: 'Last calculated',
        never: 'Never',
        effectiveAccessGrants: 'Effective access grants',
        grantsFiltered: 'of {{total}} grants',
        filtered: '(filtered)',
        allEnvironments: 'All environments',
        allSystems: 'All systems',
        allIdentities: 'All [[identities]]',
        allOperations: 'All operations',
        viewIdentityDetails: 'View [[identity]] Details',
        viewSystemDetails: 'View system details',
        validTo: 'Valid to',
        sources: 'Sources',
        accessProfile: '[[Access Profile]]',
        assignmentStart: 'Assignment start',
        assignmentExpires: 'Assignment expires',
        uniqueIdentities: 'Unique [[identities]]',
        grantsFor: 'Grants for:',
        identityNotFound: '[[Identity]] not found.',
        systemNotFound: 'System not found.',
        topIdentitiesByGrants: 'Top [[identities]] by Grants',
        topIdentitiesByGrantsDesc: '[[Identities]] with the most effective access grants',
        topSystemsByGrants: 'Top Systems by Grants',
        topSystemsByGrantsDesc: '[[Target Systems]] with the most effective access grants',
        noIdentitiesWithGrants: 'No [[identities]] with grants found.',
        noSystemsWithGrants: 'No systems with grants found.',
        targetSystems: '[[Target Systems]]',
        customRange: 'Custom range',
        identity: '[[Identity]]',
        grants: 'Grants',
        searchIdentitiesPlaceholder: 'Search [[identities]]...',
        searchSystemsPlaceholder: 'Search systems...',
        noGrantsMatchFilters: 'No grants match the selected filters.',
        noGrantsForIdentity: 'No effective access grants found for this [[identity]].',
        noGrantsForSystem: 'No effective access grants found for this system.',
        matchingSearch: 'matching search',
        identityCount: '{{count}} [[identities]]',
        identityCount_one: '{{count}} [[identity]]',
        identityCount_other: '{{count}} [[identities]]',
        systemCount: '{{count}} systems',
        systemCount_one: '{{count}} system',
        systemCount_other: '{{count}} systems',
        recalculateResult: 'Recalculation complete. Added: {{added}}, Removed: {{removed}}, Modified: {{modified}}',
        recalculateRequested: 'Recalculation requested. Results will appear shortly.',
        recalculateFailed: 'Recalculation failed. Please try again.',
        effectiveAccessOverview: 'Overview of effective access grants across the organization',
    },
    provisioning: {
        title: 'Access provisioning',
        pageTitle: 'Access provisioning',
        dashboardPageTitle: 'Dashboard | Access Provisioning',
        tasksPageTitle: 'Active Tasks | Access Provisioning',
        historyPageTitle: 'Task History | Access Provisioning',
        subtitle: 'Monitor [[provisioning tasks]] and access fulfillment',
        dashboard: 'Dashboard',
        dashboardDesc: 'Overview and statistics',
        tasks: 'Active tasks',
        tasksDesc: 'View pending and running tasks',
        history: 'Task history',
        historyDesc: 'View completed tasks',
        selectOption: 'Monitor [[provisioning tasks]] and access fulfillment status.',
        provisioningDashboard: 'Provisioning dashboard',
        provisioningDashboardDesc: 'Monitor access [[provisioning tasks]] and fulfillment status',
        processAll: 'Process all',
        processingAll: 'Processing...',
        requeueReady: 'Requeue ready',
        requeueing: 'Requeuing...',
        archiveCompleted: 'Archive completed',
        archiving: 'Archiving...',
        queued: 'Queued',
        queuedDesc: 'Waiting to be processed',
        running: 'Running',
        runningDesc: 'Currently processing',
        failed: 'Failed',
        failedDesc: 'Needs attention',
        completed: 'Completed',
        completedDesc: 'Ready for archive',
        aboutProvisioningTasks: 'About [[provisioning tasks]]',
        aboutDesc: 'Understanding the provisioning workflow',
        taskLifecycle: 'Task lifecycle',
        taskLifecycleQueued: 'QUEUED',
        taskLifecycleQueuedDesc: 'Task created, waiting for connector',
        taskLifecycleRunning: 'RUNNING',
        taskLifecycleRunningDesc: 'Connector is processing the task',
        taskLifecycleFailed: 'FAILED',
        taskLifecycleFailedDesc: 'Task failed, may retry automatically',
        taskLifecycleDone: 'DONE',
        taskLifecycleDoneDesc: 'Task completed successfully',
        actionsTitle: 'Actions',
        actionGrant: 'GRANT',
        actionGrantDesc: 'Add access to [[target system]]',
        actionRevoke: 'REVOKE',
        actionRevokeDesc: 'Remove access from [[target system]]',
        actionCreateAccount: 'CREATE ACCOUNT',
        actionDisableAccount: 'DISABLE ACCOUNT',
        actionEnableAccount: 'ENABLE ACCOUNT',
        actionDeleteAccount: 'DELETE ACCOUNT',
        actionUpdateAccount: 'UPDATE ACCOUNT',
        actionUpdateAccountDesc: 'Push attribute changes to [[target system]]',
        dependsOn: 'Depends on',
        waitingFor: 'Waiting for: {{actionType}}',
        blockedWaitingForDependency: 'Blocked \u2014 waiting for dependency',
        failedToLoadStats: 'Failed to load provisioning statistics',
        pendingTasks: 'Pending tasks',
        activeTasks: 'Active [[provisioning tasks]]',
        completedTasks: 'Completed tasks',
        failedTasks: 'Failed tasks',
        totalTasks: 'Total tasks',
        taskDetails: 'Task details',
        retryTask: 'Retry',
        retrying: 'Retrying...',
        cancelTask: 'Cancel task',
        cancelling: 'Cancelling...',
        allTasks: 'All [[provisioning tasks]]',
        filterPlaceholder: 'Search [[identity]] or account...',
        taskCount: '{{count}} task(s)',
        taskCount_one: '{{count}} task',
        taskCount_other: '{{count}} tasks',
        identity: '[[Identity]]',
        account: 'Account',
        entitlement: 'Entitlement',
        targetSystem: '[[Target System]]',
        action: 'Action',
        operation: 'Operation',
        retries: 'Retries',
        retryCount: 'Retry: {{count}}',
        grant: 'Grant',
        revoke: 'Revoke',
        done: 'Done',
        canceled: 'Canceled',
        allStatuses: 'All statuses',
        allActions: 'All actions',
        allSystems: 'All systems',
        filterBySystem: 'Filter by system...',
        noSystemsFound: 'No systems found.',
        noTasksMatch: 'No tasks match your filter.',
        noTasksFound: 'No [[provisioning tasks]] found.',
        loadingTasks: 'Loading...',
        errorLoading: 'Error loading tasks',
        allHistory: '[[Provisioning Task]] History',
        historyCount: '{{count}} history record(s)',
        noHistoryFound: 'No provisioning history found.',
        noHistoryMatch: 'No history records match your filter.',
        loadingHistory: 'Loading...',
        errorLoadingHistory: 'Error loading history',
        searchByIdentity: 'Search by [[identity]] name...',
        createdAt: 'Created',
        completedAt: 'Completed',
        noActiveProvisioningTasks: 'No active [[provisioning tasks]].',
        completedTaskCount: '{{count}} completed task(s)',
        completedTaskCount_one: '{{count}} completed task',
        completedTaskCount_other: '{{count}} completed tasks',
        matchingFilters: 'matching filters',
        retry: 'Retry:',
        retryQueued: 'Task requeued for retry.',
        retryTriggered: 'Retry triggered.',
        selectFailedTasks: 'Select failed tasks',
        selectAll: 'Select all failed',
        bulkRetrySelected: 'Retry {{count}} selected',
        bulkRetryConfirmTitle: 'Retry {{count}} failed tasks?',
        bulkRetryConfirmBody: 'This will requeue {{count}} failed [[provisioning tasks]] in {{targetSystem}}. Each task is reset to QUEUED and will be picked up on the next process run.',
        bulkRetryConfirmBodyNoSystem: 'This will requeue {{count}} failed [[provisioning tasks]]. Each task is reset to QUEUED and will be picked up on the next process run.',
        bulkRetrySuccess: '{{retried}} task(s) requeued, {{skipped}} skipped.',
        bulkRetrySkippedCount: '{{count}} skipped',
        nextRetryAt: 'Next retry at',
        retrySingle: 'Retry this task',
        tasksProcessed: 'All tasks processed successfully.',
        tasksRequeued: 'Ready tasks requeued successfully.',
        tasksArchived: 'Completed tasks archived successfully.',
        taskDetailPageTitle: 'Task Detail | Access Provisioning',
        taskDetailTitle: '[[Provisioning Task]]',
        taskDetailSubtitle: 'Details for this provisioning operation',
        taskDetailInfoCard: 'Task information',
        taskDetailInfoCardDesc: 'Provisioning action and target details',
        taskDetailErrorCard: 'Error details',
        taskDetailErrorCardDesc: 'Error information for this failed task',
        taskDetailTimelineCard: 'Task timeline',
        taskDetailTimelineCardDesc: 'Status changes and events for this task',
        taskDetailErrorMessage: 'Error message',
        taskDetailErrorLog: '[[Error Log]] Entry',
        taskDetailRetryInfo: 'Retry {{count}} of {{max}}',
        taskDetailNotFound: '[[Provisioning Task]] not found.',
        taskDetailLoadError: 'Failed to load [[provisioning task]].',
        taskDetailBack: 'Back to [[provisioning tasks]]',
        timelineQueued: 'Task queued',
        timelineStarted: 'Task started',
        timelineFailed: 'Task failed',
        timelineCompleted: 'Task completed',
        timelineRetry: 'Retry attempt {{count}}',
        timelineCreatedAt: 'Created',
        timelineUpdatedAt: 'Last updated',
        statusQueued: 'Queued',
        statusInProgress: 'In progress',
        statusSuccess: 'Success',
        statusFailed: 'Failed',
        statusRunning: 'Running',
        historySearchPlaceholder: 'Search [[identity]], system, or entitlement...',
        historyMinQHint: '[[Type]] at least 3 characters to search.',
        historySearchScopeHint: 'Search matches display names only \u2014 the diagnostic error column is excluded.',
    },
    profile: {
        title: 'My profile',
        pageTitle: 'Profile',
        subtitle: 'Your account information and settings',
        personalInfo: 'Personal information',
        email: 'Email',
        fullName: 'Full name',
        username: 'Username',
        roles: '[[Roles]]',
        permissions: 'Permissions',
        noPermissions: 'No permissions assigned.',
        userProfile: 'User profile',
        accountInfo: 'Your account information from Keycloak',
        basicInfo: 'Basic information',
        accountDetails: 'Your account details',
        authUserId: 'Auth User ID',
        displayName: 'Display name',
        notProvided: 'Not provided',
        iamIdentity: 'IAM [[Identity]]',
        linkedIdentity: 'Your linked IAM [[Identity]]',
        identityId: '[[Identity]] ID',
        linked: 'Linked',
        viewIdentityDetails: 'View [[identity]] Details',
        noIdentityLinked: 'No IAM [[Identity]] linked to this account.',
        contactAdmin: 'Contact your administrator to create an [[identity]] for your email address.',
        rolesAndPermissions: '[[Roles]] & Permissions',
        rolesAndPermissionsDesc: 'Your assigned [[roles]] and permissions',
        sessionInfo: 'Session information',
        sessionDetails: 'Current authentication session details',
        sessionStatus: 'Session status',
        authMethod: 'Authentication method',
        authMethodDesc: 'HTTP Session with HTTP-only cookies (Keycloak OIDC)',
        showPermissions: 'Show permissions',
        hidePermissions: 'Hide permissions',
        resource: '[[Resource]]',
        permissionCount: '{{count}} permission(s)',
    },
    impersonation: {
        impersonating: 'Impersonating',
        originalUser: 'Original user:',
        switchBack: 'Switch back',
        switchUser: 'Switch user',
        switchUserDescription: 'Impersonate another user to test their access.',
        switchUserDialogDescription: 'Select a user to impersonate. Your session will assume their [[identity]] and permissions.',
        selectUser: 'Select a user',
        searchPlaceholder: 'Search by name or email...',
        searchUsers: 'Search users...',
        switching: 'Switching...',
        switch: 'Switch',
        noUsersFound: 'No users found',
        switchToUser: 'Switch to {{name}}?',
        switchConfirmDescription: 'You will assume the [[identity]] and permissions of {{name}} ({{email}}). You can switch back at any time using the banner at the top of the page.',
        impersonatingSuffix: '({{email}}) \u2014 Original user: {{originalName}}',
    },
    timeSwitch: {
        serverTime: 'Server time',
        clockOverridden: 'Clock is overridden',
        setTime: 'Set time',
        quickAdvance: 'Quick advance',
        plusOneDay: '+1 day',
        plusSevenDays: '+7 days',
        plusThirtyDays: '+30 days',
        resetToSystemTime: 'Reset to System Time',
        timeSwitch: 'Time switch',
    },
    auth: {
        loopBreak: {
            title: 'Authentication loop detected',
            description: 'The app is repeatedly redirecting to login without success. This usually means your session could not be established.',
            tryAgain: 'Try again',
            logoutFully: 'Log out fully',
        },
    },
    serverStatus: {
        serverUnavailable: 'Server unavailable',
        serverUnavailableMessage: 'The backend server is currently unavailable. This may be due to a restart or maintenance.',
        retrying: 'Retrying...',
        retry: 'Retry now',
        lastChecked: 'Last checked:',
        checkingConnection: 'Checking connection...',
        waitingForServer: 'Waiting for server...',
        autoReconnect: 'The page will automatically reconnect when the server is available.',
    },
    executionLog: {
        executionLogs: '[[Execution]] Logs: {{name}}',
        executionLog: '[[Execution]] Log',
        noLogs: 'No logs available',
        logEntries: '{{count}} log entries',
        download: 'Download',
        timestamp: 'Timestamp',
        level: 'Level',
        message: 'Message',
        filterLogs: 'Filter logs...',
        showAll: 'All',
        showErrors: 'Errors',
        showWarnings: 'Warnings',
        autoScroll: 'Auto-scroll',
    },
    accessTimeline: {
        timeline: 'Access timeline',
        effectiveDate: 'Effective date',
        change: 'Change',
        source: 'Source',
        noTimelineData: 'No timeline data available.',
        loadingTimeline: 'Loading timeline...',
        viewDetails: 'View details',
        noAccessHistory: 'No access history found',
        by: 'by {{name}}',
        sourceLabel: 'Source: {{name}}',
    },
    expressionEditor: {
        expression: 'Expression',
        placeholder: 'Enter expression...',
        validate: 'Validate',
        validating: 'Validating...',
        valid: 'Valid expression',
        invalid: 'Invalid expression',
        field: 'Field',
        operator: 'Operator',
        value: 'Value',
        addCondition: 'Add condition',
        removeCondition: 'Remove',
        and: 'AND',
        or: 'OR',
        keyTab: 'Tab',
        keyEsc: 'Esc',
        keyCtrlZ: 'Ctrl+Z',
        keyCtrlShiftZ: 'Ctrl+Shift+Z',
        tabAccept: 'accept suggestion',
        escDismiss: 'dismiss',
        ctrlZUndo: 'undo',
        ctrlShiftZRedo: 'redo',
        identityAttributeHint: '[[Type]] attribute name (e.g., department)',
        partyAttributeHint: '[[Type]] attribute name',
    },
    attributeValidation: {
        minLength: '{{name}} must be at least {{min}} characters',
        maxLength: '{{name}} must be at most {{max}} characters',
        pattern: '{{name}} does not match the required format',
        minValue: '{{name}} must be at least {{min}}',
        maxValue: '{{name}} must be at most {{max}}',
        allowedValues: '{{name}} must be one of: {{values}}',
        invalidNumber: '{{name}} must be a valid number',
        invalidPattern: '{{name}} cannot be validated (invalid pattern configuration)',
        hintCharRange: '{{min}}\u2013{{max}} characters',
        hintCharExact: 'Exactly {{n}} characters',
        hintCharMin: 'At least {{min}} characters',
        hintCharMax: 'At most {{max}} characters',
        hintRange: 'Range: {{min}}\u2013{{max}}',
        hintMin: 'Minimum: {{min}}',
        hintMax: 'Maximum: {{max}}',
        hintPattern: 'Format: {{pattern}}',
        hintLabelLength: 'Length',
        hintLabelRange: 'Range',
        hintLabelPattern: 'Pattern',
        hintLabelMaxValues: 'Max values',
        patternUppercaseLetter: 'uppercase letter',
        patternLowercaseLetter: 'lowercase letter',
        patternDigit: 'digit',
        patternWordChar: 'word character',
        patternSpace: 'space',
        patternLetter: 'letter',
        patternLetterOrDigit: 'letter or digit',
        patternUppercaseOrDigit: 'uppercase letter or digit',
        patternLetterDigitUnderscore: 'letter, digit, or underscore',
        patternLetterDigitUnderscoreDash: 'letter, digit, underscore, or dash',
        patternUppercaseDigitUnderscore: 'uppercase letter, digit, or underscore',
        patternUppercaseDigitUnderscoreDash: 'uppercase letter, digit, underscore, or dash',
        patternAnyChar: 'any character',
        patternOneOrMore: 'one or more',
        patternZeroOrMore: 'zero or more',
        patternOptional: 'optional',
        maxOccurrences: '{{name}} allows at most {{max}} values',
        hintMultiValue: 'Up to {{max}} values',
    },
    durationInput: {
        days: 'Days',
        hours: 'Hours',
        minutes: 'Minutes',
        seconds: 'Seconds',
        invalidFormat: 'Invalid format. Use: 2h, 30m, 1h30m, or 45s',
        examples: 'Examples: 2h, 30m, 1h30m, 45s',
    },
    combobox: {
        searchPlaceholder: 'Search...',
        noResults: 'No results found.',
        select: 'Select...',
        typeToSearch: '[[Type]] to search...',
    },
    accessSnapshot: {
        loadingAccessState: 'Loading access state...',
        failedToLoad: 'Failed to load access state',
        noAccessGrants: 'No access grants at this time',
        grantsActive: '{{count}} grant(s) active at this time',
        grantCount: '{{count}} grant(s)',
    },
    identitySnapshot: {
        loadingIdentityState: 'Loading [[identity]] state...',
        failedToLoad: 'Failed to load [[identity]] state',
        noIdentityState: 'No [[identity]] state available',
        identityState: '[[Identity]] State',
        identityType: '[[Identity]] [[type]]',
        lifecycleState: 'Lifecycle state',
        party: '[[Party]]',
        identifiers: 'Identifiers',
        attributes: 'Attributes',
        noIdentifiersOrAttributes: 'No identifiers or attributes at this time',
    },
    timelineDetail: {
        stateAt: 'State at {{timestamp}}',
        accessState: 'Access state',
        identityState: '[[Identity]] State',
    },
    brandTheme: {
        lumon: 'Lumon industries',
        swiss: 'Swiss admin',
        muenchenstift: 'MÜNCHENSTIFT',
        bundesdruckerei: 'Bundesdruckerei',
        aargau: 'Kanton aargau',
        default: 'ID Pulse',
    },
    reporting: {
        title: 'Reporting & auditing',
        pageTitle: 'Reporting',
        subtitle: 'SQL-first reporting and compliance reports',
        welcome: 'Welcome to reporting',
        selectOption: 'Select a category or report from the sidebar.',
        categories: 'Report categories',
        categoriesDesc: 'Report categories',
        newReport: 'Create report',
        noCategories: 'No categories yet.',
        noReports: 'No reports in this category.',
        resultRows: '{{count}} row',
        resultRows_other: '{{count}} rows',
        runReport: 'Run report',
        saveReport: 'Save report',
        reportSaved: 'Report saved',
        trySql: 'Test SQL',
        running: 'Running...',
        runError: 'Report [[execution]] failed',
        saveReportDialog: {
            title: 'Save report',
            name: 'Report name',
            description: 'Description (optional)',
            category: 'Category',
            save: 'Save',
        },
        createCategory: 'Create category',
        createCategoryDialog: {
            title: 'Create category',
            name: 'Category name',
            description: 'Description (optional)',
            type: '[[Type]]',
            typeGlobal: 'Global (shared with all users)',
            typePersonal: 'Personal (only visible to you)',
        },
        exportSuccess: 'Export downloaded',
        categoryCreated: 'Category created',
        categoryDeleted: 'Category deleted',
        categoryUpdated: 'Category updated',
        categoryTransferred: 'Category transferred',
        categoryMoved: 'Category moved',
        reportDeleted: 'Report deleted',
        reportUpdated: 'Report updated',
        reportMoved: 'Report moved',
        reportsBulkDeleted: 'Reports deleted',
        reportsBulkMoved: 'Reports moved',
        reportCount: '{{count}} report',
        reportCount_other: '{{count}} reports',
        reportsLabel: 'Reports',
        categoryCount: '{{count}} category',
        categoryCount_other: '{{count}} categories',
        allTypes: 'All',
        typeGlobal: 'Global',
        typePersonal: 'Personal',
        lastModified: 'Last modified',
        author: 'Author',
        noCategoriesMatch: 'No categories match your search.',
        noReportsMatch: 'No reports match your search.',
        renameCategory: 'Rename',
        transferCategory: 'Transfer',
        moveCategory: 'Move',
        deleteCategory: 'Delete category',
        deleteCategoryConfirm: 'This will permanently delete "{{name}}" and all reports inside it.',
        transferCategoryDialog: {
            title: 'Transfer category',
            description: 'Change the visibility of this category.',
            toGlobal: 'Make Global (visible to all users)',
            toPersonal: 'Make Personal (visible only to you)',
        },
        renameDialog: {
            title: 'Rename category',
            description: 'Update the category name and description.',
        },
        moveCategoryDialog: {
            title: 'Move category',
            description: 'Move this category under another category, or to root level.',
            targetParent: 'Parent category',
        },
        parentCategory: 'Parent Category (optional)',
        noParent: 'None (root level)',
        editReportDialog: {
            title: 'Edit report',
            description: 'Update the report name and description.',
        },
        moveReportDialog: {
            title: 'Move report',
            description: 'Move this report to a different category.',
            targetCategory: 'Target category',
        },
        searchCategories: 'Categories',
        searchReports: 'Reports',
        reportSearchResults: '{{count}} report result',
        reportSearchResults_other: '{{count}} report results',
        reportSearchPlaceholder: 'Search reports across all categories...',
        categorySearchPlaceholder: 'Search categories by name...',
        allSearchPlaceholder: 'Search categories and reports...',
        reportDetail: {
            pageTitle: 'Report Details | Reporting',
            category: 'Category',
            lastRun: 'Last run',
            neverRun: 'Never run',
            results: 'Results',
            noResults: 'Run the report to see results.',
            editReport: 'Edit report',
            deleteReport: 'Delete',
            deleteConfirm: 'This will permanently delete the report "{{name}}".',
            loadingReport: 'Loading report...',
            truncatedBanner: 'More rows available, showing first {{shown}}.',
            createTitle: 'Create report',
            createParameterHintPrefix: 'To add parameters to this report, please',
            createParameterHintLink: 'save',
            createParameterHintSuffix: 'first.',
        },
        parameters: {
            title: 'Parameters',
            add: 'Add',
            addPlaceholder: 'Parameter name (e.g. state)',
        },
        assist: {
            title: 'AI SQL Assistant',
            suggestSql: 'Suggest SQL',
            suggesting: 'Suggesting...',
            apply: 'Apply suggestion',
            placeholder: 'Describe what you want to query...',
            fixPrefix: 'Fix this error',
            fixWithAi: 'Fix with AI',
            unsaved: 'unsaved changes',
        },
        searchAll: 'All',
        collapseAll: 'Collapse all',
        schedule: {
            title: 'Schedule',
            description: 'Run this report on a recurring schedule and deliver results to recipients.',
            preset: 'Preset',
            presetNone: 'None',
            presetDaily: 'Daily',
            presetWeekly: 'Weekly',
            presetMonthly: 'Monthly',
            presetCustom: 'Custom',
            daysOfWeek: 'Days of week',
            dayMon: 'Mon',
            dayTue: 'Tue',
            dayWed: 'Wed',
            dayThu: 'Thu',
            dayFri: 'Fri',
            daySat: 'Sat',
            daySun: 'Sun',
            dayOfMonth: 'Day of month',
            rawCron: 'Cron expression',
            rawCronHint: 'six-field cron: second minute hour day-of-month month day-of-week',
            nextRun: 'Next run',
            nextRunUnset: '—',
            invalidCron: 'Invalid cron expression',
            recipients: 'Recipients',
            recipientIdentities: '[[Identity]] recipients',
            recipientIdentitiesPlaceholder: 'Search [[identities]] by name…',
            recipientIdentitiesEmpty: 'No [[identity]] recipients selected.',
            recipientEmails: 'Email recipients',
            emailPlaceholder: 'Add an email address and press Enter',
            invalidEmail: 'Invalid email address',
            emailRejectedSummary: '{{count}} address rejected as invalid.',
            emailRejectedSummary_other: '{{count}} addresses rejected as invalid.',
            notificationTemplate: '[[Notification]] template',
            defaultTemplate: 'Default — Report delivered',
            removeRecipient: 'Remove',
            unsavedSchedule: 'Save to apply schedule changes.',
            noSchedule: 'No schedule configured.',
            noRecipients: 'No recipients configured.',
            identityRecipientCount: '{{count}} [[identity]] recipient',
            identityRecipientCount_other: '{{count}} [[identity]] recipients',
        },
    },
    notifications: {
        pageTitle: '[[Notifications]]',
        title: '[[Notifications]]',
        subtitle: 'Your [[notification]] history',
        bellTooltip: '[[Notifications]]',
        markAllRead: 'Mark all as read',
        viewAll: 'View all [[notifications]]',
        noNotifications: 'No [[notifications]] yet.',
        noNotificationsMatch: 'No [[notifications]] match the current filters.',
        notificationCount: '{{count}} [[notification]]',
        notificationCount_other: '{{count}} [[notifications]]',
        unreadCount: '{{count}} unread',
        matchingFilters: '(filtered)',
        // Column headers
        title_column: 'Title',
        message: 'Message',
        eventType: 'Event [[type]]',
        date: 'Date',
        readStatus: 'Status',
        read: 'Read',
        unread: 'Unread',
        // Filters
        allEventTypes: 'All event types',
        allReferenceTypes: 'All reference types',
        allStatuses: 'All statuses',
        filterPlaceholder: 'Search [[notifications]]...',
        // Event types
        eventAccessRequestCreated: '[[Access Request]] created',
        eventAccessRequestApproved: '[[Access Request]] approved',
        eventAccessRequestRejected: '[[Access Request]] rejected',
        eventAccessRequestCancelled: '[[Access Request]] cancelled',
        eventAccessProfileAssignmentGranted: '[[Access Profile]] granted',
        eventAccessProfileAssignmentGrantedByRule: '[[Access Profile]] granted by rule',
        eventAccessProfileAssignmentRevoked: '[[Access Profile]] revoked',
        eventAccessProfileAssignmentRestored: '[[Access Profile]] restored',
        eventFunctionGroupRequestCreated: '[[Function Group Request]] created',
        eventFunctionGroupRequestApproved: '[[Function Group Request]] approved',
        eventFunctionGroupRequestRejected: '[[Function Group Request]] rejected',
        eventFunctionGroupRequestCancelled: '[[Function Group Request]] cancelled',
        eventFunctionGroupAssignmentGranted: '[[Function Group]] assigned',
        eventFunctionGroupAssignmentGrantedByRule: '[[Function Group]] assigned by rule',
        eventFunctionGroupAssignmentRevoked: '[[Function Group]] removed',
        eventFunctionGroupAssignmentRestored: '[[Function Group]] re-assigned',
        eventAccessProfileAssignmentExpiring: '[[Access Profile]] expiring soon',
        eventFunctionGroupAssignmentExpiring: '[[Function Group]] expiring soon',
        eventIdentitySuspended: '[[Identity]] suspended',
        eventIdentityTerminated: '[[Identity]] terminated',
        eventProvisioningFailed: 'Provisioning failed',
        eventCertificationCampaignStarted: '[[Recertification Campaign]] started',
        eventCertificationItemPending: 'Recertification review pending',
        eventCertificationItemOverdue: 'Recertification review overdue',
        eventCertificationCampaignCompleted: '[[Recertification Campaign]] completed',
        eventReportDelivered: 'Report delivered',
        // Admin log
        adminLogTitle: '[[Notification]] Log',
        adminLogPageTitle: '[[Notification]] Log',
        adminLogSubtitle: 'System-wide [[notification]] delivery log',
        adminLogDescription: 'Monitor [[notification]] delivery status',
        recipient: 'Recipient',
        deliveryStatus: 'Delivery status',
        error: 'Error',
        sentAt: 'Sent at',
        statusSent: 'Sent',
        statusPending: 'Pending',
        statusFailed: 'Failed',
        // Detail page
        detailPageTitle: '[[Notification]] Detail',
        detailTitle: '[[Notification]] Details',
        detailDescription: 'Full details of this [[notification]]',
        referenceType: 'Reference [[type]]',
        referenceId: 'Reference ID',
        goToReference: 'Go to referenced entity',
        loadingNotification: 'Loading [[notification]]...',
        referenceTypeAccessRequest: '[[Access Request]]',
        referenceTypeAccessProfileAssignment: '[[Access Profile Assignment]]',
        referenceTypeFunctionGroupRequest: '[[Function Group Request]]',
        referenceTypeFunctionGroupAssignment: '[[Function Group Assignment]]',
        referenceTypeIdentity: '[[Identity]]',
        referenceTypeProvisioningTask: '[[Provisioning Task]]',
    },
    errorCodes: {
        GN0001: 'This [[resource]] has been modified. Please refresh and try again.',
        GN0002: '{{entity}} not found.',
        GN0003: 'Access denied.',
        SESSION_EXPIRED: 'Your session has expired — please log in again.',
        SERVER_UNAVAILABLE: 'Server is unavailable — please retry in a moment.',
        UNAUTHORIZED: 'Your session has expired — please log in again.',
        GN0005: '{{entity}} already exists.',
        GN0007: 'Permission denied: cannot {{action}} {{resource}}.',
        VS0001: 'Validation rule \'{{rule}}\' is not applicable for value type {{valueType}}.',
        VS0003: 'Validation rule \'{{rule}}\': {{detail}}.',
        VS0004: 'Validation rules conflict: {{conflict}}.',
        VS0005: 'Validation rule \'{{rule}}\': must be a positive integer.',
        VS0006: 'Validation rule \'{{rule}}\': must be greater than 0.',
        VS0007: 'Validation rule \'{{rule}}\': invalid regular expression: {{description}}.',
        VS0008: 'Validation rule \'{{rule}}\': LIST requires a non-empty values list.',
        VS0009: 'Validation rule \'{{rule}}\': LIST entry code must not be blank.',
        VS0010: 'Validation rule \'{{rule}}\': LIST entry label must not be blank.',
        VS0011: 'Validation rule \'{{rule}}\': LIST entry codes must be unique, duplicate: {{duplicate}}.',
        VS0012: 'Validation rule \'{{rule}}\': ENUM requires a typeName.',
        VS0013: 'Validation rule \'{{rule}}\': unknown type \'{{typeName}}\'.',
        VS0014: 'Validation rule \'{{rule}}\': CUSTOM_LIST requires a listName.',
        VS0015: 'Validation rule \'{{rule}}\': unique constraint is only supported for STRING attributes.',
        VS0016: 'Validation rule \'{{rule}}\': unique constraint is not allowed for multi-valued attributes.',
        VS0017: 'Validation rule \'{{rule}}\': unique constraint is not allowed with value source.',
        TM0001: 'The team lead must be a person.',
        TM0002: 'A team cannot be a member of itself.',
        TM0003: 'This [[party]] is already a member of this team.',
        TM0004: 'The selected [[party]] is not a team.',
        TM0005: 'Cannot delete team with active responsibilities.',
        TM0006: 'Membership not found.',
    },
    schemaPolicies: {
        title: 'Schema policies',
        pageTitle: 'Schema Policies | Schema',
        detailPageTitle: 'Schema Policy | Schema',
        createPageTitle: 'Create Schema Policy | Schema',
        subtitle: 'Rules about valid IAM data shape',
        allPolicies: 'All schema policies',
        policiesCount: '{{count}} policies',
        policiesCount_one: '{{count}} policy',
        policiesCount_other: '{{count}} policies',
        loadingPolicies: 'Loading schema policies...',
        noPoliciesFound: 'No schema policies defined yet.',
        noPoliciesMatch: 'No schema policies match your filters.',
        searchPolicies: 'Search schema policies...',
        createPolicy: 'Create schema policy',
        editPolicy: 'Edit schema policy',
        createFirstPolicy: 'Create the first schema policy',
        name: 'Name',
        description: 'Description',
        type: '[[Type]]',
        typeDsl: 'DSL',
        typeNativeCode: 'Native code',
        severity: 'Severity',
        expression: 'Expression',
        constraintCode: 'Producer code',
        messageTemplate: 'Message template',
        enabled: 'Enabled',
        evalStatus: 'Status',
        evalStatusStale: 'Reference broken',
        openViolations: 'Open violations',
        lastReviewed: 'Last reviewed',
        lastReviewedNever: 'Never',
        owner: 'Owner',
        version: 'Version',
        actionEnable: 'Enable',
        actionDisable: 'Disable',
        actionReview: 'Mark reviewed',
        actionTrigger: 'Run on demand',
        severityInfo: 'INFO',
        severityWarn: 'WARN',
        severityError: 'ERROR',
        severityCritical: 'CRITICAL',
        messageTemplatePlaceholder: '{constraintName} violated by {subjectId}',
    },
    schemaViolations: {
        title: 'Schema violations',
        pageTitle: 'Schema Violations | Schema',
        detailPageTitle: 'Schema Violation | Schema',
        allViolations: 'All schema violations',
        violationsCount: '{{count}} violations',
        violationsCount_one: '{{count}} violation',
        violationsCount_other: '{{count}} violations',
        loadingViolations: 'Loading schema violations...',
        noViolationsFound: 'No schema violations found.',
        noViolationsMatch: 'No schema violations match your filters.',
        searchViolations: 'Search schema violations...',
        policy: 'Policy',
        detectedAt: 'Detected at',
        severity: 'Severity',
        status: 'Status',
        statusOpen: 'Open',
        statusAcked: 'Acknowledged',
        statusResolved: 'Resolved',
        message: 'Message',
        ackedBy: 'Acknowledged by',
        ackedAt: 'Acknowledged at',
        resolvedAt: 'Resolved at',
        actionAck: 'Acknowledge',
        bulkAck: 'Bulk acknowledge',
        toggleAll: 'Toggle all violations',
        selectRow: 'Select violation',
        severityBadgeLabel: 'Schema violations',
        noOpenViolations: 'No violations',
        referenceBroken: 'Reference broken',
        viewViolations: 'View violations',
        severityCritical: 'CRITICAL',
        severityError: 'ERROR',
        severityWarn: 'WARN',
        severityInfo: 'INFO',
        severityCountCritical: '{{count}} CRITICAL',
        severityCountError: '{{count}} ERROR',
        severityCountWarn: '{{count}} WARN',
        ackSubmitError: 'Failed to acknowledge — try again.',
    },
    certificationPolicies: {
        title: '[[Certification Policies]]',
        pageTitle: '[[Certification Policies]] | [[access governance]]',
        detailPageTitle: '[[Certification Policy]] Details | [[access governance]]',
        createPageTitle: 'Create [[certification policy]] | [[access governance]]',
        subtitle: 'Manage certification review policies',
        allPolicies: 'All [[certification policies]]',
        policiesCount: '{{count}} policies',
        loadingPolicies: 'Loading [[certification policies]]...',
        loadingPolicy: 'Loading [[certification policy]]...',
        noPoliciesFound: 'No [[certification policies]] found.',
        searchPolicies: 'Search policies...',
        noPoliciesMatch: 'No policies match your filters.',
        allStatuses: 'All statuses',
        createPolicy: 'Create policy',
        editPolicy: 'Edit [[certification policy]]',
        createNewPolicy: 'Create [[certification policy]]',
        name: 'Name',
        description: 'Description',
        priority: 'Priority',
        priorityPlaceholder: 'e.g., 10',
        priorityHelp: 'Lower values are evaluated first (1 = highest priority)',
        reviewFrequencyDaysPlaceholder: 'e.g., 90',
        gracePeriodDaysPlaceholder: 'e.g., 14',
        conditions: 'Conditions',
        conditionsCount: '{{count}} condition',
        conditionsCount_other: '{{count}} conditions',
        frequency: 'Frequency',
        frequencyDays: '{{days}} days',
        noFrequency: 'Profile default',
        defaultBadge: 'Default',
        active: 'Active',
        policyDetails: 'Policy details',
        policyDetailsDesc: 'Core configuration for this [[certification policy]]',
        parameters: 'Parameters',
        parametersDesc: 'Review and response parameters',
        reviewFrequencyDays: 'Review Frequency (Days)',
        overrideReviewFrequency: 'Override profile review frequency',
        overrideReviewFrequencyDescription: 'Uses a custom review frequency instead of each [[access profile]]\'s own review cycle.',
        useProfileFrequency: 'Uses each [[access profile]]\'s own review frequency to determine when assignments are due.',
        reviewerType: 'Reviewer [[type]]',
        gracePeriodDays: 'Grace Period (Days)',
        nonResponseAction: 'Non-Response Action',
        autoRevokeOnOverdue: 'Auto Revoke on Overdue',
        campaignOwner: '[[Campaign]] Owner',
        campaignOwnerDesc: 'Optional [[identity]] used as [[campaign]] owner when [[campaigns]] are generated from this policy. If not set, the global fallback is used.',
        searchOwner: 'Search owner [[identity]]...',
        noIdentitiesFound: 'No [[identities]] found',
        reviewerTypeProfileOwner: 'Profile owner',
        reviewerTypeResourceOwner: '[[Resource]] Owner',
        reviewerTypeManager: 'Manager',
        nonResponseNoChange: 'No change',
        nonResponseAutoRevoke: 'Auto revoke',
        nonResponseEscalate: 'Escalate',
        policySaved: '[[Certification Policy]] saved.',
        policyCreated: '[[Certification Policy]] created.',
        policyDeleted: '[[Certification Policy]] deleted.',
        deletePolicy: 'Delete policy',
        deleteConfirm: 'Are you sure you want to delete the [[certification policy]] "{{name}}"? This action cannot be undone.',
        saveError: 'Failed to save [[certification policy]].',
        nameRequired: 'Name is required.',
        priorityRequired: 'Priority is required.',
        conditionsDesc: 'Define when this policy applies based on matching criteria',
        addCondition: 'Add condition',
        noConditions: 'No conditions defined. This policy applies to all access assignments.',
        conditionField: 'Field',
        conditionOperator: 'Operator',
        conditionValue: 'Value',
        conditionValuePlaceholder: 'Enter value...',
        removeCondition: 'Remove condition',
        conditionFieldLabels: {
            RISK_LEVEL: 'Risk level',
            SOURCE_TYPE: 'Source [[type]]',
            RESOURCE_TYPE: '[[Resource]] [[type]]',
            ENVIRONMENT: 'Environment',
        } as Record<string, string>,
        conditionOperatorLabels: {
            EQUALS: 'Equals',
            NOT_EQUALS: 'Not equals',
            IN: 'In',
        } as Record<string, string>,
        sourceTypeLabels: {
            RULE: 'Rule',
            REQUEST: '[[Request]]',
        } as Record<string, string>,
        createCampaign: 'Create [[campaign]]',
        createCampaignDesc: 'Create a new certification [[campaign]] from this policy',
        campaignCount: '{{count}} [[campaign]](s)',
        viewCampaigns: 'View [[campaigns]]',
        campaignRunning: 'A [[Campaign]] is already running for this policy',
        policyNotActive: 'Policy must be active to create a [[campaign]]',
        campaignCreatedFromPolicy: '[[Campaign]] created from policy.',
        scopeModeConditions: 'Conditions',
        scopeModeExpression: 'Expression',
        switchModeConfirmTitle: 'Switch scope mode',
        switchModeConfirmBody: 'Switching modes will clear the existing scope definition. Continue?',
        expressionLabel: 'Scope expression',
        expressionPlaceholder: "e.g., access.profile.riskLevel >= 'HIGH'",
        expressionInvalid: 'Invalid expression',
        expressionRequired: 'Scope expression is required.',
        previewMatchingAccess: 'Preview matching access',
        previewDialogTitle: 'Preview — Matching Access',
        previewDialogDesc: 'Dry-run result for the current expression.',
        previewStatTotal: 'Total evaluated',
        previewStatInScope: 'In scope',
        previewStatOutOfScope: 'Out of Scope',
        previewNoMatches: 'No access assignments matched the expression.',
        previewSampleCaption: 'Showing {{count}} of {{matched}} matching assignments.',
        previewColIdentity: '[[Identity]]',
        previewColProfile: 'Profile',
        previewColResource: '[[Resource]]',
        previewColTargetSystem: '[[Target System]]',
        previewColRiskLevel: 'Risk level',
        scopeModeExpressionBadge: 'Expression',
        previewZeroMatchWarning: 'This expression matches no active assignments. A [[Campaign]] started with this policy will have no scope.',
        summary: {
            basicsSection: 'Basics',
            scopeSection: 'Scope',
            reviewSettingsSection: 'Review settings',
            editBasics: 'Edit basics',
            editScope: 'Edit scope',
            editReviewSettings: 'Edit review settings',
            defaultPolicyNotEditable: 'This is the default policy and cannot be edited.',
            openCampaignWarning: 'This policy already has an open [[campaign]]. Staging another [[campaign]] is allowed but may result in duplicate review work.',
            validFrom: 'Valid from',
            validTo: 'Valid to',
            scopeMode: 'Scope definition',
            scopeModeConditions: 'Structured conditions',
            scopeModeExpression: 'CEL expression',
            conditions: '{{count}} condition(s)',
            expression: 'CEL expression',
            certifyEverything: 'No conditions — certifies all active assignments.',
            reviewFrequency: 'Review frequency',
            owner: '[[Campaign]] Owner',
            noOwner: 'Global fallback',
        },
        wizard: {
            createTitle: 'Create [[certification policy]]',
            editTitle: 'Edit Policy — {{name}}',
            createPageTitle: 'Create [[certification policy]] | [[access governance]]',
            editPageTitle: 'Edit Policy — {{name}} | [[access governance]]',
            stepBasics: 'Basics',
            stepScope: 'Scope',
            stepReviewSettings: 'Review settings',
            stepLaunch: 'Launch',
            stepBasicsDesc: 'Name, priority, and the optional active date window for this policy.',
            stepScopeDesc: 'Define which assignments this policy certifies.',
            stepReviewSettingsDesc: 'Who reviews, how often, and what happens when no one responds.',
            stepLaunchDesc: 'Review the policy and choose how to proceed.',
            nameLabel: 'Name',
            namePlaceholder: 'e.g., Quarterly High-Risk Review',
            descriptionPlaceholder: 'Optional description of what this policy certifies',
            priorityLabel: 'Priority',
            activeLabel: 'Active',
            validFromLabel: 'Valid from',
            validToLabel: 'Valid to',
            validFromHelp: 'Optional — the policy is inactive before this date.',
            validToHelp: 'Optional — the policy is inactive after this date.',
            validToAfterValidFrom: 'Valid To must be after Valid From.',
            reviewerTypeLabel: 'Reviewer [[type]]',
            reviewerTypeManagerDesc: 'The [[identity]]\'s manager receives the review tasks.',
            reviewerTypeProfileOwnerDesc: 'The owner of each [[access profile]] receives the review tasks.',
            reviewerTypeResourceOwnerDesc: 'The owner of each underlying [[resource]] receives the review tasks.',
            reviewerTypeCampaignOwnerDesc: 'The [[campaign]] owner receives the review tasks.',
            useProfileFrequencyHint: 'Leave off to use each profile\'s review frequency.',
            gracePeriodHint: 'Days after the due date before the non-response action fires.',
            autoRevokeHint: 'Revoke access automatically once the [[campaign]] due date passes, regardless of reviewer response.',
            campaignOwnerLabel: '[[Campaign]] Owner',
            back: 'Back',
            next: 'Next',
            nextToLaunch: 'Next → Launch',
            saveAndReturn: 'Save & return',
            scopeStub: 'Scope is configured in the next step.',
            scopeModeConditions: 'Conditions',
            scopeModeExpression: 'Expression',
            switchModeConfirmTitle: 'Switch scope mode',
            switchToConditionsConfirmBody: 'Switching to conditions mode will remove your expression. This cannot be undone within the wizard.',
            switchToExpressionConfirmBody: 'Switching to expression mode will remove your {{count}} conditions. This cannot be undone within the wizard.',
            noConditionsInfo: 'No conditions set — this policy will certify all active assignments.',
            previewSectionTitle: 'Scope preview',
            previewNoQuery: 'Set conditions or an expression above to see who will be in scope.',
            previewZeroMatch: '0 assignments match the current scope — no certifications would be generated.',
            previewError: 'Could not load scope preview.',
            previewRetry: 'Retry',
            previewSampleCaption: 'Showing first {{count}} of {{matched}} matches.',
            previewTooLarge: 'Scope preview is not available when the active assignment population exceeds the preview limit — your expression will be validated at [[campaign]] generation.',
            previewFrequencyDisclaimer: 'Preview shows all matching assignments regardless of certification frequency. Generation will select only assignments that are due.',
            previewInScope: '{{matched}} of {{total}} in scope',
            previewColIdentity: '[[Identity]]',
            previewColProfile: 'Profile',
            previewColResource: '[[Resource]]',
            previewColRiskLevel: 'Risk level',
            launchStub: 'The policy is saved. Staging and activation land in a later step.',
            finish: 'Finish',
            policySaved: 'Policy saved — choose how to proceed below.',
            policyUpdated: 'Policy updated — choose how to proceed below.',
            persistError: 'Could not save the policy. Please review the fields and try again.',
            defaultPolicyTitle: 'Default policy',
            defaultPolicyInfo: 'This is the default policy and cannot be edited.',
            forbidden: 'You do not have permission to access this page.',
            launch: {
                sectionTitle: 'Launch',
                alreadySavedNote: 'Policy already saved — going back will not undo it.',
                summaryTitle: 'Policy summary',
                summaryBasics: 'Basics',
                summaryScope: 'Scope',
                summaryReviewSettings: 'Review settings',
                scopeCountLabel: 'In scope',
                scopeCountValue: '{{matched}} of {{total}} assignments',
                stage: 'Stage [[campaign]]',
                stageAndActivate: 'Stage & activate',
                openCampaignWarning: 'This policy already has an open [[campaign]]. Staging another [[campaign]] is allowed but may result in duplicate review work.',
                partialFailure: '[[Campaign]] staged but activation failed — you can activate it from the [[campaign]] detail page.',
                goToCampaign: 'Go to [[campaign]]',
                stageError: 'Policy saved, but the [[campaign]] could not be created.',
                noCampaignPermission: 'You do not have permission to create [[campaigns]].',
                campaignNamePrefill: '{{policyName}} certification',
                stagedToast: '[[Campaign]] staged.',
                stagedAndActivatedToast: '[[Campaign]] staged and activated.',
                finishedToast: '[[Certification Policy]] saved.',
            },
        },
    },
    certificationCampaigns: {
        title: 'Certification [[campaigns]]',
        pageTitle: 'Certification [[campaigns]] | [[access governance]]',
        detailPageTitle: '[[Campaign]] Details | [[access governance]]',
        subtitle: 'Manage access certification [[campaigns]]',
        allCampaigns: 'All [[campaigns]]',
        campaignsCount: '{{count}} [[campaigns]]',
        noCampaignsFound: 'No certification [[campaigns]] found.',
        noReviewItemsFound: 'No review items found for this [[campaign]].',
        createCampaign: 'Create [[campaign]]',
        createDescription: 'Create a new certification [[campaign]]',
        createSuccess: '[[Campaign]] "{{name}}" created.',
        name: 'Name',
        description: 'Description',
        status: 'Status',
        dueDate: 'Due date',
        owner: 'Owner',
        policy: 'Policy',
        startedAt: 'Started',
        completedAt: 'Completed',
        progress: 'Progress',
        totalReviewItems: 'Total review items',
        completedReviewItems: 'Completed',
        keepCount: 'Keep',
        revokedCount: 'Revoke',
        autoRevokeCount: 'Auto-Revoke',
        reviewItemsProgress: 'Review items progress',
        decisionsBreakdown: 'Decisions',
        assignments: 'assignments',
        pendingDecisions: 'Undecided',
        searchReviewItems: 'Search [[identity]] or reviewer...',
        noReviewItemsMatch: 'No review items match your filters.',
        allReviewStatuses: 'All statuses',
        activate: 'Activate',
        cancel: 'Cancel [[campaign]]',
        activateConfirm: 'Are you sure you want to activate this [[campaign]]? This will start the review process.',
        cancelConfirm: 'Are you sure you want to cancel this [[campaign]]? This action cannot be undone.',
        generate: 'Generate [[campaigns]]',
        generateDescription: 'Auto-generate [[campaigns]] from active policies',
        generateExplanation: 'This will evaluate all active [[certification policies]] and create new [[campaigns]] for any access assignments that are due for review. Each [[campaign]] is created in staging status, giving you the opportunity to review it before activation. Only assignments that have not been recently certified will be included.',
        ownerIdentity: 'Owner [[identity]]',
        searchOwner: 'Search for owner...',
        noIdentitiesFound: 'No [[identities]] found.',
        selectPolicy: 'Select a [[certification policy]]...',
        noPoliciesFound: 'No [[certification policies]] found.',
        filterByStatus: 'Filter by status',
        searchByName: 'Search by [[campaign]] name...',
        reviewItems: 'Review items',
        decisions: 'Decisions',
        statistics: 'Statistics',
        statusStaging: 'Staging',
        statusBeforeGeneration: 'Pending generation',
        statusInGeneration: 'Generating...',
        statusStarted: 'Started',
        statusCompleted: 'Completed',
        statusCancelled: 'Cancelled',
        previewTitle: 'Estimated impact',
        previewIdentityCount: '[[Identities]]',
        previewAssignmentCount: 'Assignments',
        previewExplanation: 'These numbers reflect the current state based on active policies and are subject to change. The final scope will be determined when the [[campaign]] is activated.',
        editCampaign: 'Edit [[campaign]]',
        editDescription: 'Update [[campaign]] details',
        campaignUpdated: '[[Campaign]] updated.',
        generateSuccess: 'Generated {{count}} [[campaign]](s) in staging status.',
        generateSkipped: 'Skipped {{count}} policy/policies with open [[campaigns]]: {{policies}}.',
        generateNoCampaigns: 'All access assignments are up to date. No new [[campaigns]] needed.',
        deleteCampaign: 'Delete [[campaign]]',
        deleteConfirm: 'Are you sure you want to delete the [[campaign]] "{{name}}"? This action cannot be undone.',
        campaignDeleted: '[[Campaign]] deleted.',
        campaignActivated: '[[Campaign]] activated.',
        campaignCancelled: '[[Campaign]] cancelled.',
        origin: 'Origin',
        originManual: 'Manual',
        originPolicyGenerated: 'Generated from policy',
        originPolicyGeneratedWithPolicy: 'Generated from policy: {{policyName}}',
    },
    certificationReviews: {
        title: 'My certification reviews',
        pageTitle: 'My Reviews | [[access governance]]',
        subtitle: 'Review and certify access assignments',
        noReviewsFound: 'No certification reviews assigned to you.',
        reviewItemsCount: '{{count}} review items',
        identity: '[[Identity]]',
        reviewer: 'Reviewer',
        status: 'Status',
        totalAssignments: 'Total assignments',
        decidedAssignments: 'Decided',
        selfCertification: 'Self-Certification',
        fallbackReviewer: 'Fallback',
        certify: 'Certify',
        certifySuccess: '{{name}} certified successfully.',
        certifyConfirmDescription: 'Are you sure you want to certify all access assignments for {{name}}?',
        revoke: 'Revoke',
        reassign: 'Reassign',
        bulkCertify: 'Bulk certify',
        bulkCertifyCount: 'Bulk Certify ({{count}})',
        bulkCertifyDescription: 'Are you sure you want to certify {{count}} selected review items?',
        bulkCertifySuccess: '{{count}} review items certified successfully.',
        bulkDecide: 'Bulk decide',
        comment: 'Comment',
        reassignTo: 'Reassign to',
        reassignDescription: 'Transfer this review item to a different reviewer',
        reassignSuccess: 'Review item reassigned.',
        searchIdentity: 'Search for [[identity]]...',
        decisionUndecided: 'Undecided',
        decisionKeep: 'Keep',
        decisionRevoke: 'Revoke',
        decisionAutoRevoke: 'Auto-Revoke',
        accessProfile: '[[Access Profile]]',
        riskLevel: 'Risk level',
        decidedBy: 'Decided by',
        decidedAt: 'Decided at',
        statusPending: 'Pending',
        statusInReview: 'In review',
        statusCompleted: 'Certified',
        searchPlaceholder: 'Search [[identities]]...',
        allStatuses: 'All statuses',
        startReview: 'Start review',
        continueReview: 'Continue review',
        allAssignments: 'All assignments',
        allAssignmentsCount: 'All {{count}} Assignments',
        bulkDecideTitle: 'Bulk decision',
        bulkDecideDescription: 'Apply a decision to all filtered assignments',
        bulkDecideAffected: 'This will affect {{count}} assignments and overrides any already taken decisions.',
        bulkDecideSummary: '{{count}} items will be set to {{decision}}',
        bulkDecideSuccess: '{{count}} assignments updated',
        filterByRiskLevel: 'Risk level',
        filterByDecision: 'Decision',
        allRiskLevels: 'All risk levels',
        allDecisions: 'All decisions',
        undecided: 'Undecided',
        keep: 'Keep',
        noRiskLevel: 'No risk level',
        searchAssignments: 'Search assignments...',
        decisionRecorded: 'Decision recorded',
        decisionKept: 'Access kept — assignment will be retained.',
        decisionRevoked: 'Access marked for revocation — will be removed upon certification.',
        decisionReset: 'Decision reset to undecided.',
        campaign: '[[Campaign]]',
        dueDate: 'Due date',
        previousItem: 'Previous',
        nextItem: 'Next',
    },
    certificationDashboard: {
        title: 'Certification dashboard',
        pageTitle: 'Certification Dashboard | [[access governance]]',
        subtitle: 'Overview of certification [[campaigns]] and review progress',
        activeCampaigns: 'Active [[campaigns]]',
        activeCampaignsDesc: 'Currently running certification [[campaigns]]',
        overdueCampaigns: 'Overdue [[campaigns]]',
        overdueCampaignsDesc: '[[Campaigns]] that have passed their due date',
        completionPercent: 'Completion',
        completionPercentDesc: 'Overall review completion rate',
        completionValue: '{{value}}%',
        totalKeep: 'Keep',
        totalKeepDesc: 'Total access items kept',
        totalRevoked: 'Revoked',
        totalRevokedDesc: 'Total access items revoked',
        keepAndRevoked: '{{keep}} keep / {{revoked}} revoke',
        reviewProgress: 'Review progress',
        reviewProgressDesc: 'Overall review item completion',
        decisionsOverview: 'Decisions overview',
        decisionsOverviewDesc: 'Breakdown of certification decisions',
        undecided: 'Undecided',
        keep: 'Keep',
        revoked: 'Revoke',
        pending: 'Pending',
        activeCampaignsList: 'Active [[campaigns]]',
        activeCampaignsListDesc: 'Currently running certification [[campaigns]] with progress',
        campaign: '[[Campaign]]',
        dueDate: 'Due date',
        progress: 'Progress',
        overdue: 'Overdue',
        noCampaigns: 'No active [[campaigns]].',
        ofTotal: '{{completed}} of {{total}} items',
        campaignManagement: '[[Campaign Management]]',
        campaignManagementDesc: '[[Campaigns]] in staging, generation, completed, or cancelled state',
        noManagementCampaigns: 'No [[campaigns]] to manage.',
    },
    restrictionRules: {
        title: '[[Restriction Rules]]',
        pageTitle: '[[Restriction Rules]] | [[access governance]]',
        detailPageTitle: '[[Restriction Rule]] Details | [[access governance]]',
        subtitle: 'Manage Separation of Duty [[restriction rules]] to prevent conflicting access',
        allRules: 'All [[restriction rules]]',
        ruleCount: '{{count}} rules',
        searchByName: 'Search by name...',
        activeOnly: 'Active only',
        allStatus: 'All status',
        activeRulesOnly: 'Active rules only',
        noRulesFound: 'No [[restriction rules]] found.',
        noRulesMatch: 'No [[restriction rules]] match your filters.',
        loading: 'Loading [[restriction rules]]...',
        deniedProfiles: 'Denied profiles',
        deniedProfilesCount: '{{count}} denied profile(s)',
        violations: 'Violations',
        openViolations: 'Open violations',
        openViolationsCount: '{{count}} open violation(s)',
        openViolationsForRule: 'Open violations detected for this rule',
        owner: 'Owner',
        ruleDetails: 'Rule details',
        ruleInformation: 'Rule information',
        conditionExpression: 'Condition expression',
        conditionExpressionDesc: '[[Identities]] matching this condition are restricted from the denied profiles',
        profileCode: 'Code',
        profileName: 'Profile',
        resource: '[[Resource]]',
        system: 'System',
        noConditionExpression: 'No condition expression set.',
        noProfiles: 'No denied profiles configured.',
        identity: '[[Identity]]',
        violatingProfile: 'Violating profile',
        detectedAt: 'Detected at',
        detectViolations: 'Detect violations',
        detecting: 'Detecting...',
        detectCompleted: 'Violation detection completed.',
        testRule: 'Test rule',
        testing: 'Testing...',
        testResults: 'Test results',
        testFailed: 'Test failed',
        evaluated: 'Evaluated',
        matched: 'Matched',
        edit: 'Edit',
        activateRule: 'Activate rule',
        activateRuleDesc: 'Are you sure you want to activate the rule "{{name}}"? It will start enforcing restrictions.',
        createActivateRequest: 'Activate rule',
        deactivateRule: 'Deactivate rule',
        deactivateRuleDesc: 'Are you sure you want to deactivate the rule "{{name}}"? Restrictions will no longer be enforced.',
        createDeactivateRequest: 'Deactivate rule',
        deleteRule: 'Delete rule',
        deleteConfirm: 'Are you sure you want to delete the rule "{{name}}"? This action cannot be undone.',
        ruleDeleted: '[[Restriction Rule]] deleted.',
        ruleActivated: '[[Restriction Rule]] activated.',
        ruleDeactivated: '[[Restriction Rule]] deactivated.',
        createPageTitle: 'Create [[restriction rule]] | [[access governance]]',
        createRule: 'Create rule',
        createDescription: 'Define a new [[restriction rule]] to enforce access policies',
        ruleNameLabel: 'Rule name',
        ruleNamePlaceholder: 'Enter rule name...',
        descriptionPlaceholder: 'Describe the purpose of this rule...',
        conditionExprPlaceholder: "e.g. [[identity]].type == 'CONTRACTOR'",
        ownerLabel: 'Owner [[party]]',
        searchOwnerParty: 'Search for owner [[party]]...',
        searchProfilesToAdd: 'Search [[access profiles]] to add...',
        selectProfiles: 'Select at least one [[access profile]]',
        pickProfiles: 'Pick profiles',
        writeCondition: 'Write condition',
        profileConditionDesc: 'Write a CEL condition to match denied profiles dynamically (e.g., profile.riskLevel == \'CRITICAL\')',
        profileConditionPlaceholder: "e.g. profile.riskLevel == 'CRITICAL'",
        ruleCreated: '[[Restriction Rule]] created.',
        editPageTitle: 'Edit [[restriction rule]] | [[access governance]]',
        editRule: 'Edit rule',
        editDescription: 'Modify an existing [[restriction rule]]',
        ruleUpdated: '[[Restriction Rule]] updated.',
        detailsTab: 'Details',
        violationsTab: 'Violations',
        testTab: 'Test rule',
        runTest: 'Run test',
        testDescription: 'Test the rule condition against current [[identities]] to preview matches.',
        noViolationsOnRule: 'No violations detected for this rule.',
        violationsDashboardTitle: 'Violations dashboard',
        violationsDashboardSubtitle: 'Cross-rule SoD violations overview',
        totalOpenViolations: 'Open violations',
        filterByRule: 'Filter by rule...',
        searchByIdentity: 'Search by [[identity]]...',
        noViolationsFound: 'No violations found.',
        ruleName: 'Rule',
        removalGraceDays: 'Grace period',
        removalGraceDaysDesc: 'Days before a violating assignment expires after detection',
        days: 'days',
        detectionHistory: 'Detection history',
        detectionHistoryDesc: 'Most recent violation-detection runs for this rule.',
        noDetectionsYet: 'No detection runs yet.',
        detectionLoadFailed: 'Could not load detection history.',
        detectionLoading: 'Loading detection history...',
        detectionStatusSuccess: 'Success',
        detectionStatusFailed: 'Failed',
        detectionViewErrors: 'View errors',
        detectionViolationsFound: 'Found',
        detectionViolationsResolved: 'Resolved',
        detectionIdentitiesEvaluated: 'Evaluated',
        viewAllDetections: 'View all ({{count}})',
        versionHistory: 'Version history',
        versionCurrent: 'Current',
        versionLoading: 'Loading version history...',
        versionLoadFailed: 'Could not load version history.',
        noVersionHistory: 'No version history yet.',
        versionByAuthor: ' by {{name}}',
        testRuleResults: 'Test rule results',
        testViolations: 'Violations',
        testRuleLoading: 'Running test...',
        testRuleError: 'Test failed. Please try again.',
        testRuleEmpty: 'No [[identities]] evaluated.',
        viewAffectedIdentities: 'View Affected [[identities]]',
        affectedIdentitiesTitle: 'Affected [[identities]]',
        affectedIdentitiesDesc: '[[Identities]] matched by this rule condition and their violation status.',
        party: '[[Party]]',
        violationIndicator: 'Violation',
        violationsPageTitle: '{{name}} — Violations',
        violationsPageSubtitle: 'Violations recorded for this [[restriction rule]]',
        noViolationsForRule: 'No violations recorded for this rule yet.',
        resolvedAt: 'Resolved at',
        viewViolations: 'Violations',
        detectionHistoryPageTitle: 'Detection History | [[access governance]]',
        ruleDetectionHistory: 'Detection history',
        noDetections: 'No detection runs found.',
        detectionStartedAt: 'Started at',
        identitiesEvaluated: '[[Identities]] Evaluated',
        detectionsPageSubtitle: 'All violation detection runs across all [[restriction rules]]',
        rule: 'Rule',
        detectionHistoryBtn: 'Detection history',
    },
    restrictionRuleRequests: {
        pageTitle: '[[Restriction rule requests]] | [[access governance]]',
        createPageTitle: 'Create [[restriction rule request]] | [[access governance]]',
        editPageTitle: 'Edit [[restriction rule request]] | [[access governance]]',
        detailPageTitle: '[[Restriction Rule Request]] Details | [[access governance]]',
        title: '[[Restriction rule requests]]',
        subtitle: 'Governance [[requests]] for [[restriction rule]] lifecycle management',
        allRequests: 'All [[restriction rule requests]]',
        requestCount: '{{count}} [[request]](s)',
        newRequest: 'New [[request]]',
        createRequest: 'Create [[request]]',
        createTitle: 'Create [[restriction rule request]]',
        editTitle: 'Edit [[restriction rule request]]',
        searchByName: 'Search by name...',
        noRequestsFound: 'No [[restriction rule requests]] yet.',
        noRequestsMatch: 'No [[requests]] match the current filters.',
        loadingRequests: 'Loading [[restriction rule requests]]...',
        loadingRequest: 'Loading [[restriction rule request]]...',
        loadingRuleData: 'Loading rule data...',
        allStatuses: 'All statuses',
        statusSelectedCount: '{{count}} statuses',
        statusDraft: 'Draft',
        statusPending: 'Pending [[approval]]',
        statusApproved: 'Approved',
        statusRejected: 'Rejected',
        statusCancelled: 'Cancelled',
        typeCreate: 'Create rule',
        typeUpdate: 'Update rule',
        typeActivate: 'Activate rule',
        typeDeactivate: 'Deactivate rule',
        requestType: '[[Request]] [[type]]',
        requestTypeLabel: '[[Request]] [[type]]',
        linkedRule: 'Linked rule',
        ownerParty: 'Owner [[party]]',
        ownerPartyLabel: 'Owner [[party]]',
        searchOwnerParty: 'Search for owner [[party]]...',
        requestConfiguration: '[[Request]] Configuration',
        requestConfigurationCreateDesc: 'Define the [[restriction rule]] change [[request]].',
        requestConfigurationEditDesc: 'Modify the [[request]] configuration before resubmitting.',
        namePlaceholder: 'Enter [[request]] name...',
        descriptionPlaceholder: 'Describe the purpose of this [[request]]...',
        conditionExprLabel: '[[Identity]] Condition',
        conditionExprDesc: 'CEL expression that matches [[identities]] this rule applies to',
        conditionExprPlaceholder: "e.g. [[identity]].type == 'CONTRACTOR'",
        deniedProfilesLabel: 'Denied profiles',
        profileModeList: 'Pick profiles',
        profileModeCondition: 'Write condition',
        profileConditionLabel: 'Denied profile condition',
        profileConditionPlaceholder: "e.g. profile.riskLevel == 'CRITICAL'",
        searchProfilesToAdd: 'Search [[access profiles]] to add...',
        removalGraceDaysLabel: 'Removal grace days',
        days: 'days',
        nameRequired: 'Name is required.',
        ownerRequired: 'Owner [[party]] is required.',
        profileRequired: 'At least one denied profile or condition is required.',
        missingRuleId: 'No target rule specified. Navigate from a [[restriction rule]] to create this [[request]] type.',
        impactBannerActivateTitle: 'Activate rule',
        impactBannerDeactivateTitle: 'Deactivate rule',
        impactBannerActivate: 'This [[request]] will activate the [[restriction rule]] and begin enforcing access restrictions for:',
        impactBannerDeactivate: 'This [[request]] will deactivate the [[restriction rule]] and stop enforcing restrictions for:',
        requestCreated: '[[Restriction Rule Request]] created.',
        requestUpdated: '[[Restriction Rule Request]] updated.',
        requestSubmitted: '[[Request]] submitted for [[approval]].',
        requestApproved: '[[Request]] approved.',
        requestRejected: '[[Request]] rejected.',
        requestDeleted: '[[Request]] deleted.',
        requestCancelled: '[[Request]] withdrawn.',
        requestInfoTitle: '[[Request]] Info',
        requestInfoDesc: '[[Restriction Rule Request]] details',
        submittedAt: 'Submitted at',
        reviewedAt: 'Reviewed at',
        reviewComment: 'Review comment',
        linkedRuleTitle: 'Linked rule',
        linkedRuleDesc: 'The [[restriction rule]] targeted by this [[request]]',
        proposedConfigTitle: 'Proposed configuration',
        proposedConfigDesc: 'The [[restriction rule]] configuration proposed by this [[request]]',
        approvalChainEmpty: 'Not yet submitted — [[approval]] chain will be built on submit.',
        noApproversConfigured: 'No approvers configured yet.',
        standaloneNotLinkedToRule: 'Standalone [[request]] — not linked to a rule.',
        ruleNotFound: 'Rule not found.',
        reviewInfoTitle: 'Review decision',
        reviewedBy: 'Reviewed by',
        workflowTitle: 'Workflow',
        workflowDraftCreated: 'Draft created',
        workflowSubmittedForApproval: 'Submitted for [[approval]]',
        workflowApproved: 'Approved',
        workflowRejected: 'Rejected',
        workflowCancelled: 'Cancelled',
        matchedPolicy: 'Matched policy: {{name}}',
        submitForApproval: 'Submit for [[approval]]',
        cancelRequest: 'Withdraw',
        deleteDialogTitle: 'Delete Draft [[request]]',
        deleteDialogDesc: 'Are you sure you want to delete this draft [[request]]? This action cannot be undone.',
        submitDialogTitle: 'Submit for [[approval]]',
        submitDialogDesc: 'Submit this [[request]] for [[approval]]? Once submitted it cannot be edited.',
        approveDialogTitle: 'Approve [[request]]',
        approveDialogDesc: 'Approving this [[request]] will execute the [[restriction rule]] change.',
        rejectDialogTitle: 'Reject [[request]]',
        rejectDialogDesc: 'Rejecting will close this [[request]]. The requester will be notified.',
        cancelDialogTitle: 'Withdraw [[request]]',
        cancelDialogDesc: 'Are you sure you want to withdraw this [[request]]? The [[request]] will be cancelled and the rule change discarded. A new [[request]] can be created afterwards.',
        withdrawRequest: 'Withdraw [[request]]',
        withdrawing: 'Withdrawing...',
        commentOptional: 'Comment (optional)',
        commentPlaceholder: 'Add an optional comment...',
        rejectionReason: 'Reason for Rejection',
        rejectionReasonPlaceholder: 'Explain why this [[request]] is being rejected...',
        rejectCommentRequired: 'A rejection reason is required.',
        approving: 'Approving...',
        rejecting: 'Rejecting...',
        testPanelTitle: 'Test rule configuration',
        testIdentitySearch: 'Search [[identities]]...',
        runTest: 'Run test',
        testing: 'Testing...',
        testFailed: 'Test failed',
        testEvaluated: 'Evaluated',
        testMatched: 'Matched',
        testViolations: 'Violations',
        cannotEdit: 'This [[request]] cannot be edited because it is in {{status}} status.',
        // Spec Section 6.6 alias keys
        wizardTitle: 'Create [[restriction rule request]]',
        viewRequests: 'View [[requests]]',
        draft: 'Draft',
        pendingApproval: 'Pending [[approval]]',
        approved: 'Approved',
        rejected: 'Rejected',
        cancelled: 'Cancelled',
        newRule: 'Create rule',
        modifyRule: 'Update rule',
        activateRule: 'Activate rule',
        deactivateRule: 'Deactivate rule',
        openRequestExists: 'A change [[request]] is already in progress for this rule.',
        noRuleIdForType: 'No target rule specified. Navigate from a [[restriction rule]] to create this [[request]] type.',
        cancelTitle: 'Withdraw [[request]]',
        cancelDescription: 'Are you sure you want to withdraw this [[request]]? The [[request]] will be cancelled and the rule change discarded. A new [[request]] can be created afterwards.',
        cancelConfirm: 'Withdraw [[request]]',
        tabRestrictionRuleRequests: '[[Restriction rule requests]]',
        noRestrictionRuleRequestApprovals: 'No pending [[restriction rule request approvals]].',
        requestChange: '[[Request]] Change',
        requestActivation: '[[Request]] Activation',
        requestDeactivation: '[[Request]] Deactivation',
        wizard: {
            stepBasics: 'Basics',
            stepCondition: 'Condition',
            stepTest: 'Test',
            stepProfiles: 'Denied profiles',
            stepReview: 'Review',
            stepBasicsDesc: 'Name, owner and grace period for this [[restriction rule request]].',
            stepConditionDesc: 'Define the [[identity]] condition expression for this rule.',
            stepTestDesc: 'Optionally test the condition expression against current [[identities]].',
            stepProfilesDesc: 'Select the [[access profiles]] that are denied by this rule.',
            stepReviewDesc: 'Review all settings before submitting the [[request]].',
            nameLabel: 'Name',
            updateModeNote: 'You are updating an existing [[restriction rule]]. The current rule configuration is pre-filled.',
            hideHelp: 'Hide help',
            showHelp: 'Show help',
            conditionRequired: 'A condition expression is required before proceeding.',
            expressionValidating: 'Validating expression...',
            expressionValid: 'Expression syntax is valid.',
            expressionInvalid: 'Expression has syntax errors.',
            expressionParseError: 'Line {{line}}, col {{column}}: {{message}}',
            expressionNetworkError: 'Could not validate expression — check your connection.',
            testDescription: 'Run the condition expression against current [[identities]] to preview which [[identities]] would be matched.',
            runTest: 'Run test',
            testCompleted: 'Test completed',
            testCompletedDesc: '{{total}} [[identities]] evaluated — {{matched}} matched, {{violations}} with violations.',
            viewAffected: 'View {{count}} matched',
            statEvaluated: '[[Identities]] Evaluated',
            statMatched: 'Matched by Condition',
            statViolations: 'Violations',
            searchIdentities: 'Search [[identities]]...',
            noIdentitiesMatch: 'No [[identities]] match the search.',
            expressionBeingTested: 'Expression being tested',
            noDeniedProfiles: 'No profiles selected yet. Search and select profiles above.',
            testResultSummary: 'Test result',
            notTested: 'The condition has not been tested. You can proceed without testing.',
            skipTest: 'Skip test',
            next: 'Next',
            updateTitle: 'Update Rule: {{name}}',
            editTitle: 'Edit [[restriction rule request]]: {{name}}',
            defaultName: '[[Restriction Rule Request]]',
            abandonTitle: 'Leave Wizard?',
            abandonDesc: 'You have unsaved changes. If you leave now, your progress will be lost.',
            abandonStay: 'Stay',
            abandonLeave: 'Leave',
        },
    },
    delegations: {
        title: 'Delegations',
        pageTitle: 'Delegations',
        allDelegations: 'All delegations',
        delegationsCount: '{{count}} delegations',
        searchPlaceholder: 'Search by delegator or deputy name...',
        myDelegations: 'My delegations',
        myDelegationsDesc: 'Manage your outgoing and incoming delegations',
        outgoing: 'Outgoing delegations',
        incoming: 'Incoming delegations',
        createDelegation: 'Create delegation',
        editDelegation: 'Edit delegation',
        revokeDelegation: 'Revoke delegation',
        revokeConfirmation: 'Are you sure you want to revoke this delegation?',
        createSuccess: 'Delegation created successfully',
        createErrorForDeputy: 'Failed for {{deputy}}: {{error}}',
        updateSuccess: 'Delegation updated successfully',
        revokeSuccess: 'Delegation revoked successfully',
        noDelegations: 'No delegations found.',
        noOutgoing: 'You have not set up any delegations.',
        noIncoming: 'No one has delegated to you.',
        columns: {
            delegator: 'Delegator',
            deputy: 'Deputy',
            workflowStep: 'Workflow step',
            status: 'Status',
            startAt: 'Start',
            endAt: 'End',
            reason: 'Reason',
            createdAt: 'Created',
        },
        permanent: 'Permanent',
        form: {
            deputy: 'Deputy',
            deputyPlaceholder: 'Search for a deputy...',
            noDeputiesSelected: 'No deputies selected yet.',
            workflowStep: 'Workflow step',
            permanent: 'Permanent delegation',
            permanentDescription: 'No start/end date — active until revoked',
            startAt: 'Start date',
            endAt: 'End date',
            reason: 'Reason',
            reasonPlaceholder: 'e.g., Vacation, Parental Leave',
        },
        statuses: {
            SCHEDULED: 'Scheduled',
            ACTIVE: 'Active',
            EXPIRED: 'Expired',
            REVOKED: 'Revoked',
        },
        onBehalfOf: 'on behalf of {{delegator}}',
    },
    functionGroupAssignments: {
        title: '[[Function Groups]]',
        byAssignment: 'By assignment',
        functionGroup: '[[Function Group]]',
        sources: 'Sources',
        expiresAt: 'Expires',
        assignmentHistory: 'Assignment history',
        noAssignments: 'No [[function group assignments]].',
        noHistoryEvents: 'No history events.',
        activeAssignmentCount: '{{count}} active assignment(s)',
        activeSources: '{{count}} active source(s)',
        request: '[[Request]]',
        rule: 'Rule',
        api: 'API',
        import: 'Import',
        unknownSource: 'Unknown source',
        revoke: 'Revoke',
        revoking: 'Revoking...',
        revokeAssignment: 'Revoke assignment',
        revokeAssignmentConfirm: 'Are you sure you want to revoke this [[function group assignment]]? This action can be undone within the restore window.',
        assignmentRevoked: '[[Function Group Assignment]] revoked.',
        restore: 'Restore',
        restoring: 'Restoring...',
        restoreAssignment: 'Restore assignment',
        restoreAssignmentConfirm: 'Are you sure you want to restore this revoked [[function group assignment]]?',
        assignmentRestored: '[[Function Group Assignment]] restored.',
        extend: 'Extend',
        extending: 'Extending...',
        extendAssignment: 'Extend assignment',
        newExpiresAt: 'New expiration date',
        assignmentExtended: '[[Function Group Assignment]] extended.',
        statusActive: 'Active',
        statusPending: 'Pending',
        statusExpired: 'Expired',
        statusRevoked: 'Revoked',
        eventCreated: 'Created',
        eventExtended: 'Extended',
        eventShortened: 'Shortened',
        eventRevoked: 'Revoked',
        eventRestored: 'Restored',
        eventSourceAdded: 'Source added',
        eventSourceRemoved: 'Source removed',
        eventSourceRestored: 'Source restored',
        identity: '[[Identity]]',
        startAt: 'Start',
    },
    functionGroupDetail: {
        pageTitle: '[[Function Group]] Details',
        loading: 'Loading [[function group]]...',
        detailsDescription: '[[Function Group]] configuration and metadata',
        externalId: 'External ID',
        parent: 'Parent [[function group]]',
        owner: 'Owner',
        autoAssignable: 'Auto-Assignable',
        requestableLabel: 'Requestable',
        requestable: 'Requestable',
        notRequestable: 'Not requestable',
        expiryRequired: 'Expiry required',
        maxDurationDays: 'Max Duration (Days)',
        accessProfiles: {
            card: {
                title: '[[Access Profiles]]',
                description: '{{count}} [[access profile]]',
                description_other: '{{count}} [[access profiles]]',
            },
            empty: 'No [[access profiles]] associated with this [[function group]].',
            error: 'Failed to load associated [[access profiles]]',
            warning100: 'Showing first 100 associated [[access profiles]]',
            columns: {
                name: 'Name',
                code: 'Code',
                resource: '[[Resource]]',
                environment: 'Environment',
                riskLevel: 'Risk level',
                status: 'Status',
            },
        },
    },
    accessProfileDetail: {
        functionGroups: {
            card: {
                title: '[[Function Groups]]',
                description: '{{count}} [[function group]](s) will grant this [[access profile]] to [[identities]]',
                description_other: '{{count}} [[function group]](s) will grant this [[access profile]] to [[identities]]',
            },
            empty: 'No [[function group]] will grant this [[access profile]] to [[identities]]',
            error: 'Failed to load [[function group]] associations',
            columns: {
                name: 'Name',
                type: '[[Type]]',
            },
        },
    },
    identityInheritedAssignments: {
        sourceLabel: '[[Function Group]]',
        tooltip: 'Inherited from [[function group]] — manage via the [[function group assignment]]',
        errorBanner: 'Could not load inherited assignments',
        viaPrefix: 'via',
    },
    requestWizardLinkedAccessProfiles: {
        grantsCount: 'Grants {{count}} [[access profile]]',
        grantsCount_other: 'Grants {{count}} [[access profiles]]',
        noAccessProfiles: 'No [[access profiles]] associated',
        moreText: '+ {{count}} more',
        errorText: 'Could not load associated [[access profiles]]',
        notAvailable: 'Associated [[access profiles]] not available',
        retry: 'Retry',
    },
    requestDetailLinkedAccessProfiles: {
        sectionTitle: '[[Access Profiles]] ({{count}})',
        errorText: 'Could not load associated [[access profiles]]',
        retry: 'Retry',
    },
    functionGroups: {
        title: '[[Function Groups]]',
        subtitle: '[[Function Groups]] that bundle [[access profiles]] for assignment',
        createFunctionGroup: 'Create [[function group]]',
        createSuccess: '[[Function Group]] created.',
        owner: 'Owner',
        noFunctionGroupsFound: 'No [[function groups]] found.',
        noFunctionGroupsMatch: 'No [[function groups]] match your filter.',
    },
    functionGroupRequests: {
        title: '[[Function group requests]]',
        pageTitle: '[[Function group requests]]',
        subtitle: 'Manage [[function group assignment]] [[requests]]',
        createRequest: 'New [[request]]',
        loadingRequests: 'Loading [[requests]]...',
        noRequestsFound: 'No [[function group requests]] found.',
        requester: 'Requester',
        beneficiary: 'Beneficiary',
        justification: 'Justification',
        items: 'Items',
        searchByBeneficiary: 'Search by beneficiary...',
        statusSubmitted: 'Submitted',
        statusInProgress: 'In progress',
        statusCompleted: 'Completed',
        statusCancelled: 'Cancelled',
        detailPageTitle: '[[Function Group Request]] Details',
        requestDetails: '[[Request]] Details',
        requestItems: '{{count}} Item(s)',
        untilDate: '(until {{date}})',
        cancelRequest: 'Cancel [[request]]',
        cancelEntireRequest: 'Cancel Entire [[request]]',
        cancelItem: 'Cancel item',
        cancelReason: 'Reason for cancellation',
        cancelReasonPlaceholder: 'Enter a reason...',
        cancelled: 'Cancelled:',
        cancelling: 'Cancelling...',
        requestCancelled: '[[Request]] cancelled.',
        itemCancelled: 'Item cancelled.',
        approveItem: 'Approve item',
        approving: 'Approving...',
        itemApproved: 'Item approved.',
        rejectItem: 'Reject item',
        rejecting: 'Rejecting...',
        itemRejected: 'Item rejected.',
        commentOptional: 'Comment (optional)',
        commentPlaceholder: 'Add an optional comment...',
        reasonRequired: 'Reason (required)',
        rejectReasonPlaceholder: 'Enter a reason for rejection...',
        statusPendingApproval: 'Pending [[approval]]',
        statusApproved: 'Approved',
        statusFulfilled: 'Fulfilled',
        statusRejected: 'Rejected',
        approvers: 'Approvers',
        wizardTitle: 'New [[function group request]]',
        newPageTitle: 'New [[function group request]]',
        wizardSelectFunctionGroups: 'Select [[function groups]]',
        wizardSelectedFunctionGroups: '[[Function Groups]] selected',
        wizardReviewSubmit: 'Review & Submit',
        whoNeedsAccess: 'Who needs [[function group]] access?',
        myself: 'Myself',
        someoneElse: 'Someone else',
        searchForIdentity: 'Search for an [[identity]]',
        searchByName: 'Search by name...',
        selected: 'Selected:',
        allFunctionGroups: 'All [[function groups]]',
        selectFunctionGroups: 'Select [[function groups]]',
        searchFunctionGroups: 'Search [[function groups]]...',
        noFunctionGroupsFound: 'No [[function groups]] found.',
        noFunctionGroupsSelected: 'No [[function groups]] selected yet.',
        selectedCount: '{{count}} selected',
        expiryRequired: 'Expiry required',
        expirationDate: 'Expiration date',
        setExpiration: 'Set expiration',
        maxDurationHint: 'Max {{days}} days',
        reviewAndSubmit: 'Review & Submit',
        reviewBeneficiary: 'Beneficiary',
        reviewFunctionGroups: '[[Function Groups]] ({{count}})',
        expandAll: 'Expand all',
        collapseAll: 'Collapse all',
        justificationPlaceholder: 'Why is this [[function group]] access needed?',
        submitRequest: 'Submit [[request]]',
        submitting: 'Submitting...',
        requestSubmitted: '[[Function Group Request]] submitted.',
        myFunctionGroupRequests: 'My [[function group requests]]',
        myFunctionGroupRequestsSubmitted: '[[Function group requests]] you have submitted',
        newRequest: 'New [[request]]',
        noFunctionGroupRequestsFound: 'No [[function group requests]] found.',
        tabFunctionGroupRequests: '[[Function group requests]]',
        noFunctionGroupRequestApprovals: 'No pending [[function group request approvals]]',
        functionGroupRequestApproved: '[[Function Group Request]] item approved.',
        functionGroupRequestRejected: '[[Function Group Request]] item rejected.',
        approveFunctionGroupRequest: 'Approve [[function group request]] Item',
        rejectFunctionGroupRequest: 'Reject [[function group request]] Item',
    },
    errorLogs: {
        pageTitle: '[[Error Log]]',
        title: '[[Error Log]]',
        description: 'Errors across all modules',
        sidebarTitle: '[[Error Log]]',
        sidebarDescription: 'Errors across all modules',
        tabPatterns: 'Group by Error [[type]]',
        tabAllRecords: 'All errors',
        totalFailures: 'Total',
        patterns: 'Grouped',
        occurrences: 'Occurrences',
        allModules: 'All modules',
        allSourceTypes: 'All Source [[types]]',
        allContextKeys: 'All context keys',
        contextValuePlaceholder: 'Filter by value...',
        filterModule: 'Module',
        filterSourceType: 'Source [[type]]',
        filterDateRange: 'Date range',
        filterSearch: 'Search failures...',
        last24h: 'Last 24h',
        last7d: 'Last 7 days',
        last30d: 'Last 30 days',
        columns: {
            count: 'Count',
            module: 'Module',
            exception: 'Exception',
            message: 'Message',
            lastSeen: 'Last seen',
            time: 'Time',
            sourceType: 'Source [[type]]',
            source: 'Source',
            type: '[[Type]]',
            errorCode: 'Error code',
            context: 'Context',
            sourceEntity: 'Source entity',
            sessionId: 'Session',
        },
        badgePattern: 'Grouped',
        badgeOccurrence: 'Single',
        noFailures: 'No errors recorded.',
        noFailuresMatch: 'No errors match the current filters.',
        noPatterns: 'No grouped errors found.',
        noPatternsHint: 'Switch to All Errors to see individual entries.',
        noOccurrences: 'No individual errors recorded.',
        failedToLoad: 'Failed to load [[error log]].',
        patternDetail: {
            title: 'Error detail',
            breadcrumb: 'Error detail',
            patternInfo: 'Error info',
            exceptionType: 'Exception',
            errorCode: 'Error code',
            module: 'Module',
            firstSeen: 'First seen',
            lastSeen: 'Last seen',
            totalOccurrences: 'Total occurrences',
            stackTrace: 'Stack trace',
            showStackTrace: 'Show stack trace',
            hideStackTrace: 'Hide stack trace',
            moreFrames: '... ({{count}} more frames)',
            copyTrace: 'Copy',
            copiedTrace: 'Stack trace copied to clipboard.',
            occurrencesTitle: 'Occurrences',
            occurrencesCount: '{{count}} total',
            notFound: 'This error no longer exists. It may have been removed by retention.',
        },
        occurrenceDetail: {
            title: 'Error detail',
            time: 'Time',
            source: 'Source',
            message: 'Message',
            viewSource: 'View',
            context: 'Context',
            noContext: 'No context',
            stackTrace: 'Stack trace',
            stackTraceReconstructed: 'Stack trace',
            identicalToTemplate: 'Identical to grouped error.',
            noStackTrace: 'This failure was recorded without a stack trace.',
            diffNote: 'Highlighted characters differ from the pattern template.',
        },
        requestContext: {
            title: '[[Request]] Context',
            source: 'Source',
            appRequest: 'App [[request]]',
            externalRequest: 'External [[request]]',
            method: 'Method & URL',
            userAgent: 'User-Agent',
            correlationId: 'Correlation ID',
            authUser: 'Authenticated user',
            headers: 'Headers',
            headersExpand: 'Show headers',
            headersCollapse: 'Hide headers',
            copiedCorrelationId: 'Correlation ID copied to clipboard.',
        },
        detail: {
            sessionId: 'Session ID',
            actionId: 'Action ID',
            e2eRunId: 'E2E Run ID',
            e2eTestClass: 'E2E Test Class',
            e2eTestMethod: 'E2E Test Method',
            sessionLink: 'View in [[request inspector]]',
        },
        refresh: 'Refresh',
        failedToLoadStats: 'Failed to load failure statistics.',
        retry: 'Retry',
        patternCount: '{{count}} patterns',
        emptyState: 'No errors have been recorded yet.',
        emptyStateHint: 'The [[error log]] captures exceptions from background [[jobs]], connectors, and other system processes.',
        generateTestData: 'Generate test data',
        generatingTestData: 'Generating...',
        testDataGenerated: 'Generated {{count}} test failure records',
        others: '{{count}} others',
        clearAll: 'Clear all',
        clearAllConfirm: 'Clear all errors',
        clearAllDescription: 'Are you sure? This will permanently delete all error records.',
        clearAllSuccess: 'All error records have been cleared.',
        minQHint: '[[Type]] at least 3 characters to search.',
        searchScopeHint: 'Searches the error message only — stack traces are not searched.',
    },
    inlineAttributeEditor: {
        required: 'Required',
        optional: 'Optional',
        save: 'Save',
        reset: 'Reset',
        remove: 'Remove',
        noDefinitions: 'No attributes available for this entity.',
        noDefinitionsAdmin: 'No [[attribute definitions]] configured for this type.',
        saving: 'Saving...',
        saveSuccess: 'Attribute saved',
        removeSuccess: 'Attribute removed',
        removeConfirm: 'Remove attribute?',
        requiredHint: 'This attribute is required',
        enterToAdd: '[[Type]] and press Enter to add',
        searchParty: 'Search by name...',
        source: 'Managed by {{name}}',
    },
    scriptExecuteLog: {
        pageTitle: 'Script Execute Log | Admin',
        title: 'Script execute log',
        description: 'DDL audit trail from sql.execute() calls',
        emptyMessage: 'No rows recorded.',
        emptyMatchMessage: 'No rows match the active filters.',
        rowsBadge: '{{count}} row',
        rowsBadge_other: '{{count}} rows',
        filters: {
            actor: 'Actor',
            actorPlaceholder: 'Username...',
            mode: 'Mode',
            modeAll: 'All modes',
            modePreview: 'Preview',
            modeRuntime: 'Runtime',
            outcome: 'Outcome',
            outcomeAll: 'All outcomes',
            outcomeSuccess: 'Success',
            outcomeFailure: 'Failure',
            occurredFrom: 'From',
            occurredTo: 'To',
            clear: 'Clear filters',
        },
        columns: {
            occurredAt: 'Time',
            mode: 'Mode',
            actor: 'Actor',
            sqlText: 'SQL',
            durationMs: 'Duration (ms)',
            success: 'Outcome',
            errorCode: 'Error',
        },
        badges: {
            preview: 'Preview',
            runtime: 'Runtime',
            success: 'Success',
            failure: 'Failure',
        },
        detail: {
            title: '[[Audit Log]] Entry',
            close: 'Close',
            occurredAt: 'Occurred at',
            mode: 'Mode',
            actor: 'Actor',
            actorUserId: 'Actor user ID',
            jobExecutionId: '[[Job]] [[execution]] ID',
            duration: 'Duration (ms)',
            outcome: 'Outcome',
            errorCode: 'Error code',
            errorMessage: 'Error message',
            sqlText: 'SQL',
        },
    },
    caches: {
        pageTitle: 'Caches | Admin',
        title: 'Caches',
        subtitle: 'In-process caches across all backend modules — observe state and trigger a manual reload.',
        emptyState: 'No caches registered.',
        loadError: 'Failed to load caches.',
        evictSuccess: 'Cache evicted.',
        evictError: 'Failed to evict cache.',
        reloadSuccess: 'Cache reloaded.',
        reloadError: 'Failed to reload cache.',
        neverLoaded: 'Never',
        expired: 'expired (next read reloads)',
        columns: {
            name: 'Name',
            description: 'What gets cached',
            entries: 'Entries',
            lastLoad: 'Last load',
            ttl: 'TTL',
            nextExpiry: 'Next expiry',
            reloadTrigger: 'Reloads on',
            actions: 'Actions',
        },
        actions: {
            evict: 'Evict',
            reload: 'Reload now',
        },
    },
    llmPrompts: {
        pageTitle: 'LLM Prompts | Admin',
        title: 'LLM Prompt Templates',
        subtitle: 'Configure AI prompt templates used by LLM-assisted features',
        searchPlaceholder: 'Search by key, name, or description...',
        noMatchingPrompts: 'No prompt templates match your search.',
        emptyState: 'No prompt templates configured. Templates are created during system setup.',
        columns: {
            key: 'Key',
            displayName: 'Display name',
            description: 'Description',
            lastUpdated: 'Last updated',
            updatedBy: 'Updated by',
        },
        detail: {
            title: 'Edit prompt template',
            metadata: 'Metadata',
            promptEditor: 'Prompt editor',
            variables: 'Available variables',
            variableDescription: 'Use double-brace variable syntax in your prompt to reference these variables.',
            noVariables: 'This template has no variables.',
        },
        actions: {
            save: 'Save',
            cancel: 'Cancel',
            restoreDefault: 'Restore default',
            testPrompt: 'Test prompt',
            renderPreview: 'Render preview',
            sendToLlm: 'Send to LLM',
        },
        messages: {
            saveSuccess: 'Prompt template saved successfully',
            restoreSuccess: 'Prompt template restored to default',
            restoreConfirm: 'Restore Default Prompt?',
            restoreConfirmDescription: 'This will replace the current prompt with the original default. Any custom changes will be lost.',
            unsavedChanges: 'You have unsaved changes. Are you sure you want to leave?',
            versionConflict: 'Template was modified by another user. Reloading...',
            llmNotConfigured: 'LLM is not configured. Cannot send test [[requests]].',
        },
        testPanel: {
            title: 'Test prompt',
            sampleInput: 'Sample user input',
            sampleInputPlaceholder: 'Enter a sample user [[request]] to test the prompt...',
            renderedPrompt: 'Rendered prompt',
            llmResponse: 'LLM Response',
        },
    },
    notificationTemplates: {
        pageTitle: 'Notification Templates | Admin',
        title: '[[Notification Templates]]',
        searchPlaceholder: 'Search by key or subject...',
        noMatching: 'No [[notification]] templates match your search.',
        emptyState: 'No [[notification]] templates available.',
        columns: {
            key: 'Key',
            subject: 'Subject',
            state: 'State',
            active: 'Active',
            lastModified: 'Last modified',
        },
        badges: {
            customised: 'Customised',
            default: 'Default',
            active: 'Active',
            inactive: 'Inactive',
        },
        fields: {
            subject: 'Subject',
            bodyHtml: 'Body (HTML)',
            title: 'Title',
            message: 'Message',
        },
        detail: {
            title: '[[Edit Notification Template]]',
            metadata: 'Metadata',
            editor: 'Template editor',
            variables: 'Available variables',
            variableHint: 'Click a variable to insert it at the cursor position in the body.',
            noVariables: 'This template has no variables.',
        },
        actions: {
            restoreDefault: 'Restore default',
            testSend: 'Send test',
        },
        messages: {
            saveSuccess: 'Notification template saved successfully',
            restoreSuccess: 'Notification template restored to default',
            restoreConfirm: 'Restore Default Template?',
            restoreConfirmDescription: 'This deletes the override and reverts the template to the shipped default. Any customisations will be lost.',
            versionConflict: 'Template was modified by another user. Reloading...',
            testSendSent: 'Test mail sent to {{email}} — a sample in-app [[notification]] was added to your inbox.',
            testSendSkipped: 'No email address configured for your account — test mail skipped, but a sample in-app [[notification]] was added to your inbox.',
            testSendDirtyHint: 'Save your changes first — the test send uses the saved template, not your unsaved edits.',
        },
    },
    onboarding: {
        title: 'Onboarding',
        pageTitle: 'Onboarding | [[identity management]]',
        menuDescription: 'Onboard a person with [[party]], [[identity]], and identifiers',
        subtitle: 'Create a [[party]] and [[identity]] with all required information in one guided flow.',
        steps: {
            person: 'Person',
            organization: 'Organization',
            identity: '[[Identity]]',
            review: 'Review',
        },
        stepStatus: {
            active: 'active',
            complete: 'complete',
            upcoming: 'upcoming',
        },
        stepAriaLabel: 'Step {{number}}: {{name}} — {{status}}',
        mode: {
            newPerson: 'New [[party]]',
            existingPerson: 'Add [[identity]] to existing [[party]]',
        },
        templates: {
            title: 'Select a template',
            employee: 'Employee',
            employeeDesc: 'Standard workforce [[identity]]',
            contractor: 'Contractor',
            contractorDesc: 'External partner [[identity]]',
            service: 'Service [[identity]]',
            serviceDesc: 'Non-human [[service account]]',
            custom: 'Custom',
            customDesc: 'Choose [[identity]] type manually',
        },
        person: {
            title: 'Person details',
            basicInfo: 'Basic information',
            displayName: 'Display name',
            displayNamePlaceholder: 'Enter full name',
            externalId: 'External ID',
            externalIdPlaceholder: 'Optional external identifier',
            duplicateWarning: 'A [[Party]] with this name already exists. Use \'Add [[identity]] to existing [[party]]\' to select them.',
            templateSwitchInfo: '[[Identity]] attributes have been reset because the template was changed. [[party]]-level fields (name, department, manager) have been preserved.',
        },
        existingParty: {
            searchPlaceholder: 'Search for an existing [[party]]...',
            partyType: '[[Party]] [[type]]',
            loading: 'Loading [[party]] details...',
        },
        organization: {
            title: 'Organization',
            relationships: 'Relationships',
            relationshipSearchPlaceholder: 'Search for {{label}}...',
            additionalDetails: 'Additional details',
            managerSection: 'Manager',
            managerLabel: 'Manager',
            managerSearchPlaceholder: 'Search by manager name (at least 2 characters)...',
            managerEmptyResults: 'No [[identities]] found',
            managerInactiveAdvisory: 'This [[identity]] is not active — confirm you want to assign an inactive manager.',
            managerSecondaryLabel: '{{primary}} · {{secondary}} (advisory)',
        },
        identity: {
            title: '[[Identity]]',
            identityType: '[[Identity]] [[type]]',
            identityTypePlaceholder: 'Select [[identity]] type',
            entryDate: 'Entry date',
            entryDateHelper: 'Today = Active immediately, future date = Suspended until entry date',
            entryDatePastError: 'Entry date must be today or in the future',
            exitDate: 'Exit date',
            exitDateHelper: 'Optional end date for this [[identity]]',
            identifiers: 'Identifiers',
            addIdentifier: 'Add identifier',
            emailLabel: 'Email',
            emailPlaceholder: 'john.doe@example.com',
            identifierType: '[[Type]]',
            identifierValue: 'Value',
            identifierValuePlaceholder: 'Enter value',
            placeholderEMAIL: 'john.doe@example.com',
            placeholderUPN: 'john.doe@corp.local',
            placeholderEMPLOYEE_NO: 'EMP-12345',
            placeholderCUSTOM: 'Custom identifier value',
            primary: 'Primary',
            duplicateError: 'This {{type}} is already in use.',
            existingIdentities: 'Existing [[identities]]',
            existingIdentifiers: 'Existing identifiers',
            additionalDetails: 'Additional details',
        },
        review: {
            title: 'Review & Submit',
            personSection: 'Person',
            organizationSection: 'Organization',
            identitySection: '[[Identity]]',
            attributesSection: 'Attributes',
            newLabel: '(new)',
            editLink: 'Edit',
            identityTypeLabel: '[[Identity]] [[type]]',
            entryDateLabel: 'Entry date',
            exitDateLabel: 'Exit date',
        },
        actions: {
            next: 'Next',
            previous: 'Previous',
            submit: 'Submit',
            submitting: 'Submitting...',
            cancel: 'Cancel',
            newUser: 'Onboard',
        },
        messages: {
            success: 'Onboarding completed successfully',
            successAwaitingEntry: '[[Identity]] will activate on {{entryDate}}',
            submitError: 'Onboarding failed. Please review the errors and try again.',
        },
        cancel: {
            title: 'Discard changes?',
            description: 'You have unsaved changes. Are you sure you want to leave?',
            discard: 'Discard',
            keepEditing: 'Keep editing',
        },
        validation: {
            required: 'This field is required.',
            minLength: 'Must be at least {{min}} characters.',
            maxLength: 'Must be at most {{max}} characters.',
            pattern: 'Value does not match the required pattern.',
            minValue: 'Must be at least {{min}}.',
            maxValue: 'Must be at most {{max}}.',
            invalidEmail: 'Please enter a valid email address.',
            unsafeChars: 'Only letters, digits, @, dots, underscores and hyphens are allowed.',
            exitBeforeEntry: 'Exit date must be after the entry date.',
            displayNameMaxLength: 'Display name must be at most 255 characters.',
            externalIdMaxLength: 'External ID must be at most 255 characters.',
            identifierMaxLength: 'Identifier value must be at most 500 characters.',
        },
    },
    formLayouts: {
        pageTitle: '[[Form Layouts]] | Admin',
        designerPageTitle: '[[Form Layout]] Designer | Admin',
        title: '[[Form Layouts]]',
        subtitle: 'Configure form input field layouts per use-case',
        noPermission: 'You do not have permission to manage [[form layouts]].',
        emptyCallout: 'No custom layouts configured. All forms are using the default attribute sort order. Click Edit on any use-case to start designing.',
        statusActive: 'Active',
        statusInactive: 'Inactive',
        statusDefault: 'Default',
        deleteDialogTitle: 'Delete layout for {{displayName}}?',
        deleteDialogBody: 'This will permanently remove the custom layout. The onboarding form will immediately fall back to the default attribute sort order.',
        deleteSuccess: 'Layout deleted successfully.',
        fieldCount: '{{count}} (out of {{total}})',
        fieldCountSuffix: '(out of {{total}})',
        columns: {
            useCase: 'Use-case',
            key: 'Key',
            formFields: 'Used form fields',
            status: 'Status',
        },
        wizardStepPerson: 'Onboarding → Step 1: Person',
        wizardStepOrgRelationships: 'Onboarding → Step 2: Organization (Relationships)',
        wizardStepOrgAttributes: 'Onboarding → Step 2: Organization (Additional Details)',
        wizardStepIdentity: 'Onboarding → Step 3: [[identity]]',
        wizardStepIdentityAttributes: 'Onboarding → Step 3: [[identity]] (Additional Details)',
        usedOnPage: 'Used on:',
        openPage: 'Open page',
        layoutActiveIndicator: 'Custom layout',
        layoutActiveIndicatorTooltip: 'A custom [[form layout]] is active for this section. Click to open the designer.',
        keyBadgeTooltip: 'This key identifies which onboarding step this layout applies to. It is assigned by the system and cannot be changed.',
        activeTooltip: 'When inactive, the onboarding form ignores this layout and uses the default field order.',
        preview: 'Preview',
        history: 'History',
        resetDialogTitle: 'Reset all changes?',
        resetDialogBody: 'Your unsaved changes will be lost and the layout will revert to the last saved version.',
        saveSuccess: 'Layout saved successfully.',
        validationEmptySections: 'Add at least one section before saving.',
        validationEmptySectionLabel: 'All sections must have a label before saving.',
        canvasEmpty: 'No sections yet',
        canvasEmptySubtext: "Click 'Add section' below, or drag a field from the palette onto the canvas to create your first section automatically.",
        addSection: 'Add section',
        sectionEmptyState: 'Drop fields here from the palette.',
        unnamedSection: 'Unnamed section',
        deleteSectionTitle: "Delete section '{{label}}'?",
        deleteSectionBody: 'All fields in this section will be removed from the layout.',
        deleteSectionConfirm: 'Delete section',
        columns1: '1 column',
        columns2: '2 columns',
        columns3: '3 columns',
        paletteEntityFields: 'Entity fields',
        paletteIamDefs: 'IAM-managed attributes',
        paletteReadOnly: 'Read-only (HR-managed)',
        paletteRelationships: 'Relationships',
        paletteError: 'Could not load available fields',
        orphanedFieldTooltip: "This field's [[attribute definition]] is no longer active. It will be skipped when the form renders. Remove it or restore the [[attribute definition]].",
        colSpanOverflow: 'Overflow',
        colSpanOverflowTooltip: 'Column span exceeds row width',
        duplicateFieldToast: "'{{label}}' is already in the layout. A field can only appear once.",
        fieldRemovedToast: 'Field removed. Drag it from the palette to add it back.',
        fieldProperties: 'Field properties',
        sectionProperties: 'Section properties',
        sectionLabel: 'Label',
        sectionLabelPlaceholder: 'Section label...',
        sectionLabelRequired: 'Section label is required.',
        sectionColumns: 'Columns',
        sectionCollapsible: 'Collapsible section',
        fieldLabel: 'Label override',
        fieldLabelPlaceholder: 'Leave blank to use default',
        fieldPlaceholder: 'Placeholder',
        fieldDefaultValue: 'Default value',
        fieldTemplateExpression: 'Template expression',
        templatePreview: 'Preview: {{value}}',
        templateUnknownToken: "Unknown token '{{token}}' — will render as empty.",
        fieldColSpan: 'Column span',
        colSpanFull: 'Full',
        colSpanHalf: 'Half',
        colSpanThird: 'Third',
        colSpanQuarter: 'Quarter',
        colSpanCustom: 'Custom',
        fieldRequiredOverride: 'Required override',
        requiredInherit: 'Inherit',
        requiredRequired: 'Required',
        requiredOptional: 'Optional',
        requiredOptionalDisabledTooltip: 'This field is required by its [[attribute definition]] and cannot be made optional in the layout.',
        conditionalVisibility: 'Conditional visibility',
        visibilityShowWhen: 'Show field only when',
        visibilityFieldKeyPlaceholder: 'Select field...',
        visibilityValuePlaceholder: 'Equals value...',
        visibilityHint: 'This field will be hidden unless the selected condition is met.',
        fieldDisabled: 'Field is read-only (display only)',
        fieldHidden: 'Hide from rendered form',
        previewBanner: 'Preview mode — this is how the form will appear to users. Changes are not saved.',
        exitPreview: 'Exit preview',
        templateEmployee: 'Employee',
        templateContractor: 'Contractor',
        templateService: 'Service',
        templateCustom: 'Custom',
        previewEmpty: 'No sections to preview.',
        historyTitle: 'Layout history',
        historyEmpty: 'No history available.',
        historyRestore: 'Restore this version',
        historyLoadMore: 'Load more',
        historyRestoreToast: 'Historical version loaded as draft. Review changes and click Save to apply.',
        cancelDialogTitle: 'Leave the layout designer?',
        cancelDialogBody: 'Are you sure you want to go back to the layout list?',
        cancelDialogBodyDirty: 'You have unsaved changes. If you leave now, your changes will be lost.',
        unsavedChangesTitle: 'Leave without saving?',
        unsavedChangesBody: 'You have unsaved changes to this layout. If you leave now, your changes will be lost.',
        unsavedChangesStay: 'Stay and continue editing',
        unsavedChangesLeave: 'Leave without saving',
        conflictTitle: 'Layout was modified by another user',
        conflictBody: 'Your changes could not be saved because the layout was updated by {{updatedBy}} at {{updatedAt}}. You can discard your changes and reload the latest version, or copy your changes manually.',
        conflictKeepEditing: 'Keep editing',
        conflictDiscard: 'Discard my changes and reload',
    },
    inboundConnectors: {
        pageTitle: '[[Inbound Connectors]] | Admin',
        title: '[[Inbound Connectors]]',
        subtitle: 'Manage inbound data import connectors for [[identity]] data',
        allConnectors: 'All [[inbound connectors]]',
        connectorCount: '{{count}} connector(s)',
        createConnector: 'Create [[inbound connector]]',
        createDescription: 'Create a new [[inbound connector]] to import [[identity]] data from an external source.',
        displayName: 'Display name',
        displayNamePlaceholder: 'e.g. SAP SuccessFactors HR Import',
        targetSystem: '[[Target System]]',
        selectSystem: 'Select a [[target system]]...',
        connectorType: 'Connector [[type]]',
        selectType: 'Select connector type',
        schedule: 'Schedule',
        schedulePlaceholder: 'Cron expression (e.g. 0 0 */4 * * *)',
        schedulePreview: 'Schedule: {{preview}}',
        syncTypeFull: 'Full sync',
        enabledLabel: 'Enabled',
        enabledDescription: 'Enable this connector for scheduled sync',
        columns: {
            name: 'Name',
            targetSystem: '[[Target System]]',
            type: '[[Type]]',
            status: 'Status',
            lastSync: 'Last sync',
            records: 'Records',
        },
        filterPlaceholder: 'Filter connectors...',
        noConnectorsFound: 'No [[inbound connectors]] configured. Create one to start importing [[identity]] data from an HR system.',
        noConnectorsMatch: 'No connectors match your filter.',
        loadingConnectors: 'Loading connectors...',
        createSuccess: '[[Inbound Connector]] created successfully.',
        allSystemsHaveConnectors: 'All systems already have [[inbound connectors]] configured.',
        invalidCronExpression: 'Invalid cron expression',
        displayNameRequired: 'Display name is required',
        targetSystemRequired: '[[Target System]] is required',
        connectorTypeRequired: 'Connector type is required',
        typeRest: 'REST API',
        typeScim: 'SCIM 2.0',
        typeScript: 'Script',
        typeSapHcm: 'SAP HCM',
        typeSapSfEc: 'SAP SuccessFactors EC',
        sapHcm: {
            connectionSection: 'SAP HCM connection',
            connectionDescription: 'OData V2 connection to SAP HCM. Wire field names (employee key, validity-band start/end) are configured per connector so non-canonical envelopes (e.g. a German HR wrapper using mitarbeiterNummer / gültigVon / gültigBis instead of PERNR / BEGDA / ENDDA) need no code change.',
            employeeKeyField: 'Employee key field',
            validityStartField: 'Validity start field',
            validityEndField: 'Validity end field',
            validityResolutionStrategy: 'Validity resolution',
            terminationAttribute: 'Termination attribute',
            terminationValuesCsv: 'Termination values',
            enabledInfotypes: 'Enabled infotypes',
            noInfotypes: 'No infotypes enabled — sync will return zero records.',
            editDialogTitle: 'Edit SAP HCM configuration',
            editDialogDescription: 'Update connection, wire field names, authentication, pagination, delta and termination settings for this SAP HCM connector. Infotype and attribute mapping editors are managed separately on the Reconciliation tab.',
            sectionWireFields: 'Wire fields & validity resolution',
            sectionTermination: 'Termination detection',
            saveSuccess: 'SAP HCM configuration saved.',
        },
        sapSfEc: {
            connectionSection: 'SAP SuccessFactors EC connection',
            connectionDescription: 'OData V2 connection to SAP SuccessFactors Employee Central. Authentication via OAuth2 client credentials or OAuth2 SAML 2.0 bearer assertion.',
            entitySet: 'Entity set',
            datetimeFormat: 'Datetime format',
            selectFields: '$select fields',
            expandFields: '$expand fields',
            samlIssuer: 'SAML issuer',
            samlAudience: 'SAML audience',
            samlSubject: 'SAML subject',
            noMappings: 'No attribute mappings configured.',
            editDialogTitle: 'Edit SAP SuccessFactors EC configuration',
            editDialogDescription: 'Update connection, authentication and pagination settings for this SAP SuccessFactors EC connector. Attribute mapping and response filter editors are managed separately on the Reconciliation tab.',
            samlSigningKeyRef: 'SAML signing key reference',
            samlSigningCertificateRef: 'SAML signing certificate reference',
            samlAssertionTemplate: 'SAML assertion template',
            samlBearerNote: 'OAuth2 SAML Bearer is required for IAS-fronted tenants. The IAM tenant signs the SAML assertion with the configured private key and exchanges it for an access token at the token endpoint (RFC 7522).',
            saveSuccess: 'SAP SuccessFactors EC configuration saved.',
        },
        syncStatusRunning: 'Running',
        syncStatusCompleted: 'Completed',
        syncStatusCompletedWithErrors: 'Completed with errors',
        syncStatusFailed: 'Failed',
        syncStatusCancelled: 'Cancelled',
        syncStatusPaused: 'Paused',
        never: 'Never',
        // Detail page
        detailPageTitle: '[[Inbound Connector]] Detail | Admin',
        enabled: 'Enabled',
        disabled: 'Disabled',
        description: 'Description',
        noDescription: 'No description provided.',
        createdAt: 'Created',
        updatedAt: 'Last modified',
        // Overview tab
        tabOverview: 'Overview',
        tabConfiguration: 'Configuration',
        tabSyncRuns: 'Sync runs',
        connectorInfo: 'Connector information',
        scheduleSection: 'Schedule',
        cronExpression: 'Cron expression',
        cronPreview: 'Runs: {{preview}}',
        nextRun: 'Next scheduled run',
        lastSyncSection: 'Last sync',
        lastFullSync: 'Last full sync',
        neverSynced: 'Never synced',
        quickStats: 'Quick stats',
        lastRunStatus: 'Last run status',
        totalRecordsImported: 'Records imported',
        manualSync: 'Manual sync',
        runFullSync: 'Run full sync',
        runDeltaSync: 'Run delta sync',
        runPreview: 'Run preview',
        syncFullConfirmation: 'This will start a full sync and import all records from the source system. Continue?',
        syncDeltaConfirmation: 'This will start a delta sync and import only changed records since the last sync. Continue?',
        syncPreviewConfirmation: 'This will run a preview sync without applying any changes. Continue?',
        syncStarted: 'Sync started successfully.',
        syncAlreadyRunning: 'A sync is already in progress',
        enableFirst: 'Enable the connector first',
        confirmSync: 'Confirm sync',
        // Preview result dialog
        previewResultTitle: 'Preview result',
        previewRunning: 'Fetching from source…',
        previewWaitingForRecords: 'Fetching from source…',
        previewNoRecords: 'Empty response.',
        previewFailed: 'Preview failed.',
        previewStatusLine: 'HTTP {{status}} • {{contentType}}',
        downloadResponse: 'Download response',
        responseFiltersSection: 'Response filters',
        responseFiltersHint: 'Keep only items where every (field = value) matches (string-equality on the source value, e.g. enabled = true). Leave empty to keep all items.',
        responseFilterFieldPlaceholder: 'enabled',
        responseFilterValuePlaceholder: 'true',
        addResponseFilter: 'Add filter',
        // Delete
        deleteConnector: 'Delete connector',
        deleteConfirmation: 'This will delete the [[inbound connector]] and disable its sync [[job]]. Sync run history will be preserved. This cannot be undone.',
        deleteSuccess: '[[Inbound Connector]] deleted successfully.',
        dangerZone: 'Danger zone',
        // Enable/Disable
        enable: 'Enable',
        disable: 'Disable',
        enableDisable: 'Enable / Disable',
        enableSuccess: 'Connector enabled successfully.',
        disableSuccess: 'Connector disabled successfully.',
        // Update
        updateSuccess: 'Connector updated successfully.',
        // Configuration tab
        connectionSection: 'REST Configuration',
        connectionDescription: 'Connection, authentication, and sync settings.',
        baseUrl: 'Base URL',
        itemsEndpoint: 'Items endpoint',
        itemsJsonPath: 'Items JSON Path',
        responseFormat: 'Response format',
        responseFormatJson: 'JSON',
        responseFormatXml: 'XML',
        responseFormatCsv: 'CSV',
        responseFormatText: 'TEXT',
        itemsPathHelpJson: 'JSON path to items array, e.g. data.users',
        itemsPathHelpXml: 'XML element path to items, e.g. users.user',
        itemsPathHelpCsv: '(unused — CSV header row defines fields)',
        itemsPathHelpText: '(unused — body returned as single record)',
        totalCountJsonPath: 'Total Count JSON Path',
        authSection: 'Authentication',
        authType: 'Auth [[type]]',
        authBearer: 'Bearer token',
        authOAuth2: 'OAuth2 Client Credentials',
        authBasic: 'Basic auth',
        authApiKey: 'API Key',
        authMutualTls: 'Mutual TLS',
        authAwsSigV4: 'AWS SigV4',
        authOAuth2SamlBearer: 'OAuth2 SAML Bearer',
        authNone: 'None',
        clientCertSecretRef: 'Client certificate reference',
        clientCertSecretRefPlaceholder: 'vault:certs/inbound/client.crt or env:CLIENT_CERT_PEM',
        clientKeySecretRef: 'Client key reference',
        clientKeySecretRefPlaceholder: 'vault:certs/inbound/client.key or env:CLIENT_KEY_PEM',
        truststoreSecretRef: 'Truststore Reference (optional)',
        truststoreSecretRefHelp: '(empty = JVM default CA bundle)',
        mtlsSectionHelp: 'Mutual TLS uses the operator-supplied client certificate and private key for the TLS handshake. Truststore is optional and defaults to the JVM CA bundle. Do not enable trust-all — server certificates are always validated.',
        awsAccessKeySecretRef: 'AWS Access Key Reference (optional)',
        awsAccessKeySecretRefPlaceholder: 'vault:aws/inbound/access or env:AWS_ACCESS_KEY',
        awsAccessKeySecretRefHelp: 'Empty for [[iam-role]] / IRSA / instance-profile credentials (recommended in production).',
        awsSecretKeySecretRef: 'AWS Secret Key Reference (optional)',
        awsSecretKeySecretRefPlaceholder: 'vault:aws/inbound/secret or env:AWS_SECRET_KEY',
        awsRegion: 'AWS Region',
        awsRegionPlaceholder: 'us-east-1',
        awsService: 'AWS Service',
        awsServicePlaceholder: 'execute-api',
        sigV4SectionHelp: 'AWS SigV4 signs each request with your AWS credentials. For production, leave both keys empty and rely on the [[iam role]] attached to the running pod or EC2 instance.',
        authSignedRequest: '[[Signed Request]]',
        signingAlgorithm: 'Signing algorithm',
        signingKeySecretRef: 'Signing key reference',
        signingKeySecretRefPlaceholder: 'vault:signing/keys/inbound or env:LUMON_TEST_SIGNING_KEY',
        signingHeaderTemplate: 'Signing header template',
        signingHeaderTemplatePlaceholder: 'Authorization: Bearer {{signature}}',
        signingHeaderTemplateHelp: 'Available placeholders: {{timestamp}}, {{nonce}}, {{signature}}. Use the form "Header-Name: value" or just a value (defaults to Authorization).',
        signingHeaderTemplateNewlineError: 'Newline characters are not allowed (HTTP response splitting)',
        signedRequestSectionHelp: '[[Signed-Request]] auth signs each call with HS256, RS256, or HMAC_SHA256. Each connector should use its own signing key — sharing keys across connectors weakens the security model.',
        authNtlmKerberos: 'NTLM/Kerberos',
        kerberosPrincipal: 'Kerberos principal',
        kerberosPrincipalPlaceholder: 'service@REALM.EXAMPLE.COM',
        kerberosKeytabSecretRef: 'Keytab reference',
        kerberosKeytabSecretRefPlaceholder: 'vault:kerberos/keytab or env:KERBEROS_KEYTAB',
        kerberosRealm: 'Kerberos Realm (optional)',
        kerberosRealmHelp: '(empty = derive from principal)',
        kerberosSectionHelp: 'Kerberos / NTLM SSO. Recommended: deploy a Kerberos sidecar instead of using in-process JAAS — see operations guide at docs/architecture/kerberos-deployment.md.',
        authGoogleSaJwt: 'Google Workspace (JWT-bearer)',
        googleSaSectionHelp: 'Google Workspace JWT-bearer flow (RFC 7523). The [[service account]] signs a JWT with its RSA private key and exchanges it at https://oauth2.googleapis.com/token for an access token scoped to the delegated user.',
        googleDelegatedUser: 'Delegated user email',
        googleDelegatedUserPlaceholder: 'iam-sync@your-domain.com',
        googleDelegatedUserHelp: 'The Google Workspace admin account this integration impersonates. Use a dedicated non-human admin (e.g. iam-sync@your-domain.com) — a personal account will stop working if that person leaves.',
        googleSaEmail: '[[Service Account]] Email',
        googleSaEmailPlaceholder: 'sync@my-project.iam.gserviceaccount.com',
        googleSaEmailHelp: 'The service account\'s email address (found in Google Cloud Console under IAM → Service Accounts).',
        googleSaKeySecretRef: '[[Service Account]] Key Secret Ref',
        googleSaKeySecretRefPlaceholder: 'env:GOOGLE_SA_KEY or vault:secret/iam/google-sa#private_key',
        googleSaKeySecretRefHelp: 'Secret reference to the RSA private key (PKCS#8 PEM). The resolved key is never displayed — only the reference name.',
        googleTokenScope: 'OAuth Token Scope',
        googleTokenScopePlaceholder: 'https://www.googleapis.com/auth/admin.directory.user.readonly',
        googleTokenScopeHelp: 'Space-separated OAuth scopes. For read-only user sync: https://www.googleapis.com/auth/admin.directory.user.readonly',
        googleFieldRequiredError: 'Required when Google Workspace (JWT-bearer) is selected.',
        googleEmailFormatError: 'Must be a valid email address.',
        googleSaKeySecretRefPrefixError: 'Must start with vault:, env:, or plain:',
        googleNewlineError: 'Newline characters are not allowed.',
        googleSecretMasked: '••••••',
        authTypeChangeWarning: 'Changing the auth type will clear the previous mode\'s secret references when you save.',
        tokenUrl: 'Token URL',
        clientId: 'Client ID',
        clientSecretRef: 'Client secret reference',
        oauthScope: 'Scope',
        username: 'Username',
        passwordRef: 'Password reference',
        tokenRef: 'Token reference',
        apiKeyHeader: 'API Key Header',
        apiKeyRef: 'API Key Reference',
        paginationSection: 'Pagination',
        paginationStyle: 'Pagination style',
        pageSize: 'Page size',
        paginationOffset: 'Offset',
        paginationPage: 'Page number',
        paginationCursor: 'Cursor',
        paginationNone: 'None',
        timeoutSection: 'Timeouts',
        connectTimeout: 'Connect Timeout (ms)',
        readTimeout: 'Read Timeout (ms)',
        maxRetries: 'Max retries',
        entityOperationsSection: 'Entity operations',
        entityOperationsHelp: 'Select which operations this connector is allowed to perform per entity type.',
        operationCreate: 'Create',
        operationUpdate: 'Update',
        operationDelete: 'Delete',
        safeguardsSection: 'Safeguards',
        safeguardsHelp: 'Safeguards pause the sync when thresholds are exceeded, requiring admin [[approval]] before changes are applied.',
        maxDeletePercent: 'Max Delete %',
        maxDeleteAbsolute: 'Max delete absolute',
        maxUpdatePercent: 'Max Update %',
        maxCreatePercent: 'Max Create %',
        emptySourceProtection: 'Empty source protection',
        safeguardsEnabled: 'Safeguards enabled',
        rehirePolicySection: 'Rehire policy',
        rehirePolicyHelp: 'Controls how the reconciler reacts when an incoming record matches a previously offboarded [[identity]].',
        rehirePolicyLabel: 'Rehire policy',
        rehirePolicyHumanReview: 'Human review required',
        rehirePolicyAutoResurrect: 'Auto-resurrect on match',
        rehirePolicyIgnore: 'Ignore (Skip Rehire Check)',
        rehirePolicyHelper: 'Human review queues a pending candidate for an administrator to approve. Auto-resurrect rehires the matched offboarded [[identity]] automatically, with the connector recorded as the actor of the decision. Ignore skips the rehire check entirely and creates a new [[identity]] — use only for sources that are not authoritative for [[identity]] lifecycle.',
        rehirePolicyIgnoreAuthoritativeWarning: 'This [[target system]] is authoritative for [[identity]] lifecycle. Skipping the rehire check may break the audit link between TERMINATED and rehired [[identities]]. Required for compliance review.',
        editRehirePolicy: 'Edit rehire policy',
        editRehirePolicyDescription: 'Update how the reconciler handles matches against offboarded [[identities]].',
        decidedByConnector: 'by connector {{name}}',
        validationSection: 'Validation',
        validationHelp: 'Controls how strictly imported data is validated. WARN logs violations but imports the record. OFF skips validation entirely.',
        attributeValidation: 'Attribute validation',
        relationshipSchema: 'Relationship schema',
        identifierUniqueness: 'Identifier uniqueness',
        enforcementStrict: 'Strict',
        enforcementWarn: 'Warn',
        enforcementOff: 'Off',
        attributeMappingsSection: 'Attribute mappings',
        attributeMappingsHelp: 'JSON mapping of source fields to IAM [[Attribute Definitions]].',
        invalidJson: 'Invalid JSON',
        scimSection: 'SCIM Configuration',
        scimFilter: 'SCIM Filter',
        enterpriseExtension: 'Enterprise extension',
        testConnection: 'Test connection',
        testConnectionSuccess: 'Connected successfully',
        testConnectionFailed: 'Connection failed',
        testConnectionTime: '{{ms}}ms',
        noConfig: 'Configure the connection to start syncing. Set the base URL and authentication, then test the connection.',
        saveConfig: 'Save configuration',
        // Edit dialogs
        editRestConfig: 'Edit REST Configuration',
        editRestConfigDescription: 'Update connection, authentication, and sync settings.',
        editScimConfig: 'Edit SCIM Configuration',
        editScimConfigDescription: 'Update SCIM filter and enterprise extension settings.',
        editSafeguards: 'Edit safeguards',
        editSafeguardsDescription: 'Update safeguard thresholds and protection settings.',
        editValidation: 'Edit validation',
        editValidationDescription: 'Update validation and batch processing settings.',
        editEntityOperations: 'Edit entity operations',
        editEntityOperationsDescription: 'Update allowed operations per entity type.',
        restConfigSaveSuccess: 'REST configuration saved successfully.',
        scimConfigSaveSuccess: 'SCIM configuration saved successfully.',
        settingsSaveSuccess: 'Settings saved successfully.',
        sectionConnection: 'Connection',
        sectionAuthentication: 'Authentication',
        sectionPagination: 'Pagination',
        sectionTimeouts: 'Timeouts',
        unsavedChangesTitle: 'Unsaved changes',
        unsavedChangesMessage: 'You have unsaved changes. If you leave, your changes will be lost.',
        unsavedChangesLeave: 'Leave',
        unsavedChangesStay: 'Stay',
        queryFilter: 'Query filter',
        queryParams: 'Query params',
        queryParamsPlaceholder: 'enabled=true&emailVerified=true',
        fullUrl: 'Full URL',
        batchSize: 'Batch size',
        secretRefPlaceholder: 'Secret reference (leave blank to keep existing)',
        // Sync Runs tab
        correlationRulesSection: 'Correlation rules',
        correlationRulesHelp: 'Rules that match incoming records to existing IAM entities.',
        correlationRulesEmpty: 'No correlation rules configured. Records will be matched by external ID.',
        // Sync Runs tab
        syncRunsEmpty: 'No sync runs yet. Trigger a sync from the Overview tab.',
        syncRunType: '[[Type]]',
        syncRunStatus: 'Status',
        syncRunStarted: 'Started',
        syncRunDuration: 'Duration',
        syncRunDurationValue: '{{seconds}}s',
        syncRunCreated: 'Created',
        syncRunUpdated: 'Updated',
        syncRunSkipped: 'Skipped',
        syncRunErrored: 'Errored',
        syncRunTriggeredBy: 'Triggered by',
        syncRunErrorMessage: 'Error message',
        syncTypePreview: 'Preview',
        cancelSync: 'Cancel',
        activeRun: 'Active run',
        pausedTooltip: 'This sync is paused. Review the staging records, then approve to apply changes or reject to cancel.',
        // Staging records (issue 145)
        syncRunRecordsTitle: 'Staging records',
        syncRunRecordsFilterAll: 'All actions',
        syncRunRecordsEmpty: 'No staging records yet.',
        syncRecordExternalId: 'External ID',
        syncRecordEntityType: 'Entity [[type]]',
        syncRecordAction: 'Action',
        syncRecordCorrelatedIdentity: 'Correlated [[identity]]',
        syncRecordProcessedAt: 'Processed at',
        syncRecordErrorMessage: 'Error message',
        syncRecordRawData: 'Raw payload',
        syncRecordMappedData: 'Mapped payload',
        syncRecordPayloadCleared: '(payload cleared after successful processing)',
        syncRecordPayloadPreProcessing: '(payload pending — record not yet processed)',
        syncRecordShowPayload: 'Show payload',
        syncRecordHidePayload: 'Hide payload',
        syncRunErrorLogsTitle: 'Per-record [[error log]] entries',
        syncRunErrorLogsHint: 'Each entry is a row in the error_logs table. Use the IDs below to look up the full exception, stack trace, and context.',
        syncRunErrorLogsCountLabel: '{{count}} entries',
        syncRunErrorLogsCountLabel_one: '{{count}} entry',
        syncRunErrorLogsCountLabel_other: '{{count}} entries',
        syncRunErrorLogsEmpty: 'No per-record error_logs entries — every record either applied or was skipped cleanly.',
        syncRunErrorLogIdHeader: '[[Error Log]] ID',
        syncRunErrorLogCreatedAtHeader: 'Logged at',
        // Structured reconciler error codes (issue 338.01 — rehire safety net)
        errorCode: {
            TERMINATED_MATCH_NEEDS_REVIEW: 'Terminated match — review required',
        },
        syncRunApprove: 'Approve',
        syncRunReject: 'Reject',
        syncRunApproveTitle: 'Approve paused sync',
        syncRunApproveBody: 'The staged changes in this sync run will be applied to production. This cannot be undone.',
        syncRunRejectTitle: 'Reject paused sync',
        syncRunRejectBody: 'The sync will be cancelled and no changes will be applied. Staging records are preserved for audit.',
        syncRunApproveSuccess: 'Sync run approved. Staged changes will be applied.',
        syncRunRejectSuccess: 'Sync run rejected. Staging records preserved for audit.',
        // Configuration sub-pages (issue 547.04)
        configNavConnection: 'Connection',
        configNavConnectionDescription: 'Base URL, authentication, response format, pagination, timeouts.',
        configNavReconciliation: 'Reconciliation',
        configNavReconciliationDescription: 'Rehire policy, correlation rules, and attribute mappings.',
        configNavOperations: 'Operations',
        configNavOperationsDescription: 'Entity operations, validation, and safeguards.',
        configNavSelectorAria: 'Configuration sub-page',
        editRehirePolicyInline: 'Edit rehire policy',
        editValidationLevelInline: 'Edit validation level',
        editSafeguardsValueInline: 'Edit safeguard value',
        editEntityOperationInline: 'Toggle entity operation',
        addCorrelationRule: 'Add correlation rule',
        correlationRulesNotConfigured: 'No correlation rules defined. The reconciler will use default external ID matching.',
        connectionEmptyState: 'Configure the connection to start syncing.',
        inlineEditError: 'Could not save: {{message}}',
        inlineEditConflictTitle: 'Update conflict',
        inlineEditConflictDescription: 'The connector was updated by another session. Reloading the latest values.',
    },
    transformParams: {
        title: 'Parameters',
        zone: 'Time zone',
        zonePlaceholder: 'UTC',
        value: 'Value',
        search: 'Search',
        replacement: 'Replacement',
        delimiter: 'Delimiter',
        index: 'Index',
        sources: 'Source fields',
        sourcesPlaceholder: 'firstName, lastName',
        pattern: 'Pattern',
        group: 'Capture group',
        equals: 'Equals',
        then: 'Then',
        elseValue: 'Else',
        requiredField: '{{field}} is required',
        notInteger: '{{field}} must be an integer',
        invalidRegex: 'Invalid regular expression',
        descriptions: {
            toAdGeneralizedTime: 'Formats a date/time as Active Directory GeneralizedTime (yyyyMMddHHmmss.0Z). An optional time zone shifts the value before formatting.',
            toWindowsFiletime: 'Converts a date/time to a Windows FILETIME (100-nanosecond ticks since 1601). An optional time zone shifts the value before converting.',
            prefix: 'Prepends a fixed string to the source value. e.g. value `EMP-` turns `1024` into `EMP-1024`.',
            suffix: 'Appends a fixed string to the source value. e.g. value `@corp.com` turns `jdoe` into `jdoe@corp.com`.',
            replace: 'Replaces every occurrence of one substring with another. e.g. search `_` replacement `-` turns `a_b_c` into `a-b-c`.',
            split: 'Splits the source by a delimiter and returns the piece at a 0-based index. e.g. delimiter `,` index `1` turns `a,b,c` into `b`.',
            join: 'Combines several source fields into one value, separated by a delimiter. e.g. fields `firstName, lastName` with a space delimiter give `Jane Doe`.',
            regexExtract: 'Extracts the first match of a regular expression, optionally a capture group. e.g. pattern `(\\d+)` on `id-42` gives `42`.',
            conditional: 'If the source equals a value, outputs one result, otherwise another. e.g. equals `active` then `1` else `0`.',
            lookupOrgUnit: 'Resolves an org-unit code to its display name during provisioning.',
            resolveManager: 'Resolves a manager reference to the manager’s identifier on the [[target system]].',
            toDate: 'Parses the source as a date and reformats it as a date value.',
            toUppercase: 'Converts the source value to upper case. e.g. `jdoe` becomes `JDOE`.',
            toLowercase: 'Converts the source value to lower case. e.g. `JDOE` becomes `jdoe`.',
        },
    },
    inboundAttributeMappings: {
        title: 'Attribute mappings',
        description: 'Define how source system fields map to IAM entity attributes during inbound sync.',
        descriptionDetail: 'Each row maps a source field path (e.g. name.givenName) to an IAM attribute, entity type, and optional transform.',
        source: 'Source',
        sourceHint: 'External field path (e.g. name.givenName, emails[type=work])',
        target: 'Target',
        targetHint: 'IAM attribute name',
        type: '[[Type]]',
        typeDirect: 'Direct',
        typeComputed: 'Computed',
        typeStatic: 'Static',
        targetEntityType: 'Entity [[type]]',
        entityTypeParty: '[[Party]]',
        entityTypeIdentity: '[[Identity]]',
        entityTypeResource: '[[Resource]]',
        entityTypeFunctionGroup: '[[Function Group]]',
        identifierType: 'Identifier [[type]]',
        identifierTypePlaceholder: 'e.g. EMAIL',
        transform: 'Transform',
        transformNone: 'None',
        transformLookupOrgUnit: 'Lookup org unit',
        transformResolveManager: 'Resolve manager',
        transformToDate: 'To date',
        transformToUppercase: 'To uppercase',
        transformToLowercase: 'To lowercase',
        transformToAdGeneralizedTime: 'To AD GeneralizedTime',
        transformToWindowsFiletime: 'To Windows FILETIME',
        transformPrefix: 'Add prefix',
        transformSuffix: 'Add suffix',
        transformReplace: 'Replace',
        transformSplit: 'Split',
        transformJoin: 'Join',
        transformRegexExtract: 'Regex extract',
        transformConditional: 'Conditional',
        required: 'Required',
        addMappingAction: '+ Add',
        confirmDelete: 'Remove this mapping?',
        noMappings: 'No attribute mappings configured',
        noMappingsWarning: '[[Identity]] attributes will not be imported until attribute mappings are configured.',
        sourceRequired: 'Source is required',
        sourceExceedsMaxLength: 'Source exceeds 500 characters',
        targetRequired: 'Target is required',
        targetExceedsMaxLength: 'Target exceeds 100 characters',
        targetNotInSchema: 'Not in {{typeCode}} attribute schema — value will be silently dropped on sync',
        createPartyToggle: 'Create [[party]] ({{typeCode}})',
        createPartyToggleHeader: 'Create [[party]]',
        createPartyHint: 'Materialise a [[party]] row for each imported record.',
        createIdentityToggle: 'Create [[identity]] ({{typeCode}})',
        createIdentityToggleHeader: 'Create [[identity]]',
        createIdentityHint: 'Materialise an [[identity]] row linked to the [[party]].',
        createAccountToggle: 'Create account',
        createAccountHint: 'Materialise an Account row on this connector’s [[target system]], linked to the [[identity]]. External ID comes from the source record’s id field.',
        addPartyMapping: 'Add [[party]] Mapping',
        addIdentityAttribute: 'Add [[identity]] Attribute',
        addIdentityIdentifier: 'Add [[identity]] Identifier',
        noPartyMappings: 'No [[party]] mappings yet.',
        noIdentityMappings: 'No [[identity]] mappings yet.',
        externalIdFieldLabel: 'External ID Source Field',
        externalIdFieldPlaceholder: 'id',
        externalIdFieldHint: 'Source field whose value becomes the staged record\'s external ID and the account\'s external ID. Defaults to "id".',
        lifecycleSourceFieldLabel: 'Lifecycle source field',
        lifecycleSourceFieldPlaceholder: 'enabled',
        lifecycleSourceFieldHint: 'Source field whose value drives Account ENABLED / DISABLED. [[identity]] is auto-suspended when zero ENABLED accounts remain across all [[target systems]]. Leave blank to skip.',
        lifecycleEnabledValueLabel: 'Lifecycle enabled values',
        lifecycleEnabledValuePlaceholder: 'true,1,ACTIVE,ENABLED',
        lifecycleEnabledValueHint: 'Comma-separated list of source values that mean ENABLED — case-insensitive string match. e.g. "true" for boolean, "ACTIVE" for status fields, "1" for numeric. Any match → ENABLED, anything else → DISABLED.',
        duplicateTarget: 'Duplicate target + entity type combination: {{name}}',
        invalidTemplateSyntax: 'Invalid template syntax (unclosed or nested braces)',
        maxMappingsTooltip: 'Maximum 50 attribute mappings reached',
        saved: 'Attribute mappings saved',
        cleared: 'Attribute mappings cleared',
        sourceHintComputed: '{firstName} {lastName}',
        sourceHintStatic: 'Literal value',
    },
    valueLists: {
        pageTitle: '[[Value Lists]] | Admin',
        title: '[[Value Lists]]',
        subtitle: 'Manage custom [[value lists]] for [[attribute definitions]]',
        detailPageTitle: '[[Value List]] | Admin',
        columns: {
            name: 'Name',
            displayName: 'Display name',
            description: 'Description',
            entryCount: 'Entries',
            active: 'Active',
        },
        entriesTable: {
            title: 'Entries',
            code: 'Code',
            label: 'Label',
            description: 'Description',
            sortOrder: 'Sort order',
            active: 'Active',
            empty: 'No entries yet. Add the first entry.',
            dragToReorder: 'Drag to reorder',
        },
        actions: {
            createList: 'New [[value list]]',
            editList: 'Edit list',
            deleteList: 'Delete list',
            addEntry: 'Add entry',
            editEntry: 'Edit entry',
            deleteEntry: 'Delete entry',
        },
        form: {
            createTitle: 'Create [[value list]]',
            createDescription: 'Create a new custom [[value list]] for use in [[attribute definitions]].',
            editTitle: 'Edit [[value list]]',
            editDescription: 'Update the [[value list]] metadata.',
            namePlaceholder: 'e.g. clearance_levels',
            nameHelp: 'Lowercase letters, numbers, underscores only. Cannot be changed after creation.',
            displayNamePlaceholder: 'e.g. Clearance Levels',
            descriptionPlaceholder: 'Optional description',
            entryCodePlaceholder: 'e.g. HIGH',
            entryCodeHelp: 'Uppercase letters, numbers, underscores only.',
            entryLabelPlaceholder: 'e.g. High',
            entryDescriptionPlaceholder: 'Optional description',
            addEntryTitle: 'Add entry',
            addEntryDescription: 'Add a new entry to this [[value list]].',
            editEntryTitle: 'Edit entry',
            editEntryDescription: 'Update the value of this entry.',
        },
        messages: {
            createSuccess: '[[Value List]] created successfully.',
            updateSuccess: '[[Value List]] updated successfully.',
            deleteSuccess: '[[Value List]] deleted.',
            addEntrySuccess: 'Entry added successfully.',
            updateEntrySuccess: 'Entry updated successfully.',
            deleteEntrySuccess: 'Entry deleted.',
            reorderSuccess: 'Entries reordered.',
            confirmDeleteList: 'Are you sure you want to delete this [[value list]]? This action cannot be undone.',
            confirmDeleteEntry: 'Are you sure you want to delete this entry? This action cannot be undone.',
        },
        noLists: 'No [[value lists]] found.',
        selectList: 'Select a [[value list]]',
        customListLabel: 'Custom list',
    },
    requestInspector: {
        pageTitle: '[[Request Inspector]]',
        title: '[[Request Inspector]]',
        description: 'Inspect HTTP traces and session timelines',
        searchPlaceholder: 'Search by operation name or HTTP URL (min. 3 characters)...',
        minQHint: '[[Type]] at least 3 characters to search.',
        searchScopeHint: 'Search matches operation names and HTTP URLs only — diagnostic columns (SQL fingerprints, error messages, trace IDs) are intentionally excluded.',
        filterSession: 'Session ID...',
        filterUser: 'User ID...',
        filterErrorsOnly: 'Errors only',
        filterSlowerThan: 'Slower than (ms)...',
        allSessions: 'All sessions',
        clearFilters: 'Clear filters',
        refresh: 'Refresh',
        writerOffline: 'Span writer is offline — new spans may not be recorded.',
        columns: {
            sessionId: 'Session',
            spanCount: 'Spans',
            errorCount: 'Errors',
            totalDuration: 'Duration',
            earliestStartedAt: 'Started',
            latestStartedAt: 'Last span',
            e2eTestClass: 'E2E Class',
        },
        noSessions: 'No sessions recorded yet.',
        noSessionsMatch: 'No sessions match the current filters.',
        detail: {
            title: 'Session detail',
            back: '[[Request Inspector]]',
            sessionId: 'Session ID',
            spanCount: 'Spans',
            errorCount: 'Errors',
            totalDuration: 'Total duration',
            startedAt: 'Started',
            endedAt: 'Ended',
            e2eRunId: 'E2E Run ID',
            e2eTestClass: 'E2E Test Class',
            e2eTestMethod: 'E2E Test Method',
            downloadTrace: 'Download Trace JSON',
            requestsTitle: '[[HTTP Requests]]',
            noRequests: 'No [[http requests]] recorded in this session.',
            columns: {
                method: 'Method',
                url: 'URL',
                status: 'Status',
                duration: 'Duration',
                sqlCount: 'SQL Queries',
                sqlTime: 'SQL Time',
            },
        },
        requestDetail: {
            title: '[[HTTP Request]] Detail',
            back: 'Session',
            noSpans: 'No spans found for this [[http request]].',
        },
        waterfall: {
            title: 'Span timeline',
            colSpan: 'Span',
            colDuration: 'Duration',
            colStatus: 'Status',
            sortByTime: 'By time',
            sortByDuration: 'By duration',
            filterAll: 'All',
        },
        spanDetail: {
            title: 'Span detail',
            tabOverview: 'Overview',
            tabHttp: 'HTTP',
            tabSql: 'SQL',
            tabAttributes: 'Attributes',
            tabError: 'Error',
            spanId: 'Span ID',
            traceId: 'Trace ID',
            parentSpanId: 'Parent Span ID',
            kind: 'Kind',
            operationName: 'Operation',
            status: 'Status',
            startedAt: 'Started',
            endedAt: 'Ended',
            durationMs: 'Duration',
            sessionId: 'Session ID',
            actionId: 'Action ID',
            correlationId: 'Correlation ID',
            authUserId: 'Auth User ID',
            identityId: '[[Identity]] ID',
            httpMethod: 'Method',
            httpUrl: 'URL',
            httpStatusCode: 'HTTP Status',
            httpResponseBytes: 'Response size',
            sqlFingerprint: 'Query key',
            sqlStatement: 'SQL Statement',
            sqlRowsAffected: 'Rows affected',
            sqlPoolWaitMs: 'Pool wait',
            errorCode: 'Error code',
            errorMessage: 'Error message',
            errorLogId: '[[Error Log]] ID',
            viewErrorLog: 'View [[error log]]',
        },
    },
    help: {
        toggleHelp: 'Toggle help',
        learnMore: 'Learn more',
    },
    associationEditor: {
        searchPlaceholder: 'Search to add...',
        emptyMessage: 'No items selected.',
        removeAriaLabel: 'Remove {{label}}',
        conflictToast: 'This record was modified by another user. The list has been refreshed with the latest data.',
    },
    scriptConnector: {
        title: 'Script configuration',
        description: 'Groovy script configuration for custom provisioning operations.',
        baseUrl: 'Base URL',
        baseUrlPlaceholder: 'https://api.example.com',
        apiKeyHeaderPlaceholder: 'X-Api-Key',
        authType: 'Authentication [[type]]',
        connectTimeoutMs: 'Connect Timeout (ms)',
        readTimeoutMs: 'Read Timeout (ms)',
        operations: 'Operations',
        script: 'Connector script',
        scriptDescription: 'Single Groovy blob with all operation methods. Shared helpers can be defined at the top and called from any method.',
        enabled: 'Enabled',
        createConfig: 'Configure script connector',
        editConfig: 'Edit script configuration',
        validateScript: 'Validate script',
        validationSuccess: 'Script is valid.',
        validationError: 'Script validation failed.',
        validationWarning: '{{count}} warning(s)',
        errorAtLine: 'Line {{line}}, col {{column}}: {{message}}',
        noBaseUrl: 'No base URL',
        configured: 'Configured',
        notConfigured: 'Not configured',
        badgeSupported: 'Method present',
        badgeUnsupported: 'Method missing',
        badgeDisabled: 'Disabled',
        unsavedChanges: 'You have unsaved changes. Leave anyway?',
        testConnection: 'Test connection',
        testConnectionTesting: 'Testing...',
        testConnectionSuccess: 'Connected',
        testConnectionFailure: 'Connection failed',
        noConfig: 'No script configuration. Click "Configure Script Connector" to set up scripts for this connector.',
        noConfigFound: 'No script configuration found. Configure the connector first.',
        createSuccess: 'Script configuration created successfully.',
        updateSuccess: 'Script configuration updated successfully.',
        createDialogTitle: 'Create script configuration',
        createDialogDescription: 'Configure authentication, script, and timeouts for this script connector.',
        editDialogTitle: 'Edit script configuration',
        editDialogDescription: 'Update authentication, script, and timeouts for this script connector.',
        sectionAuthentication: 'Authentication',
        sectionBaseUrl: 'Base URL',
        sectionScript: 'Connector script',
        sectionOperations: 'Operations',
        sectionTimeouts: 'Timeouts',
        typeScript: 'Script',
        timeoutValidation: 'Must be between {{min}} and {{max}} ms',
        operationLabels: {
            createAccount: 'Create account',
            updateAccount: 'Update account',
            disableAccount: 'Disable account',
            enableAccount: 'Enable account',
            deleteAccount: 'Delete account',
            grant: 'Grant',
            revoke: 'Revoke',
            testConnection: 'Test connection',
            fullSync: 'Full sync',
            createOp: 'Create',
            updateOp: 'Update',
            deleteOp: 'Delete',
            queryOp: 'Query',
        },
    },
    unifiedSearch: {
        bar: {
            placeholder: 'Search...',
            clearSearch: 'Clear search text',
            openFilters: 'Open filter panel',
            activeFiltersIndicator: 'Active filters',
        },
        panel: {
            title: 'Filters',
            apply: 'Apply',
            clearAll: 'Clear all',
            notSet: 'Not set',
            any: 'Any',
            yes: 'Yes',
            no: 'No',
            from: 'From',
            to: 'To',
            pickDate: 'Pick a date',
            pickDateTime: 'Pick date and time',
            time: 'Time',
            // UUID filter placeholder — entity-picker combobox is hooked up
            // per-page in the B-phase migrations; until then the panel accepts
            // a raw UUID (SEC-06 graceful fallback).
            uuidPlaceholder: 'Enter UUID (entity picker pending)',
        },
        calendar: {
            prevMonth: 'Previous month',
            nextMonth: 'Next month',
            prevYear: 'Previous year',
            nextYear: 'Next year',
            // Issue 342.26 — year-quick-jump UI on the calendar header.
            pickYear: 'Pick year',
            backToDays: 'Back to month grid',
            prevDecade: 'Previous decade',
            nextDecade: 'Next decade',
            weekdayHeader: 'Calendar days',
            weekdayShort: {
                sun: 'Sun',
                mon: 'Mon',
                tue: 'Tue',
                wed: 'Wed',
                thu: 'Thu',
                fri: 'Fri',
                sat: 'Sat',
            },
        },
        chip: {
            removeLabel: 'Remove filter: {{name}} {{values}}',
            moreSuffix: '+{{count}} more',
        },
        announce: {
            filterApplied: 'Filters applied: {{filters}}',
            noFiltersActive: 'no filters active',
            filterRemoved: 'Filter removed: {{label}}',
            filtersCleared: 'All filters cleared',
            searchCleared: 'Search cleared',
            search: 'Search: {{query}}',
            resultsCount: '{{count}} result',
            resultsCount_other: '{{count}} results',
            noResults: 'No results',
            valueSelected: '{{section}}: {{value}} selected',
            valueDeselected: '{{section}}: {{value}} deselected',
        },
        empty: {
            withFilters: 'No results match your current filters.',
            clearAllFilters: 'Clear all filters',
        },
        error: {
            toast: 'Search failed. Please try again.',
        },
    },
    authority: {
        ownedBy: 'Owned by {{systemName}}',
        unclaimed: 'Unclaimed',
        historical: '(historical)',
        editDisabledTooltip: 'Owned by {{systemName}} — release authority first to edit manually',
        actionsMenu: 'Authority actions',
        release: 'Release authority',
        releaseTitle: 'Release authority on {{attributeName}}?',
        releaseBody: 'Releasing authority will allow any source to write to {{attributeName}} on this record. The next inbound sync that touches this attribute will claim authority automatically. Currently owned by {{systemName}}.',
        releaseConfirm: 'Release',
        releaseSuccess: 'Authority released',
        releaseError: 'Could not release authority. Try again.',
        transfer: 'Transfer authority...',
        transferTitle: 'Transfer authority on {{attributeName}}',
        transferBody: 'Select the system that should own {{attributeName}} on this record. Only systems currently linked as sources are available. Writes from other systems will continue to be rejected.',
        transferTargetLabel: '[[Target System]]',
        transferTargetPlaceholder: 'Select a [[target system]]',
        transferConfirm: 'Transfer',
        transferSuccess: 'Authority transferred to {{systemName}}',
        transferError: 'Could not transfer authority. Try again.',
        transferNoEligibleSources: 'No active source rows for this record — link a source to transfer authority.',
        violations: {
            title: 'Authority violations',
            count: '{{count}} attribute writes skipped — owned by another system',
            truncated: 'Only the first 100 violations are shown. To review all violations, filter attributes by authority on the affected entities.',
            rowLabel: '{{entityType}} {{entityName}} — {{attributeName}} — owned by {{ownerSystem}}, attempted by {{syncSystem}}',
            viewEntity: 'View {{entityType}}',
        },
    },
    owners: {
        title: 'Owners',
        empty: 'No owners assigned.',
        addOwner: 'Add owner',
        removeOwner: 'Remove',
        removeConfirm: 'Remove {{partyName}} as owner?',
        responsibility: 'Responsibility',
        validFrom: 'Valid from',
        validTo: 'Valid to',
        party: '[[Party]]',
        searchParty: 'Search for a [[party]]…',
        addOwnerTitle: 'Add owner',
        addOwnerDescription: 'Assign a [[party]] as owner of this entity.',
        addedSuccess: 'Owner added.',
        removedSuccess: 'Owner removed.',
        loading: 'Loading owners…',
        responsibilityLookupMissing: 'Responsibility configuration is missing for this entity type. Owner assignment is disabled until an administrator seeds the responsibility lookup.',
    },
    sources: {
        title: 'Sources',
        empty: 'No external sources',
        emptySubtext: 'This record was created manually and is not synced from any external system.',
        loadError: 'Could not load sources. Try refreshing the page.',
        firstSeen: 'First linked {{date}}',
        lastSeen: 'Synced {{relativeTime}}',
        actionsMenu: 'Source actions',
        copyExternalId: 'Copy external ID',
        externalIdCopied: 'External ID copied to clipboard',
        externalIdCopyFailed: 'Could not copy external ID',
        detach: 'Detach source',
        detachTitle: 'Detach source?',
        detachBody: 'Removing {{systemName}} as a source will unlink external ID {{externalId}} from this record. The next sync from {{systemName}} will treat this record as new and create a fresh source link. If correlation fails, a duplicate record may be created. This action cannot be undone.',
        detachConfirm: 'Detach',
        detachSuccess: 'Source detached',
        detachSuccessWithCount: 'Source detached, {{count}} attributes released',
        detachError: 'Could not detach source. Try again.',
        releaseAll: 'Release all attributes owned by this system',
        releaseAllTitle: 'Release all attributes owned by {{systemName}}?',
        releaseAllBody: 'This will release authority on {{count}} attributes across this record. Each attribute will become editable from any source, and the next inbound sync that writes to each attribute will claim authority automatically.',
        releaseAllConfirm: 'Release {{count}} attributes',
        releaseAllSuccess: '{{count}} attributes released',
        releaseAllError: 'Could not release attributes. Try again.',
    },
    rehireReview: {
        title: 'Rehire review',
        pageTitle: 'Rehire Review | Admin',
        subtitle: 'Candidates where an inbound sync matched a TERMINATED [[Identity]]',
        list: {
            title: 'Rehire review queue',
        },
        columns: {
            matchedIdentity: 'Matched [[identity]]',
            priorEntryDate: 'Prior entry date',
            priorExitDate: 'Prior exit date',
            sourceConnector: 'Source connector',
            syncRun: 'Sync run',
            newEntryDate: 'New entry date',
            detectedAt: 'Detected at',
            status: 'Status',
            decidedBy: 'Decided by',
        },
        decidedByConnector: 'by connector {{name}}',
        status: {
            pending: 'Pending',
            resurrected: 'Resurrected',
            createdNew: 'Created new',
            rejected: 'Rejected',
        },
        actorType: {
            user: 'User',
            connector: 'Connector',
        },
        filters: {
            status: 'Status',
            allStatuses: 'All statuses',
            connector: 'Connector',
            allConnectors: 'All connectors',
            from: 'Detected from',
            to: 'Detected to',
        },
        emptyState: {
            title: 'No rehire review candidates',
            description: 'There are no candidates matching the current filters. Incoming syncs that match a TERMINATED [[Identity]] will appear here.',
        },
        detail: {
            pageTitle: 'Rehire Review Candidate | Admin',
            title: 'Review candidate',
            backToList: 'Back to queue',
            matchedCard: {
                title: 'Matched [[identity]]',
                priorName: 'Prior display name',
                employeeNumber: 'Employee number',
                entryDate: 'Entry date',
                exitDate: 'Exit date',
                terminationReason: 'Last termination reason',
                lifecycleState: 'Lifecycle state',
            },
            incomingCard: {
                title: 'Incoming record',
                newEntryDate: 'New entry date',
                sourceConnector: 'Source connector',
                sourceSyncRun: 'Source sync run',
                detectedAt: 'Detected at',
                attributesSnapshot: 'Mapped attributes',
            },
            diff: {
                title: 'Attribute diff',
                description: 'Differences between the stored [[identity]] and the incoming record.',
                attribute: 'Attribute',
                oldValue: 'Stored value',
                newValue: 'Incoming value',
                noChanges: 'No attribute differences detected.',
            },
            actions: {
                title: 'Decision',
                resurrect: 'Resurrect',
                createNew: 'Create new',
                reject: 'Reject',
            },
            decisionInfo: {
                decidedBy: 'Decided by',
                decidedAt: 'Decided at',
                comment: 'Decision comment',
            },
        },
        dialogs: {
            resurrect: {
                title: 'Resurrect [[identity]]',
                description: 'Reactivate the matched [[identity]] with the new entry date from the incoming record.',
                reasonLabel: 'Reason',
                reasonPlaceholder: 'Why are you resurrecting this [[identity]]?',
                submit: 'Resurrect',
            },
            createNew: {
                title: 'Create New [[identity]]',
                description: 'Create a separate new [[identity]] for the incoming record. The matched [[identity]] stays TERMINATED.',
                reasonLabel: 'Reason',
                reasonPlaceholder: 'Why are you creating a new [[identity]]?',
                submit: 'Create new',
            },
            reject: {
                title: 'Reject match',
                description: 'Dismiss this candidate. No change to the matched [[identity]] or the incoming record.',
                reasonLabel: 'Reason',
                reasonPlaceholder: 'Why are you rejecting this match?',
                submit: 'Reject',
            },
            reasonRequired: 'A reason is required.',
            entryDateLabel: 'New entry date',
            entryDateHint: 'Must be today or in the future, within 2 years.',
            entryDateRequired: 'A new entry date is required.',
            entryDateInvalid: 'New entry date must be today or in the future, within 2 years.',
        },
        messages: {
            resurrectSuccess: '[[Identity]] resurrected.',
            resurrectSuccessLink: 'Open [[identity]]',
            createNewSuccess: 'New [[identity]] created.',
            createNewSuccessLink: 'Open new [[identity]]',
            rejectSuccess: 'Candidate rejected.',
            readOnly: 'You have read-only access to the rehire review queue.',
        },
        picker: {
            title: 'Previously held by {{name}}',
            description: 'Select [[access profiles]] to re-[[Request]] for this [[identity]]. Each [[request]] runs through normal [[approval policies]].',
            selectionCount: '{{count}} selected',
            selectionCount_one: '{{count}} selected',
            selectionCount_other: '{{count}} selected',
            createRequests: 'Create [[access requests]]',
            requestsCreated: '{{count}} [[access request]](s) submitted.',
            requestsCreated_one: '{{count}} [[access request]] submitted.',
            requestsCreated_other: '{{count}} [[access requests]] submitted.',
            viewRequests: 'View My [[requests]]',
            defaultJustification: 'Restore previous access for rehired [[identity]]: {{name}}',
            requestsFailed: 'Failed to create [[access requests]].',
        },
    },
    serviceAccounts: {
        pageTitle: '[[Service Accounts]]',
        pageDescription: 'Non-human authentication [[identities]] used by automation, scripts, and integrations to call this app via API keys.',
        listTitle: '[[Service Accounts]]',
        listCount: '{{count}} [[service account]]',
        listCount_other: '{{count}} [[service accounts]]',
        matchingFilters: 'matching filters',
        createButton: 'Create [[service account]]',
        createTitle: 'Create [[service account]]',
        editButton: 'Edit',
        editTitle: 'Edit [[service account]]',
        deactivateButton: 'Deactivate',
        reactivateButton: 'Reactivate',
        actions: 'Actions',
        nameLabel: 'Name',
        descriptionLabel: 'Description',
        descriptionPlaceholder: 'Optional description (max 500 characters)',
        nameRequired: 'Name is required.',
        nameTooLong: 'Name must be 100 characters or fewer.',
        descriptionTooLong: 'Description must be 500 characters or fewer.',
        duplicateNameError: 'A [[Service Account]] with this name already exists.',
        createSuccess: '[[Service Account]] created.',
        editSuccess: '[[Service Account]] updated.',
        deactivateSuccess: '[[Service Account]] deactivated.',
        reactivateSuccess: '[[Service Account]] reactivated.',
        deactivateTitle: 'Deactivate this [[service account]]?',
        deactivateBody: 'Deactivating this [[service account]] will immediately revoke all its active API keys. Automation using those keys will fail.',
        deactivateConfirm: 'Deactivate',
        emptyTitle: 'No [[service accounts]] yet',
        emptyDescription: 'Create one to enable programmatic API access.',
        emptyMatching: 'No [[service accounts]] match the current filters.',
        clearFilters: 'Clear filters',
        filterByName: 'Filter by name',
        filterByStatus: 'Filter by status',
        filterStatusAll: 'All',
        filterStatusActive: 'Active only',
        filterStatusInactive: 'Inactive only',
        columns: {
            name: 'Name',
            activeKeys: 'Active keys',
            status: 'Status',
            created: 'Created',
            createdBy: 'Created by',
            description: 'Description',
        },
        statusActive: 'Active',
        statusInactive: 'Inactive',
        overview: 'Overview',
        roles: '[[Roles]]',
        rolesDescription: 'Authorization [[roles]] assigned to this [[service account]].',
        rolesEmpty: 'No [[roles]] assigned.',
        assignRoleButton: 'Assign [[role]]',
        assignRoleTitle: 'Assign [[role]]',
        assignRoleDescription: 'Choose a [[role]] to assign to this [[service account]].',
        assignButton: 'Assign',
        roleLabel: '[[Role]]',
        selectRolePlaceholder: 'Search [[roles]]…',
        noRolesFound: 'No [[roles]] found.',
        roleAlreadyAssignedError: 'This [[role]] is already assigned to the [[service account]].',
        removeRoleAction: 'Remove',
        removeRoleTitle: 'Remove [[role]]?',
        removeRoleBody: 'Remove [[role]] "{{role}}" from "{{serviceAccount}}"?',
        removeRoleConfirm: 'Remove',
        assignRoleSuccess: '[[Role]] assigned.',
        removeRoleSuccess: '[[Role]] removed.',
        roleColumns: {
            name: '[[Role]]',
            description: 'Description',
            assignedBy: 'Assigned by',
            assignedAt: 'Assigned at',
            actions: 'Actions',
        },
    },
    apiKeys: {
        cardTitle: 'API Keys',
        cardCount: '{{count}} key',
        cardCount_other: '{{count}} keys',
        emptyTitle: 'No API keys yet',
        emptyDescription: 'Mint one to allow programmatic access.',
        mintButton: 'Mint API Key',
        revokeButton: 'Revoke',
        defaultRateLimit: 'Default ({{value}})',
        never: 'Never',
        columns: {
            name: 'Name',
            prefix: 'Prefix',
            lastUsed: 'Last used',
            rateLimit: 'Rate limit',
            status: 'Status',
            actions: 'Actions',
        },
        status: {
            active: 'Active',
            expired: 'Expired',
            revoked: 'Revoked',
            inactive: 'Inactive',
        },
        mintDialog: {
            title: 'Mint API Key',
            description: 'Configure the new key. The raw key value is shown exactly once after minting — copy it before closing.',
            nameLabel: 'Name',
            namePlaceholder: 'e.g. ci-deploy-bot',
            expiryLabel: 'Expiry date',
            expiryHelp: 'Default: today + 365 days. Past dates are rejected.',
            rateLimitLabel: 'Rate limit ([[Requests]] per minute)',
            rateLimitPlaceholder: 'Default ({{value}})',
            rateLimitHelp: 'Optional. Leave blank to use the global default.',
            submit: 'Mint key',
            submitting: 'Minting…',
            disclosurePanelTitle: 'API key — save it now',
            warningBanner: 'This is the only time this key will be shown. Save it now in a secure location — your password manager, vault, or CI secret store. We cannot retrieve or display this key again. If you lose it, revoke it and mint a new one.',
            keyLabel: 'API key',
            copyButton: 'Copy',
            copyDone: 'Copied',
            copyDisabledMessage: 'Clipboard access requires HTTPS. Please copy the key manually.',
            closeButton: 'I’ve saved it — close',
            closeConfirm: 'You haven’t saved the key yet. Close anyway?',
            nameRequired: 'Name is required.',
            nameTooLong: 'Name must be 100 characters or fewer.',
            expiresAtInPast: 'Expiry date must be in the future.',
            rateLimitInvalid: 'Rate limit must be a positive integer.',
            inactiveError: 'This [[service account]] is inactive. Reactivate it before minting keys.',
        },
        revokeDialog: {
            title: 'Revoke key ‘{{name}}’?',
            body: 'Calls using this key will fail immediately. This cannot be undone.',
            confirm: 'Revoke key',
            successToast: 'Key revoked. Calls using this key will fail immediately.',
        },
    },
    timeRange: {
        invalidUrlParam: 'Time range URL parameter is invalid: {{detail}}. The bad parameter was ignored.',
    },
    holdingStatus: {
        none: 'not held',
        directBlocking: 'already held',
        indirectRule: 'via [[auto-assign rule]]',
        indirectImport: 'via inbound import',
        indirectFg: 'via [[function group]]',
        indirectMixed: 'via multiple sources',
        tooltipOriginsHeading: 'held via:',
        tooltipBlockingHint: 'this grant is durable — a fresh submission is redundant',
        tooltipIndirectHint: 'this grant is ephemeral — a fresh submission creates a durable copy',
    },
    escalation: {
        timeline: {
            title: 'Escalation timeline',
            empty: 'No escalation events yet.',
            currentLevel: 'Current level',
            nextDeadline: 'Next deadline',
            platformOwner: 'IAM Platform Owner',
            unresolvableManager: 'Manager unresolvable — skipped',
            unknownRecipient: 'Unknown recipient',
            levels: {
                NONE: 'Not escalated',
                REMINDED: 'Reminded',
                FINAL_REMINDED: 'Final reminder',
                ESCALATED_TO_MANAGER: 'Escalated to manager',
                ESCALATED_TO_PLATFORM_OWNER: 'Escalated to IAM Platform Owner',
                CHAIN_CLOSED: 'Chain closed',
            },
            eventTypes: {
                REMINDED: 'Reminder sent',
                FINAL_REMINDED: 'Final reminder sent',
                ESCALATED_TO_MANAGER: 'Escalated to manager',
                ESCALATED_TO_PLATFORM_OWNER: 'Escalated to IAM Platform Owner',
                CHAIN_CLOSED: 'Chain closed',
            },
        },
        thresholds: {
            pageTitle: 'Escalation thresholds',
            title: 'Escalation thresholds',
            description: 'Configurable escalation cadence and recipients per [[request]] type and risk level.',
            count: '{{count}} threshold',
            count_other: '{{count}} thresholds',
            defaultRiskLabel: 'Default',
            columns: {
                requestType: '[[Request]] type',
                riskLevel: 'Risk level',
                reminderDays: 'Reminder days',
                finalReminderDays: 'Final reminder days',
                managerDays: 'Manager days',
                platformOwnerDays: 'Platform owner days',
                managerTarget: 'Manager target',
                platformOwner: 'IAM Platform Owner',
                active: 'Active',
                activeSnapshots: 'Active references',
                actions: 'Actions',
            },
            actions: {
                edit: 'Edit threshold',
            },
            edit: {
                title: 'Edit escalation threshold',
                description: 'Editing affects only newly activated steps. In-flight steps stay frozen on the values captured at activation.',
                reminderDays: 'Reminder after (days)',
                finalReminderDays: 'Final reminder after (days)',
                managerDays: 'Escalate to manager after (days)',
                platformOwnerDays: 'Escalate to IAM Platform Owner after (days)',
                managerTarget: 'Manager target',
                platformOwner: 'IAM Platform Owner',
                platformOwnerPlaceholder: 'Search [[identities]]…',
                active: 'Active',
                save: 'Save changes',
                cancel: 'Cancel',
                saveSuccess: 'Threshold updated.',
            },
            validation: {
                positive: 'Each day value must be greater than 0.',
                monotonic: 'Days must be strictly increasing: reminder < final reminder < manager < platform owner.',
                platformOwnerRequired: 'IAM Platform Owner is required when the threshold is active.',
            },
            managerTarget: {
                APPROVER_MANAGER: 'Approver’s manager',
                OBJECT_OWNER_MANAGER: 'Object owner’s manager',
            },
        },
    },
} as const

export default translation
